/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/admin/v1/accounts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * ListLedgerAccounts
         * @description Lists the distinct ledger accounts, most recent activity first.
         */
        get: operations["LedgerAdminService_ListLedgerAccounts"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/accounts/{accountId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetLedgerAccount
         * @description Returns one ledger account's activity summary and confirmed balances.
         */
        get: operations["LedgerAdminService_GetLedgerAccount"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/announcements": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * AdminListAnnouncements
         * @description Lists in-app announcements.
         */
        get: operations["NotificationsAdminService_AdminListAnnouncements"];
        put?: never;
        /**
         * AdminCreateAnnouncement
         * @description Creates an in-app announcement.
         */
        post: operations["NotificationsAdminService_AdminCreateAnnouncement"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/announcements/{announcementId}/dismissals": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * AdminGetAnnouncementDismissals
         * @description Reports how many users dismissed an announcement.
         */
        get: operations["NotificationsAdminService_AdminGetAnnouncementDismissals"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/announcements/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * AdminUpdateAnnouncement
         * @description Updates an in-app announcement.
         */
        put: operations["NotificationsAdminService_AdminUpdateAnnouncement"];
        post?: never;
        /**
         * AdminDeleteAnnouncement
         * @description Deletes an in-app announcement.
         */
        delete: operations["NotificationsAdminService_AdminDeleteAnnouncement"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/conversation-flags": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * AdminListConversationFlags
         * @description AdminListConversationFlags lists conversation flags newest first,
         *      optionally narrowed to one review state and one conversation. Each flag
         *      carries its conversation's owner and title and the flagged message.
         */
        get: operations["ConversationsAdminService_AdminListConversationFlags"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/conversation-flags/{flagId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * AdminUpdateConversationFlag
         * @description AdminUpdateConversationFlag moves a conversation flag through review and
         *      records what the review found.
         */
        patch: operations["ConversationsAdminService_AdminUpdateConversationFlag"];
        trace?: never;
    };
    "/admin/v1/conversations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * AdminListConversations
         * @description AdminListConversations lists conversations across all users, most-recently-
         *      updated first. The `query` filter is a single smart box: a UUID is matched
         *      as a user_id; any other value is resolved to user_ids via the users service.
         */
        get: operations["ConversationsAdminService_AdminListConversations"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/conversations/{conversationId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * AdminGetConversation
         * @description AdminGetConversation returns a single conversation and its full message
         *      thread by id, with the owner's email/name attached.
         */
        get: operations["ConversationsAdminService_AdminGetConversation"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/conversations/{conversationId}/flags": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * AdminCreateConversationFlag
         * @description AdminCreateConversationFlag flags one of Nim's messages, or a whole
         *      conversation, with feedback on what Nim got wrong and what it should have
         *      done instead. The flag is raised as the signed-in admin. A retry with the
         *      same idempotency key returns the flag already raised.
         */
        post: operations["ConversationsAdminService_AdminCreateConversationFlag"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/events/{eventCode}/guests/{userId}:issueTickets": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * IssueEventTickets
         * @description Hands a guest of an event all of the event's drink tickets at once, with
         *      the signed-in operator recorded as who handed them over, and returns the
         *      guest afterwards. Refused with EVENT_CLOSED outside the event's window,
         *      EVENT_GUEST_NOT_SUBMITTED or EVENT_GUEST_REJECTED when the guest's
         *      identity verification does not allow it, EVENT_FULL once the event's
         *      guest limit is reached, and EVENT_TICKETS_ALREADY_ISSUED when the guest
         *      was already handed them; a refusal records nothing.
         */
        post: operations["EventsAdminService_IssueEventTickets"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/events/{eventCode}/guests:resolve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * ResolveEventGuest
         * @description Finds a guest of an event by exactly one of their profile tag, current
         *      or previous and in any case, their email address, or their user id, and
         *      returns them as the door sees them. A tag or email address that matches
         *      no profile, or more than one, is not found.
         */
        get: operations["EventsAdminService_ResolveEventGuest"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/events/{eventCode}/ticketIssuances": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * ListEventTicketIssuances
         * @description Lists the drink tickets an event's guests were handed, most recent
         *      first, each with the guest's name and tag, and the event's totals.
         */
        get: operations["EventsAdminService_ListEventTicketIssuances"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/feedback": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * AdminListFeedback
         * @description AdminListFeedback lists the bug reports, feature requests and general
         *      feedback users raised in conversation with Nim, newest first, each with
         *      the reporter's name attached. The `query` filter behaves like the
         *      conversations one; `kinds` narrows to the selected categories.
         */
        get: operations["ConversationsAdminService_AdminListFeedback"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/fflags/disable": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * AdminDisableFFlag
         * @description Disables a flag globally.
         */
        post: operations["FFlagsAdminService_AdminDisableFFlag"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/fflags/enable": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * AdminEnableFFlag
         * @description Enables a flag globally.
         */
        post: operations["FFlagsAdminService_AdminEnableFFlag"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/fflags/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * AdminListFFlags
         * @description Lists every flag with its state.
         */
        post: operations["FFlagsAdminService_AdminListFFlags"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/fflags/overrides/delete": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * AdminDeleteUserFFlagOverride
         * @description Removes a per-user override.
         */
        post: operations["FFlagsAdminService_AdminDeleteUserFFlagOverride"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/fflags/overrides/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * AdminListUserFFlagOverrides
         * @description Lists override rows, filterable by user and flag.
         */
        post: operations["FFlagsAdminService_AdminListUserFFlagOverrides"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/fflags/overrides/set": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * AdminSetUserFFlagOverride
         * @description Upserts a per-user override.
         */
        post: operations["FFlagsAdminService_AdminSetUserFFlagOverride"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * HealthCheck
         * @description Reports whether the admin gateway is up.
         */
        get: operations["AdminService_HealthCheck"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/kyc/webhooks/{webhookEventId}/replay": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * AdminReplayPersonaWebhook
         * @description Re-processes a stored Persona webhook event.
         */
        post: operations["KYCAdminService_AdminReplayPersonaWebhook"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/ledger": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * ListLedgerEntries
         * @description Lists the entries of ledger transactions.
         */
        get: operations["LedgerAdminService_ListLedgerEntries"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/lifecycle/activity": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * SummarizeNudgeActivity
         * @description Summarizes the nudge engine's day across every user: the nudges planned
         *      for the next 24 hours and what was sent or skipped in the last 24.
         */
        get: operations["NotificationsAdminService_SummarizeNudgeActivity"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/lifecycle/preview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * SendNudgePreview
         * @description Sends one nudge message to the calling admin's own Liminal account.
         */
        post: operations["NotificationsAdminService_SendNudgePreview"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/me": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetCurrentAdmin
         * @description Returns the authenticated admin's identity.
         */
        get: operations["AdminService_GetCurrentAdmin"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/nim-announcements": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * AdminListNimAnnouncements
         * @description AdminListNimAnnouncements lists Nim announcements with delivery progress.
         */
        get: operations["ConversationsAdminService_AdminListNimAnnouncements"];
        put?: never;
        /**
         * AdminCreateNimAnnouncement
         * @description AdminCreateNimAnnouncement sends an announcement into targeted users' Nim
         *      chats, delivered once to each user as the first message of their next new
         *      conversation, in place of Nim's greeting.
         */
        post: operations["ConversationsAdminService_AdminCreateNimAnnouncement"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/nim-announcements/{id}/cancel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * AdminCancelNimAnnouncement
         * @description AdminCancelNimAnnouncement cancels a Nim announcement; undelivered
         *      messages are skipped from then on.
         */
        post: operations["ConversationsAdminService_AdminCancelNimAnnouncement"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/nim/calls": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * ListNimCalls
         * @description Lists calls between users and Nim, newest first: every user's or one
         *      user's, started or placed by anyone or by one kind of initiator, each
         *      with who placed it, its brief and reason, the operator's options, its
         *      conversation and how it went.
         */
        get: operations["NimAdminService_ListNimCalls"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/nim/calls:place": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * PlaceNimCall
         * @description Places a call from Nim to a user, as the signed-in operator: the call
         *      rings the user's phones, and when they answer, Nim opens a new
         *      conversation with them and follows the brief, which the user never
         *      sees. The operator is read from the admin session, never from the
         *      request. The call is held to the user's consent as any call Nim places
         *      is, with no override: it is refused, with a reason, when the user has
         *      not let Nim call them, has no phone Nim can ring, is inside their quiet
         *      hours or is already on a call with Nim, and when Nim cannot ring phones
         *      at all. Unless the operator chooses otherwise, the call is charged to
         *      the user's Nim credits and Nim has its full toolset, as on any call.
         *      Re-submitting the same request_id returns the call it placed.
         */
        post: operations["NimAdminService_PlaceNimCall"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/nim/graph/backfill": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * BackfillNimGraph
         * @description Rebuilds graph relations for stored memories.
         */
        post: operations["NimAdminService_BackfillNimGraph"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/nim/graph/entity": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetNimEntityGraph
         * @description Returns the entity graph.
         */
        get: operations["NimAdminService_GetNimEntityGraph"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/nim/graph/expand": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * ExpandNimNode
         * @description Expands one graph node's neighbourhood.
         */
        get: operations["NimAdminService_ExpandNimNode"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/nim/graph/full": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetNimFullGraph
         * @description Returns a user's full memory graph.
         */
        get: operations["NimAdminService_GetNimFullGraph"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/nim/graph/memory": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetNimMemoryGraph
         * @description Returns the memory graph around a seed memory.
         */
        get: operations["NimAdminService_GetNimMemoryGraph"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/nim/graph/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetNimGraphStats
         * @description Returns memory-graph size and health statistics.
         */
        get: operations["NimAdminService_GetNimGraphStats"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/nim/media": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * AdminListNimMedia
         * @description AdminListNimMedia lists images uploaded into Nim conversations across all
         *      users, newest-first by default, each with a signed read URL and the
         *      owner's email/name. The `query` filter behaves like the conversations one.
         */
        get: operations["ConversationsAdminService_AdminListNimMedia"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/nim/memories": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * ListNimMemories
         * @description Lists stored memories with filters.
         */
        get: operations["NimAdminService_ListNimMemories"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/push-announcements": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * AdminListPushAnnouncements
         * @description Lists push announcements with delivery progress.
         */
        get: operations["NotificationsAdminService_AdminListPushAnnouncements"];
        put?: never;
        /**
         * AdminCreatePushAnnouncement
         * @description Creates a push announcement fan-out.
         */
        post: operations["NotificationsAdminService_AdminCreatePushAnnouncement"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/push-announcements/{id}/cancel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * AdminCancelPushAnnouncement
         * @description Cancels a push announcement's remaining deliveries.
         */
        post: operations["NotificationsAdminService_AdminCancelPushAnnouncement"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/ramps/banks": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * ListRampBanks
         * @description Lists the configured banks.
         */
        get: operations["RampsAdminService_ListRampBanks"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/ramps/linked-accounts/{accountId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetRampLinkedAccount
         * @description Returns one linked bank account by id.
         */
        get: operations["RampsAdminService_GetRampLinkedAccount"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/ramps/recipients/{recipientId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetRampRecipient
         * @description Returns one recipient by id.
         */
        get: operations["RampsAdminService_GetRampRecipient"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/ramps/transactions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * ListRampTransactions
         * @description Lists on/offramp transactions.
         */
        get: operations["LedgerAdminService_ListRampTransactions"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/referrals:summarizeAttribution": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * SummarizeReferralAttribution
         * @description Summarizes how referrals were attributed across every inviter in the
         *      last 30 days: how many each attribution source produced, and the
         *      referrals themselves, newest first, each with both people's emails.
         */
        get: operations["ReferralsAdminService_SummarizeReferralAttribution"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/rewardBudgets": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * ListRewardBudgets
         * @description Lists reward budgets, newest first.
         */
        get: operations["RewardsAdminService_ListRewardBudgets"];
        put?: never;
        /**
         * CreateRewardBudget
         * @description Creates a reward budget, open, with nothing reserved or spent.
         */
        post: operations["RewardsAdminService_CreateRewardBudget"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/rewardBudgets/{rewardBudget}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetRewardBudget
         * @description Returns a reward budget with what it has reserved and spent.
         */
        get: operations["RewardsAdminService_GetRewardBudget"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * UpdateRewardBudget
         * @description Updates a reward budget's name, limits or window.
         */
        patch: operations["RewardsAdminService_UpdateRewardBudget"];
        trace?: never;
    };
    "/admin/v1/rewardBudgets/{rewardBudget}:close": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * CloseRewardBudget
         * @description Closes a reward budget for good. Refused while a merchant names it.
         */
        post: operations["RewardsAdminService_CloseRewardBudget"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/rewardBudgets/{rewardBudget}:pause": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * PauseRewardBudget
         * @description Pauses a reward budget: no new Pay with LIL choice reserves from it.
         */
        post: operations["RewardsAdminService_PauseRewardBudget"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/rewardBudgets/{rewardBudget}:resume": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * ResumeRewardBudget
         * @description Resumes a paused reward budget.
         */
        post: operations["RewardsAdminService_ResumeRewardBudget"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/rewardMerchants": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * ListRewardMerchants
         * @description Lists partner merchants, newest first.
         */
        get: operations["RewardsAdminService_ListRewardMerchants"];
        put?: never;
        /**
         * CreateRewardMerchant
         * @description Creates a partner merchant, active, at revision 1.
         */
        post: operations["RewardsAdminService_CreateRewardMerchant"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/rewardMerchants/{rewardMerchant}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetRewardMerchant
         * @description Returns a partner merchant at its current revision.
         */
        get: operations["RewardsAdminService_GetRewardMerchant"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * UpdateRewardMerchant
         * @description Updates a partner merchant. Its catalogue fields change in place; its
         *      identities, rates (the Pay with LIL levels among them) or budget make a
         *      new revision.
         */
        patch: operations["RewardsAdminService_UpdateRewardMerchant"];
        trace?: never;
    };
    "/admin/v1/rewardMerchants/{rewardMerchant}/images": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * CreateRewardMerchantImage
         * @description Registers an uploaded image as one of a partner merchant's images. It
         *      shows once an update places it among the merchant's photos or makes it
         *      the logo.
         */
        post: operations["RewardsAdminService_CreateRewardMerchantImage"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/rewardMerchants/{rewardMerchant}/images/{image}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * DeleteRewardMerchantImage
         * @description Deletes one of a partner merchant's images. The current logo cannot be
         *      deleted.
         */
        delete: operations["RewardsAdminService_DeleteRewardMerchantImage"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/rewardMerchants/{rewardMerchant}/images:upload": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * CreateRewardMerchantImageUpload
         * @description Signs a URL the operator's browser uploads one image of a partner
         *      merchant to, straight into storage. Nothing is kept until
         *      CreateRewardMerchantImage registers the upload.
         */
        post: operations["RewardsAdminService_CreateRewardMerchantImageUpload"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/rewardMerchants/{rewardMerchant}:listRevisions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * ListRewardMerchantRevisions
         * @description Lists a partner merchant's revisions, newest first.
         */
        get: operations["RewardsAdminService_ListRewardMerchantRevisions"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/rewardMerchants/{rewardMerchant}:pause": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * PauseRewardMerchant
         * @description Pauses a partner merchant: its payments open, and no choice is taken.
         */
        post: operations["RewardsAdminService_PauseRewardMerchant"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/rewardMerchants/{rewardMerchant}:resume": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * ResumeRewardMerchant
         * @description Resumes a paused partner merchant.
         */
        post: operations["RewardsAdminService_ResumeRewardMerchant"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/rewardMerchants/{rewardMerchant}:retire": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * RetireRewardMerchant
         * @description Retires a partner merchant for good, freeing its identities.
         */
        post: operations["RewardsAdminService_RetireRewardMerchant"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/rewardMerchants:resolveLocationLink": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * ResolveRewardMerchantLocationLink
         * @description Reads the coordinates and the place name out of a Google Maps link,
         *      short or full. A link with no coordinates in it is refused.
         */
        post: operations["RewardsAdminService_ResolveRewardMerchantLocationLink"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/rewardPayments": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * ListRewardPayments
         * @description Lists every customer's reward payments, most recently settled first.
         */
        get: operations["RewardsAdminService_ListRewardPayments"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/rewardProgramme:query": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * QueryRewardProgramme
         * @description Returns the programme's money picture: each budget's counters, what
         *      live redemptions may still draw, and the treasury Safe's balances with
         *      the time they were read.
         */
        get: operations["RewardsAdminService_QueryRewardProgramme"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/transactions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * ListTransactions
         * @description Lists ledger transactions across all accounts.
         */
        get: operations["LedgerAdminService_ListTransactions"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/transactions/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetTransaction
         * @description Returns one ledger transaction.
         */
        get: operations["LedgerAdminService_GetTransaction"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/batch-get": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * AdminBatchGetUsers
         * @description AdminBatchGetUsers fetches many profiles by user_id in a single call — replaces
         *      the admin graph's per-id getUser fan-out. POST because the id
         *      list can be large.
         */
        post: operations["UsersAdminService_AdminBatchGetUsers"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/batch-resolve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * AdminBatchResolveUsersByName
         * @description AdminBatchResolveUsersByName resolves many lowercased "first last" names to user
         *      profiles by exact full-name match in a single call — replaces the admin
         *      graph's per-name searchUsers fan-out. POST because the name list
         *      can be large.
         */
        post: operations["UsersAdminService_AdminBatchResolveUsersByName"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/emails": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * ExportFilteredEmails
         * @description Exports the id, email, and name of every user matching the filters.
         */
        get: operations["UsersAdminService_ExportFilteredEmails"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/resolve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * AdminResolveUsers
         * @description AdminResolveUsers resolves a pasted list of mixed user ids and email
         *      addresses to profiles, reporting identifiers that matched nothing. Used by
         *      the announcement audience selector. POST because the list can be large.
         */
        post: operations["UsersAdminService_AdminResolveUsers"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * SearchUsers
         * @description Searches users by free text with KYC and platform filters, ordered and
         *      paged across the whole matching set.
         */
        get: operations["UsersAdminService_SearchUsers"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/{profile.user_id}/profile": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * UpdateProfile
         * @description UpdateProfile updates the fields of a user's profile named in
         *      update_mask. Without a mask, every populated field of profile is written
         *      (AIP-134's implied mask), so clearing a field (a bool to false, a string
         *      to empty) needs an explicit mask. profile.user_id names the profile;
         *      server-owned fields (user_id, timestamps, tier, phone_number_verified,
         *      previous_display_tag) cannot be updated and are rejected.
         */
        patch: operations["UsersAdminService_UpdateProfile"];
        trace?: never;
    };
    "/admin/v1/users/{userId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetUser
         * @description Returns a user's profile by id.
         */
        get: operations["UsersAdminService_GetUser"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/{userId}/balances": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetUserBalances
         * @description Returns a user's token balances.
         */
        get: operations["WalletsAdminService_GetUserBalances"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/{userId}/devices": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetUserDevices
         * @description Lists a user's registered devices.
         */
        get: operations["NotificationsAdminService_GetUserDevices"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/{userId}/inbox": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * ListUserInbox
         * @description Lists a user's inbox notifications.
         */
        get: operations["NotificationsAdminService_ListUserInbox"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/{userId}/kyc/data": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetUserKYCData
         * @description Returns the KYC data a user submitted.
         */
        get: operations["KYCAdminService_GetUserKYCData"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/{userId}/kyc/persona/decisions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * AdminListPersonaDecisions
         * @description Lists a user's Persona decisions.
         */
        get: operations["KYCAdminService_AdminListPersonaDecisions"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/{userId}/kyc/persona/inquiries": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * AdminListPersonaInquiries
         * @description Lists a user's Persona inquiries.
         */
        get: operations["KYCAdminService_AdminListPersonaInquiries"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/{userId}/kyc/persona/webhooks": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * AdminListWebhookEvents
         * @description Lists received KYC webhook events.
         */
        get: operations["KYCAdminService_AdminListWebhookEvents"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/{userId}/kyc/providers/{provider}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * AdminGetProviderCustomer
         * @description Returns a user's provider customer record.
         */
        get: operations["RampsAdminService_AdminGetProviderCustomer"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/{userId}/kyc/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetUserKYCStatus
         * @description Returns a user's KYC status.
         */
        get: operations["KYCAdminService_GetUserKYCStatus"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/{userId}/lifecycle": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetUserLifecycle
         * @description Returns a user's onboarding nudge state: stage, milestones, what was sent
         *      or skipped, and the nudges still planned.
         */
        get: operations["NotificationsAdminService_GetUserLifecycle"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/{userId}/lifecycle/restart": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * RestartUserLifecycle
         * @description Restarts the current stage's nudge journey for a staff test account.
         */
        post: operations["NotificationsAdminService_RestartUserLifecycle"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/{userId}/linked-accounts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * ListUserLinkedAccounts
         * @description Lists a user's linked bank accounts.
         */
        get: operations["RampsAdminService_ListUserLinkedAccounts"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/{userId}/portfolio": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetUserPortfolio
         * @description Returns a user's investing portfolio.
         */
        get: operations["InvestingAdminService_GetUserPortfolio"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/{userId}/preferences": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetUserPreferences
         * @description Returns a user's notification preferences.
         */
        get: operations["UsersAdminService_GetUserPreferences"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/{userId}/recipients": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * ListUserRecipients
         * @description Lists a user's recipients.
         */
        get: operations["RampsAdminService_ListUserRecipients"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/{userId}/savings": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetUserSavings
         * @description Returns a user's savings positions.
         */
        get: operations["SavingsAdminService_GetUserSavings"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/{userId}/schedules": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * ListUserSchedules
         * @description Lists a user's payment schedules.
         */
        get: operations["ScheduledPaymentsAdminService_ListUserSchedules"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/{userId}/schedules/{scheduleId}/jobs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * ListScheduleJobs
         * @description Lists a schedule's execution jobs.
         */
        get: operations["ScheduledPaymentsAdminService_ListScheduleJobs"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/{userId}/suspension": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetSuspension
         * @description Returns a user's suspension, if any.
         */
        get: operations["AuthAdminService_GetSuspension"];
        put?: never;
        post?: never;
        /**
         * DeleteSuspension
         * @description Lifts a user's suspension.
         */
        delete: operations["AuthAdminService_DeleteSuspension"];
        options?: never;
        head?: never;
        /**
         * UpdateSuspension
         * @description Creates or updates a user's suspension.
         */
        patch: operations["AuthAdminService_UpdateSuspension"];
        trace?: never;
    };
    "/admin/v1/users/{userId}/transactions/ledger": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * ListUserLedgerTransactions
         * @description Lists one user's ledger transactions with filters.
         */
        get: operations["LedgerAdminService_ListUserLedgerTransactions"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/{userId}/transactions/wallet": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * ListUserWalletTransactions
         * @description Lists a user's on-chain transactions.
         */
        get: operations["WalletsAdminService_ListUserWalletTransactions"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/{userId}/wallets": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetUserWallets
         * @description Returns a user's wallets.
         */
        get: operations["WalletsAdminService_GetUserWallets"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/users/{user}/rewardPayments/{rewardPayment}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetRewardPayment
         * @description Returns one customer's reward payment.
         */
        get: operations["RewardsAdminService_GetRewardPayment"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/wallets": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * ListWallets
         * @description Lists wallets across all users.
         */
        get: operations["WalletsAdminService_ListWallets"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/v1/wallets/{address}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * GetWallet
         * @description Returns one wallet.
         */
        get: operations["WalletsAdminService_GetWallet"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        /**
         * Format: enum
         * @description How a user first heard of Liminal, as they answered at signup. An answer the app no longer offers stays valid: older builds still send it, and older profiles still hold it.
         * @enum {string}
         */
        AcquisitionSource: AcquisitionSource;
        /** @description ActionResult represents the result of a confirmed action */
        ActionResult: {
            /** @description Whether the action succeeded. */
            readonly success?: boolean;
            /** @description The action's result, as a JSON string. */
            readonly result?: string;
            /** @description The action's error message, when it failed. */
            readonly error?: string;
        };
        /** @description A span of time a partner merchant is live in: from its start, up to but not including its end. Windows may overlap. */
        ActiveWindow: {
            /**
             * Format: date-time
             * @description When the window opens.
             */
            startTime: string;
            /**
             * Format: date-time
             * @description When the window closes. Must be after start_time.
             */
            endTime: string;
        };
        /** @description A postal address. */
        Address: {
            /** @description The first street line. */
            readonly street1?: string;
            /** @description The second street line. */
            readonly street2?: string;
            /** @description The city. */
            readonly city?: string;
            /** @description The state or province. */
            readonly subdivision?: string;
            /** @description The postal code. */
            readonly postalCode?: string;
            /** @description The country, as an ISO-3166 alpha-2 code. */
            readonly countryCode?: string;
        };
        /** @description Request to fetch many profiles by id. */
        AdminBatchGetUsersRequest: {
            /** @description The users to fetch, as UUIDs. */
            userIds?: string[];
        };
        /** @description Profiles fetched by id. */
        AdminBatchGetUsersResponse: {
            /** @description Profiles keyed by user_id; unknown ids are omitted. */
            profiles?: {
                [key: string]: components["schemas"]["Profile"];
            };
        };
        /** @description Request to resolve names to profiles. */
        AdminBatchResolveUsersByNameRequest: {
            /** @description Lowercased "first last" names to resolve. */
            names?: string[];
        };
        /** @description Profiles matched by name. */
        AdminBatchResolveUsersByNameResponse: {
            /** @description Exact full-name match keyed by the input name; unmatched names are omitted. */
            profiles?: {
                [key: string]: components["schemas"]["Profile"];
            };
        };
        /** @description AdminCancelNimAnnouncementRequest names one announcement to cancel. */
        AdminCancelNimAnnouncementRequest: {
            /** @description The announcement to cancel, as a UUID. */
            id: string;
        };
        /** @description Request message for NotificationsService.AdminCancelPushAnnouncement. */
        AdminCancelPushAnnouncementRequest: {
            /** @description The push announcement to cancel, as a UUID. */
            id: string;
        };
        /** @description AdminConversationSummary is a listing row enriched with the owner's identity. */
        AdminConversationSummary: {
            /** @description The conversation's unique identifier, as a UUID. */
            id?: string;
            /** @description The conversation's owner, as a UUID. */
            userId?: string;
            /** @description The conversation's title. */
            title?: string;
            /** @description The owner's email address. */
            email?: string;
            /** @description The owner's first name. */
            firstName?: string;
            /** @description The owner's last name. */
            lastName?: string;
            /**
             * Format: date-time
             * @description When the conversation was created.
             */
            createdAt?: string;
            /**
             * Format: date-time
             * @description When the conversation last changed.
             */
            updatedAt?: string;
            /**
             * Format: int32
             * @description How many messages the conversation holds.
             */
            messageCount?: number;
            /** @description Whether the conversation has confirmations awaiting the user. */
            hasPendingActions?: boolean;
            /**
             * Format: int32
             * @description The number of the conversation's flags still open, waiting for review.
             */
            readonly flagCount?: number;
        };
        /** @description Request message for NotificationsService.AdminCreateAnnouncement. */
        AdminCreateAnnouncementRequest: {
            /** @description The display title. */
            title: string;
            /** @description The display body. */
            body: string;
            type?: components["schemas"]["AnnouncementType"];
            /** @description The action button's label. */
            actionLabel?: string;
            /** @description The action button's target. */
            actionUrl?: string;
            /**
             * Format: int32
             * @description The display ordering priority; higher shows first.
             */
            priority?: number;
            /**
             * Format: date-time
             * @description When the announcement becomes visible.
             */
            startsAt: string;
            /**
             * Format: date-time
             * @description When the announcement stops showing; unset shows indefinitely.
             */
            expiresAt?: string;
            audience?: components["schemas"]["Audience"];
            push?: components["schemas"]["AnnouncementPush"];
            /** @description Stamped by admin_api from the authenticated admin's email — any client-supplied value is overwritten at the gateway. Annotated OPTIONAL, not REQUIRED or OUTPUT_ONLY, for the same reason as AdminCreatePushAnnouncementRequest.created_by: this message is also the gateway's own external request type, and the field-behavior interceptor runs on both the gateway and this service. */
            createdBy?: string;
        };
        /** @description Request to flag one of Nim's messages, or a whole conversation, as the signed-in admin. Where the flag comes from and who raised it are set by the server, never by the client. */
        AdminCreateConversationFlagRequest: {
            /**
             * Format: uuid
             * @description A client-minted UUID making the create idempotent: a retry of a committed create returns the flag already raised instead of raising a second one. The server mints one when it is omitted.
             */
            idempotencyKey?: string;
            /**
             * Format: uuid
             * @description The conversation to flag, as a UUID.
             */
            conversationId: string;
            /**
             * Format: uuid
             * @description The message to flag, as a UUID. It must belong to the conversation. Empty flags the whole conversation.
             */
            messageId?: string;
            /** @description What Nim got wrong and what it should have done, up to four thousand characters. Leading and trailing whitespace is dropped. */
            feedback: string;
        };
        /** @description Request to send an announcement into users' Nim chats. */
        AdminCreateNimAnnouncementRequest: {
            /** @description The announcement text delivered to each user. */
            content: string;
            audience?: components["schemas"]["NimAudience"];
            /** @description Caller-minted UUID making the create idempotent end-to-end (a retry of a committed create returns the existing announcement). The gateway mints one when the client omits it, which still protects against gRPC-level retries between gateway and nim. */
            idempotencyKey: string;
            /** @description The text of an optional button under the message, for example "See what's new". */
            buttonLabel?: string;
            /**
             * Format: uri
             * @description The page the button opens, as an HTTPS URL. Set together with button_label.
             */
            buttonUri?: string;
        };
        /** @description Request message for NotificationsService.AdminCreatePushAnnouncement. */
        AdminCreatePushAnnouncementRequest: {
            /** @description The push title. */
            title: string;
            /** @description The push body. */
            message: string;
            /**
             * Format: date-time
             * @description Omitted = send now.
             */
            sendAt?: string;
            /** @description Stamped by admin_api from the authenticated admin's email — any client-supplied value is overwritten at the gateway. Annotated OPTIONAL, not REQUIRED or OUTPUT_ONLY: this message is also the gateway's own external request type, received before the stamp happens, and the field-behavior interceptor runs on both the gateway and this service — REQUIRED would reject the browser's request and OUTPUT_ONLY would clear the gateway's stamp back out before it reaches this service. */
            createdBy?: string;
            /** @description Internal app path opened when the user taps the push (e.g. /savings). */
            url?: string;
            audience?: components["schemas"]["Audience"];
        };
        /** @description Response message for NotificationsService.AdminDeleteAnnouncement. */
        AdminDeleteAnnouncementResponse: Record<string, never>;
        /** @description Request to remove a per-user override. */
        AdminDeleteUserFFlagOverrideRequest: {
            /** @description The overridden flag's name. */
            name: string;
            /**
             * Format: uuid
             * @description The user whose override to remove, as a UUID.
             */
            userId: string;
        };
        /** @description Response to removing an override. */
        AdminDeleteUserFFlagOverrideResponse: Record<string, never>;
        /** @description Request to disable a flag globally. */
        AdminDisableFFlagRequest: {
            /** @description The flag to disable. */
            name: string;
        };
        /** @description Response to disabling a flag. */
        AdminDisableFFlagResponse: Record<string, never>;
        /** @description Request to enable a flag globally. */
        AdminEnableFFlagRequest: {
            /** @description The flag to enable. */
            name: string;
        };
        /** @description Response to enabling a flag. */
        AdminEnableFFlagResponse: Record<string, never>;
        /** @description AdminFeedbackItem is one feedback submission, enriched with the reporter's name. The email is the address recorded at submit time, which is what the team replies to. */
        AdminFeedbackItem: {
            /** @description The submission's identifier, as a UUID. */
            id?: string;
            /** @description The reporter's id, as a UUID. */
            userId?: string;
            /** @description The reporter's email address, recorded when the feedback was submitted. */
            email?: string;
            /** @description The reporter's first name. */
            firstName?: string;
            /** @description The reporter's last name. */
            lastName?: string;
            kind?: components["schemas"]["FeedbackKind"];
            /** @description A one-line summary of the submission. */
            title?: string;
            /** @description The submission's full text. */
            details?: string;
            /** @description The conversation the submission was raised in, as a UUID. Empty when the conversation was not recorded. */
            conversationId?: string;
            /** @description The message the submission was raised from, as a UUID. Empty when the message was not recorded. */
            messageId?: string;
            /** @description The client the submission came from, for example "ios" or "web". Empty when the client did not report one. */
            platform?: string;
            /**
             * Format: date-time
             * @description When the submission was made.
             */
            createdAt?: string;
        };
        /** @description Response message for NotificationsService.AdminGetAnnouncementDismissals. */
        AdminGetAnnouncementDismissalsResponse: {
            /** @description The dismissals. */
            readonly dismissals?: components["schemas"]["AnnouncementDismissal"][];
            /**
             * Format: int32
             * @description The total number of dismissals.
             */
            readonly total?: number;
        };
        /** @description A conversation and its full message thread. */
        AdminGetConversationResponse: {
            conversation?: components["schemas"]["AdminConversationSummary"];
            /** @description The conversation's messages, oldest first. */
            messages?: components["schemas"]["Message"][];
        };
        /** @description The full customer record held at a provider, for admin review. */
        AdminGetProviderCustomerResponse: {
            /** @description The provider's customer identifier. Treat as opaque text. */
            readonly providerCustomerId?: string;
            /** @description The provider's status string for the customer. */
            readonly customerStatus?: string;
            /** @description The provider's customer type, such as `individual`. */
            readonly customerType?: string;
            /** @description The customer's full name as the provider holds it. */
            readonly name?: string;
            /** @description The customer's email address as the provider holds it. */
            readonly email?: string;
            /** @description A URL the customer can open to continue verification, when the provider issues one. */
            readonly verificationLink?: string;
            /** @description When the provider last updated the record, as an RFC 3339 string. */
            readonly updatedAt?: string;
            /** @description Outstanding problems with the customer's verification. */
            readonly verificationIssues?: components["schemas"]["RampVerificationIssue"][];
            /** @description The payment rails the customer is approved to use. */
            readonly availablePaymentMethods?: string[];
            kycData?: components["schemas"]["CustomerKYCData"];
            /** @description The identity documents the provider holds. */
            readonly documents?: components["schemas"]["CustomerDocument"][];
        };
        /** @description Response message for NotificationsService.AdminListAnnouncements. */
        AdminListAnnouncementsResponse: {
            /** @description The matching announcements. */
            readonly announcements?: components["schemas"]["Announcement"][];
            /**
             * Format: int32
             * @description The total number of matching announcements across all pages.
             */
            readonly total?: number;
        };
        /** @description One page of conversation flags. */
        AdminListConversationFlagsResponse: {
            /** @description The flags on this page, newest first. */
            flags?: components["schemas"]["ConversationFlag"][];
            /** @description The token for the next page. Empty when this is the last page. */
            nextPageToken?: string;
        };
        /** @description One page of conversations. */
        AdminListConversationsResponse: {
            /** @description The conversations on this page, most recently updated first. */
            conversations?: components["schemas"]["AdminConversationSummary"][];
            /** @description The token for the next page. Empty when this is the last page. */
            nextPageToken?: string;
            /**
             * Format: int32
             * @description The total number of matching conversations across all pages.
             */
            totalCount?: number;
        };
        /** @description Request for every flag. */
        AdminListFFlagsRequest: Record<string, never>;
        /** @description Every flag with its current state. */
        AdminListFFlagsResponse: {
            /** @description All flags. */
            readonly fflags?: components["schemas"]["FFlag"][];
        };
        /** @description One page of feedback submissions. */
        AdminListFeedbackResponse: {
            /** @description The submissions on this page, newest first. */
            feedback?: components["schemas"]["AdminFeedbackItem"][];
            /** @description The token for the next page. Empty when this is the last page. */
            nextPageToken?: string;
            /**
             * Format: int32
             * @description The total number of matching submissions across all pages.
             */
            totalCount?: number;
        };
        /** @description AdminListMemoriesResponse is one page of memories. */
        AdminListMemoriesResponse: {
            /** @description The memories on this page, newest first. */
            readonly memories?: components["schemas"]["MemoryEntry"][];
            /** @description The cursor for the next page. Empty when this is the last page. */
            readonly nextPageToken?: string;
            /**
             * Format: int32
             * @description The total number of memories matching the filter.
             */
            readonly totalCount?: number;
        };
        /** @description AdminListNimAnnouncementsResponse is one page of announcements. */
        AdminListNimAnnouncementsResponse: {
            /** @description The announcements on this page, newest first. */
            readonly announcements?: components["schemas"]["NimAnnouncement"][];
            /**
             * Format: int32
             * @description The total number of announcements, ignoring pagination.
             */
            readonly total?: number;
        };
        /** @description One page of uploaded images. */
        AdminListNimMediaResponse: {
            /** @description The images on this page. */
            items?: components["schemas"]["AdminNimMediaItem"][];
            /** @description The token for the next page. Empty when this is the last page. */
            nextPageToken?: string;
            /**
             * Format: int32
             * @description The total number of matching images across all pages.
             */
            totalCount?: number;
        };
        /** @description Response message for KYCService.AdminListPersonaDecisions. */
        AdminListPersonaDecisionsResponse: {
            /** @description The auto-decisioner outputs, newest first. */
            readonly decisions?: components["schemas"]["PersonaDecisionDetail"][];
        };
        /** @description Response message for KYCService.AdminListPersonaInquiries. */
        AdminListPersonaInquiriesResponse: {
            /** @description The user's Persona inquiries. */
            readonly inquiries?: components["schemas"]["PersonaInquiryDetail"][];
        };
        /** @description Response message for NotificationsService.AdminListPushAnnouncements. */
        AdminListPushAnnouncementsResponse: {
            /** @description The push announcements, newest first. */
            readonly pushAnnouncements?: components["schemas"]["PushAnnouncement"][];
            /**
             * Format: int32
             * @description The total number across all pages.
             */
            readonly total?: number;
        };
        /** @description Request for override rows, optionally filtered. */
        AdminListUserFFlagOverridesRequest: {
            /** @description A user to filter by, as a UUID. Empty matches every user. */
            userId?: string;
            /** @description A flag name to filter by. Empty matches every flag. */
            fflagName?: string;
        };
        /** @description The matching override rows. */
        AdminListUserFFlagOverridesResponse: {
            /** @description The overrides matching the filters. */
            readonly overrides?: components["schemas"]["FFlagOverride"][];
        };
        /** @description Response message for KYCService.AdminListWebhookEvents. */
        AdminListWebhookEventsResponse: {
            /** @description The webhook events, newest first. */
            readonly events?: components["schemas"]["WebhookEventDetail"][];
        };
        /** @description AdminNimMediaItem is one uploaded image, enriched with the owner's identity. signed_url is time-limited (see url_expires_in_seconds) — clients must not cache an item past its expiry or the image silently stops loading. */
        AdminNimMediaItem: {
            /** @description The message the image was attached to, as a UUID. */
            messageId?: string;
            /** @description The conversation the message belongs to, as a UUID. */
            conversationId?: string;
            /** @description The image's owner, as a UUID. */
            userId?: string;
            /** @description The owner's email address. */
            email?: string;
            /** @description The owner's first name. */
            firstName?: string;
            /** @description The owner's last name. */
            lastName?: string;
            /** @description Who the image was attached to: `user` or `assistant`. */
            role?: string;
            /** @description The message text the image accompanied, if any. */
            content?: string;
            /** @description A time-limited URL serving the image. */
            signedUrl?: string;
            /**
             * Format: date-time
             * @description When the image was uploaded.
             */
            createdAt?: string;
            /**
             * Format: int32
             * @description How long `signed_url` stays valid, in seconds.
             */
            urlExpiresInSeconds?: number;
        };
        /** @description Request for KYCAdminService.AdminReplayPersonaWebhook. */
        AdminReplayPersonaWebhookRequest: {
            /** @description The webhook event to replay, as the UUID of kyc.webhook_events.id. */
            webhookEventId: string;
        };
        /** @description Response message for KYCProcessorService.AdminReplayWebhook. */
        AdminReplayWebhookResponse: {
            /** @description Whether the replay completed successfully */
            readonly success?: boolean;
            /** @description Error message if the replay failed */
            readonly error?: string;
        };
        /** @description Request to resolve mixed identifiers to profiles. */
        AdminResolveUsersRequest: {
            /** @description Mixed user ids (UUIDs) and email addresses, already split by the client. */
            identifiers?: string[];
        };
        /** @description Resolution results, with unmatched identifiers reported. */
        AdminResolveUsersResponse: {
            /** @description Resolved profiles, deduped by user_id. */
            profiles?: components["schemas"]["Profile"][];
            /** @description Input identifiers that matched no profile, in input order. */
            unmatched?: string[];
        };
        /** @description One page of matching users. */
        AdminSearchUsersResponse: {
            /** @description The profiles on this page, enriched with KYC and platform data. */
            profiles?: components["schemas"]["EnrichedProfile"][];
            /**
             * Format: int32
             * @description The total number of matching users across all pages.
             */
            totalCount?: number;
        };
        /** @description Request to upsert a per-user override. */
        AdminSetUserFFlagOverrideRequest: {
            /** @description The flag to override. */
            name: string;
            /**
             * Format: uuid
             * @description The user the override applies to, as a UUID.
             */
            userId: string;
            /** @description The overriding value. */
            enabled?: boolean;
        };
        /** @description Response to setting an override. */
        AdminSetUserFFlagOverrideResponse: Record<string, never>;
        /**
         * Format: enum
         * @description Which way a sorted column runs.
         * @enum {string}
         */
        AdminSortDirection: AdminSortDirection;
        /** @description Request message for NotificationsService.AdminUpdateAnnouncement. */
        AdminUpdateAnnouncementRequest: {
            /** @description The announcement to update, as a UUID. */
            id: string;
            /** @description The display title. */
            title: string;
            /** @description The display body. */
            body: string;
            type?: components["schemas"]["AnnouncementType"];
            /** @description The action button's label. */
            actionLabel?: string;
            /** @description The action button's target. */
            actionUrl?: string;
            /**
             * Format: int32
             * @description The display ordering priority; higher shows first.
             */
            priority?: number;
            /**
             * Format: date-time
             * @description When the announcement becomes visible.
             */
            startsAt: string;
            /**
             * Format: date-time
             * @description When the announcement stops showing; unset shows indefinitely.
             */
            expiresAt?: string;
            /**
             * Format: date-time
             * @description Optimistic concurrency: must match the row's current update_time. If another admin saved changes since this value was read, the update is rejected with ABORTED so the caller can re-fetch and retry.
             */
            updatedAt: string;
            audience?: components["schemas"]["Audience"];
        };
        /** @description Request to move one conversation flag through review. */
        AdminUpdateConversationFlagRequest: {
            /**
             * Format: uuid
             * @description The flag to update, as a UUID.
             */
            flagId: string;
            state: components["schemas"]["ConversationFlag_State"];
            /** @description What the review found or did, up to four thousand characters. Absent leaves the current notes; empty clears them. */
            reviewNotes?: string;
        };
        /**
         * Format: enum
         * @description Only fields carried on the profile itself. The list's KYC columns are resolved per-row by the console after the page arrives, so there is nothing here to order them by.
         * @enum {string}
         */
        AdminUserSortField: AdminUserSortField;
        /** @description A Safe wallet as the admin dashboard shows it. */
        AdminWallet: {
            /** @description The wallet's identifier. */
            walletId?: string;
            /** @description The Safe smart-contract wallet's on-chain address. */
            safeAddress?: string;
            /**
             * Format: int32
             * @description The EVM chain identifier.
             */
            chainId?: number;
            /**
             * Format: date-time
             * @description When the record was created.
             */
            createdAt?: string;
        };
        /** @description An on-chain transaction as the admin dashboard shows it. */
        AdminWalletTransaction: {
            /** @description The transaction's identifier, as a UUID. */
            transactionId?: string;
            /** @description The acting user's identifier, as a UUID. */
            userId?: string;
            /**
             * Format: int32
             * @description The EVM chain identifier.
             */
            chainId?: number;
            /** @description The on-chain transaction hash. */
            transactionHash?: string;
            /** @description The ERC-4337 user-operation hash. */
            userOperationHash?: string;
            /** @description The token's symbol. */
            tokenSymbol?: string;
            /** @description The token's contract address. */
            tokenAddress?: string;
            /** @description The amount, as a human-readable decimal string. */
            amountHuman?: string;
            /** @description The amount in the token's smallest unit. */
            amountWei?: string;
            /** @description The destination address. */
            recipientAddress?: string;
            /** @description The transaction status: "pending", "success", or "failed". */
            status?: string;
            /** @description The failure description, populated when the operation failed. */
            errorMessage?: string;
            /**
             * Format: date-time
             * @description When the record was created.
             */
            createdAt?: string;
            /**
             * Format: date-time
             * @description When the record was last updated.
             */
            updatedAt?: string;
        };
        /** @description Balances aggregated across all of a user's wallets. */
        AggregatedBalance: {
            /** @description The total value across every wallet, in USD as a decimal string. Empty when the tokens are not priced, which is always the case today. */
            readonly totalUsdValue?: string;
            /** @description The amount of each token summed across every wallet, keyed by token symbol, as decimal strings. */
            byToken?: {
                [key: string]: string;
            };
            /** @description The total USD value per chain identifier, as decimal strings. Empty when the tokens are not priced, which is always the case today. */
            byChain?: {
                [key: string]: string;
            };
        };
        /** @description ===== WEB PUSH TYPES ===== ===== ANNOUNCEMENT TYPES ===== An in-app announcement shown to its audience until dismissed or expired. */
        Announcement: {
            /** @description The announcement's identifier, as a UUID. */
            readonly id?: string;
            /** @description The display title. */
            readonly title?: string;
            /** @description The display body. */
            readonly body?: string;
            type?: components["schemas"]["AnnouncementType"];
            /** @description The action button's label, when the announcement has one. */
            readonly actionLabel?: string;
            /** @description The action button's target, when the announcement has one. */
            readonly actionUrl?: string;
            /**
             * Format: int32
             * @description The display ordering priority; higher shows first.
             */
            readonly priority?: number;
            /**
             * Format: date-time
             * @description When the announcement becomes visible.
             */
            readonly startsAt?: string;
            /**
             * Format: date-time
             * @description When the announcement stops showing; unset shows indefinitely.
             */
            readonly expiresAt?: string;
            /**
             * Format: date-time
             * @description When the record was created.
             */
            readonly createdAt?: string;
            /**
             * Format: date-time
             * @description When the record was last updated.
             */
            readonly updatedAt?: string;
            audienceKind?: components["schemas"]["AudienceKind"];
            /** @description The human-readable audience description. */
            readonly audienceDescription?: string;
            /**
             * Format: int32
             * @description Number of users in the snapshot; unset when audience_kind = ALL.
             */
            readonly audienceSize?: number;
            /** @description The push announcement sent alongside this one, as a UUID; unset when the announcement was created without a push. */
            readonly pushAnnouncementId?: string;
            pushStatus?: components["schemas"]["PushAnnouncement_State"];
        };
        /** @description One user's dismissal of an announcement. */
        AnnouncementDismissal: {
            /** @description The dismissal record's identifier, as a UUID. */
            readonly id?: string;
            /** @description The dismissing user's identifier, as a UUID. */
            readonly userId?: string;
            /**
             * Format: date-time
             * @description When the user dismissed the announcement.
             */
            readonly dismissedAt?: string;
        };
        /** @description The push notification sent alongside an in-app announcement. Each field omitted falls back to the announcement's own copy, so a push that repeats the announcement verbatim needs no fields at all. */
        AnnouncementPush: {
            /** @description The push title; omitted uses the announcement's title. */
            title?: string;
            /** @description The push body; omitted uses the announcement's body. */
            message?: string;
            /** @description Internal app path opened when the user taps the push (for example "/savings"); omitted uses the announcement's action_url. */
            url?: string;
        };
        /**
         * Format: enum
         * @description The lifecycle filter for admin announcement listings.
         * @enum {string}
         */
        AnnouncementStatusFilter: AnnouncementStatusFilter;
        /**
         * Format: enum
         * @description AnnouncementType is the kind of an in-app announcement.
         * @enum {string}
         */
        AnnouncementType: AnnouncementType;
        /** @description A user's savings balance in one asset. */
        AssetBalance: {
            /** @description The asset, as a stablecoin code. */
            readonly assetSymbol?: string;
            /** @description The current value across all positions, as a decimal string. */
            readonly totalBalance?: string;
            /** @description The lifetime amount deposited, as a decimal string from the ledger. */
            readonly totalDeposited?: string;
            /** @description The lifetime amount withdrawn, as a decimal string from the ledger. */
            readonly totalWithdrawn?: string;
            interest?: components["schemas"]["Interest"];
            /** @description The estimated daily earnings at the current balance and rates, as a decimal string. */
            readonly dailyEarningRate?: string;
            /** @description The balance of each position contributing to the total. */
            readonly positions?: components["schemas"]["PositionBalance"][];
        };
        /**
         * Format: enum
         * @description How a referral was attributed to its inviter.
         * @enum {string}
         */
        AttributionSource: AttributionSource;
        /** @description How many referrals one attribution source produced. */
        AttributionSourceCount: {
            source?: components["schemas"]["AttributionSource"];
            /**
             * Format: int32
             * @description How many referrals it produced.
             */
            readonly referralCount?: number;
        };
        /** @description Audience is the write-path targeting for an announcement. Criteria filters are resolved to a concrete user-id snapshot by admin_api at create time, so downstream services only ever see ALL or USER_IDS. Read paths expose only audience_kind + audience_description + audience_size — never the id array. */
        Audience: {
            kind?: components["schemas"]["AudienceKind"];
            /** @description Concrete user-id snapshot; required (non-empty) iff kind = USER_IDS. */
            userIds?: string[];
            /** @description Human-readable audit description, e.g. "filters: kyc=approved (123 users)". */
            description?: string;
            filters?: components["schemas"]["AudienceFilters"];
        };
        /** @description ===== ADMIN ANNOUNCEMENT TYPES ===== AudienceFilters mirrors the admin user-search filters (AdminSearchUsers). */
        AudienceFilters: {
            /** @description A free-text user search query. */
            query?: string;
            /** @description A KYC status to filter users by. */
            kycStatusFilter?: string;
            /** @description A device platform to filter users by. */
            platformFilter?: string;
        };
        /**
         * Format: enum
         * @description AudienceKind is how an announcement's recipients are chosen.
         * @enum {string}
         */
        AudienceKind: AudienceKind;
        /** @description BackfillNimGraphRequest optionally scopes the backfill to one owner. */
        BackfillNimGraphRequest: {
            /** @description An owner to backfill, as a UUID. Empty backfills every owner. */
            ownerIdFilter?: string;
        };
        /** @description BackfillNimGraphResponse reports what the backfill touched. */
        BackfillNimGraphResponse: {
            /**
             * Format: int32
             * @description The number of memories scanned.
             */
            readonly memoriesScanned?: number;
            /**
             * Format: int32
             * @description The number of memory nodes created or found.
             */
            readonly memoryNodes?: number;
            /**
             * Format: int32
             * @description The number of MENTIONS edges created.
             */
            readonly mentionsEdges?: number;
            /**
             * Format: int32
             * @description The number of fact edges upserted.
             */
            readonly factEdgesUpserted?: number;
        };
        /** @description An external bank account as entered by the user. Which fields apply depends on the destination country's banking scheme. */
        BankAccountDetails: {
            /** @description The account holder's first name, for individually owned accounts. */
            firstName?: string;
            /** @description The account holder's last name, for individually owned accounts. */
            lastName?: string;
            /** @description The account holder's email address. */
            email?: string;
            /** @description The account's country, as an ISO 3166-1 alpha-2 code. */
            country?: string;
            /** @description The account's currency, as an ISO 4217 code. */
            currency?: string;
            /** @description US_ACH, EU_SEPA_CT, etc. (canonical proto enum suffix, no PAYMENT_METHOD_ prefix). */
            paymentMethod?: string;
            /** @description The bank's name. */
            bankName?: string;
            /** @description Reference to ramps.banks for bank address lookup. */
            bankId?: string;
            /** @description Account identifiers (country-specific) */
            accountNumber?: string;
            /** @description The routing number, for US accounts. */
            routingNumber?: string;
            /** @description The sort code, for UK accounts. */
            sortCode?: string;
            /** @description The IBAN, for accounts in IBAN countries. */
            iban?: string;
            /** @description The BIC/SWIFT code, for international transfers. */
            bicSwift?: string;
            /** @description Australia. */
            bsb?: string;
            /** @description India. */
            ifscCode?: string;
            /** @description Mexico. */
            clabeNumber?: string;
            /** @description Argentina. */
            cbu?: string;
            /** @description The bank code, for schemes that address banks numerically. */
            bankCode?: string;
            /** @description The branch code, for schemes that address branches separately. */
            branchCode?: string;
            /** @description Canada. */
            transitNumber?: string;
            /** @description CHECKING, SAVINGS. */
            accountType?: string;
            /** @description Brazil PIX key (CPF, CNPJ, email, phone, or random UUID). */
            pixCode?: string;
            /** @description Brazil CPF (11 digits) or CNPJ (14 digits). */
            taxNumber?: string;
            ownerType?: components["schemas"]["OwnerType"];
            /** @description Company name (required when owner_type is BUSINESS) */
            businessName?: string;
            /** @description Country-specific identifiers (added for international support) China CNAPS code. */
            cnapsCode?: string;
            /** @description Hong Kong clearing code. */
            clearingCode?: string;
            /** @description Nigeria NUBAN. */
            nubanNumber?: string;
            /** @description Canada institution number. */
            institutionNumber?: string;
            /** @description Brazil EMVCo BR Code (Pix QR / Copie e Cola). */
            brCode?: string;
            /** @description The type of identity document whose number is in `tax_number`, as one of the `document_type` option values the bank's field requirements list (for example "cc", "ce", "pa" for Colombia). */
            documentType?: string;
            /** @description The Colombian Bre-B key that names the account on the Bre-B rail: a mobile number, identity-document number, email, `@` alias or merchant code (for example "3001234567" or "@camila2025"). */
            breBKey?: string;
            /** @description The Pix key's type, as one of the `pix_key_type` option values the bank's field requirements list ("CPF", "CNPJ", "EMAIL", "PHONE", "EVP"). Eleven digits are both a CPF and a Brazilian mobile, so the holder says which their key is. */
            pixKeyType?: string;
            bankAddress?: components["schemas"]["BankAddress"];
            userAddress?: components["schemas"]["RampAddress"];
        };
        /** @description The displayable essentials of a recipient's bank account. */
        BankAccountSummary: {
            /** @description The bank's name. */
            readonly bankName?: string;
            /** @description The account's currency, as an ISO 4217 code. */
            readonly currency?: string;
            /** @description The account's country, as an ISO 3166-1 alpha-2 code. */
            readonly country?: string;
            /** @description US_ACH, EU_SEPA_CT, SWIFT_MT, etc (canonical proto enum suffix). */
            readonly paymentMethod?: string;
            /** @description Last 4 digits or similar. */
            readonly mask?: string;
            /** @description Bank logo URL from ramps.banks. */
            readonly logoUrl?: string;
            ownerType?: components["schemas"]["OwnerType"];
        };
        /** @description A bank branch's postal address. */
        BankAddress: {
            /** @description The country, as an ISO 3166-1 alpha-2 code. */
            country?: string;
            /** @description The first address line. */
            addressLine1?: string;
            /** @description The second address line, when the address needs one. */
            addressLine2?: string;
            /** @description The city. */
            city?: string;
            /** @description The state, province, or region. */
            state?: string;
            /** @description The postal or ZIP code. */
            postalCode?: string;
        };
        /** @description Blocker is one reason the user cannot transact yet, in plain language. */
        Blocker: {
            /** @description The reason, as a stable upper-snake-case code (for example "IDENTITY_UNDER_REVIEW"). */
            readonly code?: string;
            /** @description A short user-facing title. */
            readonly title?: string;
            /** @description A user-facing explanation, including what happens next when known. */
            readonly message?: string;
        };
        /**
         * Format: enum
         * @description The blockchain networks savings vaults live on.
         * @enum {string}
         */
        Chain: Chain;
        /**
         * Format: enum
         * @description A delivery channel.
         * @enum {string}
         */
        Channel: Channel;
        /** @description Chart is a single-series value-over-time line chart rendered as a component. It carries the ordered series points plus axis-formatting metadata (title, subtitle, currency); the client converts each point's decimal-string value to a number only at the chart render seam, never at this boundary. */
        Chart: {
            /** @description An optional heading, e.g. "AAPL price". */
            readonly title?: string;
            /** @description An optional context line, e.g. "AAPL · last 30 days". */
            readonly subtitle?: string;
            /** @description The ISO currency / token code for Y-axis formatting. */
            readonly currency?: string;
            /** @description The time series, in chronological order. */
            readonly chartPoints?: components["schemas"]["ChartPoint"][];
        };
        /** @description ChartPoint is one observation in a chart series: one value at one moment. Shared by Chart (chart_points) and LineChart's ChartSeries (points). */
        ChartPoint: {
            /** @description The observation's moment, as an ISO 8601 / RFC 3339 timestamp. */
            readonly timestamp?: string;
            /** @description The observed value, as a decimal string — money must never deserialize as a number. */
            readonly value?: string;
        };
        /** @description ChartSeries is one named line within a LineChart: a legend label plus the time series it traces. */
        ChartSeries: {
            /** @description The series' legend label. */
            readonly name?: string;
            /** @description The time series, in chronological order. */
            readonly points?: components["schemas"]["ChartPoint"][];
        };
        /** @description Request message for RewardsAdminService.CloseRewardBudget. */
        CloseRewardBudgetRequest: {
            /** @description The budget to close, as `rewardBudgets/{reward_budget}`. */
            name: string;
            /** @description The etag the budget was read with. */
            etag: string;
            /**
             * Format: uuid
             * @description The idempotency key, as a UUID: minted once by the client when the form opens and sent again on a retry, so a retried change is made once.
             */
            requestId: string;
        };
        /** @description Response message for WalletService.ComputeBalance. */
        ComputeBalanceResponse: {
            /** @description The per-wallet balances. */
            readonly balances?: components["schemas"]["WalletBalance"][];
            total?: components["schemas"]["AggregatedBalance"];
        };
        /** @description A conversation flag: feedback from the Liminal team on what Nim got wrong in one message, or in a whole conversation, and what it should have done instead. Flags are raised from the admin dashboard or from Slack and wait in review until someone looks at them. */
        ConversationFlag: {
            /** @description The flag's identifier, as a UUID. Assigned by the server. */
            readonly id?: string;
            /** @description The flagged conversation, as a UUID. */
            readonly conversationId?: string;
            /** @description The flagged message, as a UUID. Empty when the flag is on the whole conversation. */
            readonly messageId?: string;
            /** @description What Nim got wrong and what it should have done, in the reporter's words. */
            readonly feedback?: string;
            source?: components["schemas"]["ConversationFlag_Source"];
            /** @description Who raised the flag: their email address, or "slack:" followed by their Slack user id when no email is known. */
            readonly reportedBy?: string;
            /** @description A link back to where the flag was raised, such as the Slack thread, as a URL. Empty when there is nowhere to link to. */
            readonly sourceUrl?: string;
            state?: components["schemas"]["ConversationFlag_State"];
            /** @description What the review found or did about the flag. Empty until a reviewer writes some. */
            readonly reviewNotes?: string;
            /**
             * Format: date-time
             * @description When the flag was raised.
             */
            readonly createTime?: string;
            /**
             * Format: date-time
             * @description When the flag last changed.
             */
            readonly updateTime?: string;
            /** @description The user whose conversation was flagged, as a UUID. */
            readonly userId?: string;
            /** @description The flagged conversation's title, as it stands now. */
            readonly conversationTitle?: string;
            /** @description The flagged message's author role: "user", "assistant" or "system". Empty when the flag is on the whole conversation. */
            readonly messageRole?: string;
            /** @description The flagged message's text. Empty when the flag is on the whole conversation. */
            readonly messageContent?: string;
            /**
             * Format: date-time
             * @description When the flagged message was sent. Unset when the flag is on the whole conversation.
             */
            readonly messageCreateTime?: string;
        };
        /**
         * Format: enum
         * @description Where a flag was raised.
         * @enum {string}
         */
        ConversationFlag_Source: ConversationFlag_Source;
        /**
         * Format: enum
         * @description Where a flag is in review.
         * @enum {string}
         */
        ConversationFlag_State: ConversationFlag_State;
        /** @description CurrencyConversion is a single FX quote rendered as a component: SourceAmount of SourceCurrencyCode converted into DestinationAmount of DestinationCurrencyCode at Rate. It carries the initial quote only; live re-quoting on edit is a client concern. */
        CurrencyConversion: {
            /** @description The currency converted from. */
            readonly fromCurrency?: string;
            /** @description The currency converted to. */
            readonly toCurrency?: string;
            /** @description The amount converted from, as a decimal string — money must never deserialize as a number. */
            readonly fromAmount?: string;
            /** @description The amount converted to, as a decimal string — money must never deserialize as a number. */
            readonly toAmount?: string;
            /** @description The exchange rate, as a decimal string — money must never deserialize as a number. */
            readonly rate?: string;
        };
        /** @description A customer address as a provider returns it. aip.dev/not-precedent: mirrors the provider's wire format verbatim — never normalized onto liminal.type.PostalAddress; a reshape would add a mapping table on a money path for no interop gain. */
        CustomerAddress: {
            /** @description The country, as an ISO 3166-1 alpha-2 code. */
            readonly countryCode?: string;
            /** @description The first street line. */
            readonly streetLine1?: string;
            /** @description The city. */
            readonly city?: string;
            /** @description The state, region, or province. */
            readonly stateRegionProvince?: string;
            /** @description The postal or ZIP code. */
            readonly postalCode?: string;
        };
        /** @description An identity document a provider holds for a customer. */
        CustomerDocument: {
            /** @description The provider's document type, such as `passport`. */
            readonly type?: string;
            /** @description The provider's document subtype, where it uses one. */
            readonly subtype?: string;
            /** @description The issuing country, as an ISO 3166-1 alpha-2 code. */
            readonly countryCode?: string;
            /** @description The document's identifying number. */
            readonly documentIdNumber?: string;
            /** @description The issuance date, as `YYYY-MM-DD`. */
            readonly issuanceDate?: string;
            /** @description The expiry date, as `YYYY-MM-DD`. */
            readonly expirationDate?: string;
        };
        /** @description Identity data a provider holds for a customer. */
        CustomerKYCData: {
            /** @description The customer's legal first name. */
            readonly legalFirstName?: string;
            /** @description The customer's legal last name. */
            readonly legalLastName?: string;
            /** @description The customer's date of birth, as `YYYY-MM-DD`. */
            readonly dateOfBirth?: string;
            /** @description The customer's nationality, as an ISO 3166-1 alpha-2 code. */
            readonly nationality?: string;
            address?: components["schemas"]["CustomerAddress"];
        };
        /** @description One registered notification device. */
        Device: {
            /** @description The device record's identifier, as a UUID. */
            readonly id?: string;
            /** @description The owner's identifier, as a UUID. */
            readonly userId?: string;
            /** @description The device's stable identifier. */
            readonly deviceId?: string;
            platform?: components["schemas"]["Platform"];
            channel?: components["schemas"]["Channel"];
            /** @description Whether the device can currently receive notifications. */
            readonly isActive?: boolean;
            /** @description The device's user-agent description. */
            readonly userAgent?: string;
            /** @description Web push fields */
            readonly webEndpoint?: string;
            /** @description The web-push public key; web devices only. */
            readonly webP256dh?: string;
            /** @description The web-push auth secret; web devices only. */
            readonly webAuth?: string;
            /** @description Mobile push fields */
            readonly mobileToken?: string;
            /** @description "fcm" or "apns". */
            readonly provider?: string;
            /**
             * Format: date-time
             * @description When the record was created.
             */
            readonly createdAt?: string;
            /**
             * Format: date-time
             * @description When the device last checked in.
             */
            readonly lastSeenAt?: string;
            /** @description App version (e.g. "1.2.3") */
            readonly appVersion?: string;
            /** @description OS version (e.g. "18.1" for iOS, "14" for Android) */
            readonly osVersion?: string;
        };
        /**
         * Format: enum
         * @description Which side of a double entry an amount sits on.
         * @enum {string}
         */
        Direction: Direction;
        /** @description DisplayBlock is one renderable content block in an assistant message. The oneof selects the block variant; new block types are added as additional oneof arms, and clients skip variants they do not recognize (forward-compatibility). Rehydration replays the full stored block array (text, thinking, etc.) so a resumed message renders identically to the live stream — the merged `content` field cannot preserve block order. */
        DisplayBlock: {
            /** @description A plain text segment. */
            readonly text?: string;
            thinking?: components["schemas"]["Thinking"];
            suggestedReplies?: components["schemas"]["SuggestedReplies"];
            transactionList?: components["schemas"]["TransactionList"];
            currencyConversion?: components["schemas"]["CurrencyConversion"];
            splitsBalances?: components["schemas"]["SplitsBalances"];
            table?: components["schemas"]["Table"];
            chart?: components["schemas"]["Chart"];
            stocksList?: components["schemas"]["StocksList"];
            lineChart?: components["schemas"]["LineChart"];
        };
        /** @description EdgeTypeCount is one edge type's frequency. */
        EdgeTypeCount: {
            /** @description The edge type. */
            readonly predicate?: string;
            /**
             * Format: int32
             * @description The number of edges of this type.
             */
            readonly count?: number;
        };
        /** @description A profile with the admin list's per-row context attached. */
        EnrichedProfile: {
            profile?: components["schemas"]["Profile"];
            /** @description The user's KYC status. */
            kycStatus?: string;
            /** @description Whether the user has passed KYC. */
            kycVerified?: boolean;
            /** @description The device platforms the user has registered. */
            platforms?: string[];
            personaState?: components["schemas"]["PersonaInquiryState"];
        };
        /** @description Entry represents a single debit or credit in a transaction */
        Entry: {
            /** @description Unique identifier for the entry (UUID format) */
            id?: string;
            /** @description Account identifier - either a user UUID or system account name (e.g., "fees", "reserves") Examples: "550e8400-e29b-41d4-a716-446655440000" (user), "fees" (system account) */
            accountId: string;
            direction: components["schemas"]["Direction"];
            /** @description The entry's amount, as a decimal string (for example `"100.50"`). */
            amount?: string;
            /** @description Asset/currency symbol for this entry Examples: "USDC", "USD", "EUR", "GBP", "BTC" */
            assetSymbol?: string;
        };
        /** @description An event whose guests are handed drink tickets at the door. */
        Event: {
            /** @description The event's code, as lowercase letters, digits and hyphens (for example "floripa-nomads-2026-10-31"). */
            code?: string;
            /** @description The event's name as staff see it. */
            displayName?: string;
            /**
             * Format: date-time
             * @description When check-in opens.
             */
            startTime?: string;
            /**
             * Format: date-time
             * @description When check-in closes.
             */
            endTime?: string;
            /** @description Whether check-in is open now: at or after start_time and before end_time. */
            open?: boolean;
            /**
             * Format: int32
             * @description How many drink tickets each guest is handed.
             */
            guestTicketCount?: number;
            /**
             * Format: int32
             * @description The most guests who may be handed tickets. Zero when the event has no limit.
             */
            maxGuests?: number;
        };
        /** @description A guest of an event as the door sees them: who they are, whether they may be handed tickets, and the tickets they were handed, if any. */
        EventGuest: {
            event?: components["schemas"]["Event"];
            /** @description The guest's user id, as a UUID. */
            userId?: string;
            /** @description The guest's name, given then family, as their profile has it. */
            displayName?: string;
            /** @description The guest's current profile tag, without the leading "@". */
            displayTag?: string;
            /** @description The guest's email address. */
            email?: string;
            eligibility?: components["schemas"]["EventGuest_Eligibility"];
            ticketIssuance?: components["schemas"]["EventTicketIssuance"];
        };
        /**
         * Format: enum
         * @description Whether a guest's identity verification lets them be handed tickets.
         * @enum {string}
         */
        EventGuest_Eligibility: EventGuest_Eligibility;
        /** @description The drink tickets one guest of an event was handed, all at once. */
        EventTicketIssuance: {
            /** @description The event's code. */
            eventCode?: string;
            /** @description The guest's user id, as a UUID. */
            userId?: string;
            /**
             * Format: int32
             * @description How many tickets the guest was handed.
             */
            ticketCount?: number;
            /** @description Who handed them over, as the operator's email address. */
            actor?: string;
            /**
             * Format: date-time
             * @description When they were handed over.
             */
            issueTime?: string;
            /** @description The guest's name, given then family, as their profile has it. Empty when the guest has no profile. */
            guestDisplayName?: string;
            /** @description The guest's current profile tag, without the leading "@". Empty when the guest has no profile. */
            guestDisplayTag?: string;
        };
        /** @description ExpandNodeResponse is the node's neighbourhood subgraph. */
        ExpandNodeResponse: {
            /** @description The subgraph's nodes, deduplicated. */
            readonly nodes?: components["schemas"]["GraphNode"][];
            /** @description The subgraph's edges. */
            readonly edges?: components["schemas"]["GraphEdge"][];
        };
        /** @description The exported users matching the filters. */
        ExportFilteredEmailsResponse: {
            /**
             * Format: int32
             * @description The total number of exported users.
             */
            total?: number;
            /** @description One row per matching user. */
            rows?: components["schemas"]["ExportedUser"][];
        };
        /** @description One exported user. */
        ExportedUser: {
            /** @description The user, as a UUID. */
            userId?: string;
            /** @description The user's email address. */
            email?: string;
            /** @description The user's first name. */
            firstName?: string;
            /** @description The user's last name. */
            lastName?: string;
        };
        /** @description One feature flag's global state. */
        FFlag: {
            /** @description The flag's name. */
            readonly name?: string;
            /** @description Whether the flag is globally enabled. */
            readonly enabled?: boolean;
            /** @description Whether the flag may be served to unauthenticated clients. */
            readonly public?: boolean;
        };
        /** @description A per-user override of one flag. */
        FFlagOverride: {
            /** @description The overridden flag's name. */
            readonly fflagName?: string;
            /** @description The user the override applies to, as a UUID. */
            readonly userId?: string;
            /** @description The overriding value, which wins over the flag's global state. */
            readonly enabled?: boolean;
        };
        /**
         * Format: enum
         * @description FeedbackKind is the category a user filed their feedback under.
         * @enum {string}
         */
        FeedbackKind: FeedbackKind;
        /** @description FernProviderDetails contains Fern-specific KYC status information. */
        FernProviderDetails: {
            /** @description Fern's raw provider status (e.g., "CREATED", "ACTIVE", "NEEDS_ADDITIONAL_INFORMATION") */
            readonly rawStatus?: string;
            /** @description URL for user to complete Fern KYC verification */
            readonly verificationLink?: string;
            /** @description Issues preventing verification (populated when NEEDS_INFO or REJECTED) */
            readonly verificationIssues?: components["schemas"]["VerificationIssue"][];
            /** @description Available payment methods (e.g., ["US_ACH", "US_FEDWIRE"]) */
            readonly availablePaymentMethods?: string[];
            /** @description Fern customer ID */
            readonly providerCustomerId?: string;
        };
        /** @description A user's savings balances, per asset and in total. */
        GetBalanceResponse: {
            /** @description The user's balance in each asset. */
            readonly balances?: components["schemas"]["AssetBalance"][];
            total?: components["schemas"]["TotalBalance"];
        };
        /** @description The authenticated admin's identity. */
        GetCurrentAdminResponse: {
            /** @description The authenticated admin's email address. */
            email?: string;
        };
        /** @description GetEntityGraphResponse is the entity subgraph. */
        GetEntityGraphResponse: {
            /** @description The subgraph's nodes, deduplicated. */
            readonly nodes?: components["schemas"]["GraphNode"][];
            /** @description The subgraph's edges. */
            readonly edges?: components["schemas"]["GraphEdge"][];
        };
        /** @description GetFullGraphResponse is the owner's entire graph. */
        GetFullGraphResponse: {
            /** @description The graph's nodes, deduplicated. */
            readonly nodes?: components["schemas"]["GraphNode"][];
            /** @description The graph's edges. */
            readonly edges?: components["schemas"]["GraphEdge"][];
        };
        /** @description GetGraphStatsResponse summarises the graph's size and composition. */
        GetGraphStatsResponse: {
            /**
             * Format: int32
             * @description The number of memory nodes.
             */
            readonly memoryCount?: number;
            /**
             * Format: int32
             * @description The number of entity nodes.
             */
            readonly entityCount?: number;
            /**
             * Format: int32
             * @description The total number of edges.
             */
            readonly totalEdgeCount?: number;
            /** @description The edge counts broken down by type. */
            readonly edgesByType?: components["schemas"]["EdgeTypeCount"][];
            /** @description The most-connected entities. */
            readonly topEntities?: components["schemas"]["TopEntity"][];
        };
        /** @description GetMemoryGraphResponse is the traversed subgraph. */
        GetMemoryGraphResponse: {
            /** @description The subgraph's nodes, deduplicated. */
            readonly nodes?: components["schemas"]["GraphNode"][];
            /** @description The subgraph's edges. */
            readonly edges?: components["schemas"]["GraphEdge"][];
            /** @description The memory actually used as the seed, as a UUID. */
            readonly seedMemoryId?: string;
        };
        /** @description The user's portfolio, totals as decimal strings in USD. */
        GetPortfolioResponse: {
            /** @description The user's positions. */
            readonly positions?: components["schemas"]["UserPosition"][];
            /** @description The portfolio's total market value. */
            readonly totalValueUsd?: string;
            /** @description The portfolio's total profit-and-loss. */
            readonly totalPnlUsd?: string;
            /** @description The portfolio's total profit-and-loss as a percentage decimal string. */
            readonly totalPnlPercent?: string;
        };
        /** @description Response message for KYCService.GetStatus. */
        GetStatusResponse: {
            overallStatus?: components["schemas"]["KYCState"];
            /** @description True when Persona is approved AND every contributing ramp provider is verified; equivalent to overall_status == KYC_STATUS_VERIFIED. */
            readonly isVerified?: boolean;
            personaStatus?: components["schemas"]["InquiryState"];
            personaDetails?: components["schemas"]["PersonaProviderDetails"];
            /** @description Per-provider ramp verification statuses (Fern, Avenia, etc.) */
            readonly providers?: components["schemas"]["ProviderStatus"][];
            fernStatus?: components["schemas"]["KYCState"];
            fernDetails?: components["schemas"]["FernProviderDetails"];
            nextAction?: components["schemas"]["NextAction"];
            /** @description The URL to open for NEXT_ACTION_PROVIDE_DETAILS. Empty for every other action. */
            readonly actionUrl?: string;
            /** @description The reasons the user cannot transact yet, in plain language. Empty when next_action is NEXT_ACTION_NONE. */
            readonly blockers?: components["schemas"]["Blocker"][];
            /**
             * Format: date-time
             * @description When the identity verification last changed state. Unset until the user has started verification.
             */
            readonly statusChangeTime?: string;
        };
        /** @description Response message for NotificationsService.GetUserDevices. */
        GetUserDevicesResponse: {
            /** @description The user's registered devices. */
            readonly devices?: components["schemas"]["Device"][];
        };
        /** @description Response message for KYCService.GetVerifiedIdentity. */
        GetVerifiedIdentityResponse: {
            /** @description The verified user's identifier, as a UUID. */
            readonly userId?: string;
            /** @description Name */
            readonly firstName?: string;
            /** @description The person's legal middle name, when present on the document. */
            readonly middleName?: string;
            /** @description The person's legal last name. */
            readonly lastName?: string;
            /** @description Date of birth (YYYY-MM-DD format) */
            readonly birthdate?: string;
            address?: components["schemas"]["Address"];
            idClass?: components["schemas"]["IDClass"];
            /** @description The document's issuing country, as an ISO-3166 alpha-2 code. */
            readonly idIssuingCountry?: string;
            /** @description The document's expiry date, as YYYY-MM-DD, when present. */
            readonly idExpirationDate?: string;
            /**
             * Format: date-time
             * @description When the identity was verified
             */
            readonly verifiedAt?: string;
        };
        /** @description Contains an arbitrary serialized message along with a @type that describes the type of the serialized message. */
        GoogleProtobufAny: {
            /** @description The type of the serialized message. */
            "@type"?: string;
        } & {
            [key: string]: unknown;
        };
        /** @description GraphEdge connects two nodes by their composite keys. `predicate` is the edge type (e.g. "MENTIONS", "HOLDS", or a custom relation). `weight` is the edge's strength or confidence depending on edge type; 0 if neither applies. */
        GraphEdge: {
            /** @description The source node's composite key. */
            readonly sourceKey?: string;
            /** @description The target node's composite key. */
            readonly targetKey?: string;
            /** @description The edge type, e.g. "MENTIONS" or "HOLDS". */
            readonly predicate?: string;
            /**
             * Format: double
             * @description The edge's strength or confidence, depending on type; 0 when neither applies.
             */
            readonly weight?: number;
        };
        /** @description GraphNode is a deduplicated node in a returned subgraph. `key` is a stable composite identifier of the form "MEMORY:<uuid>" or "ENTITY:<name>" used by the client to reference the node from edges. */
        GraphNode: {
            /** @description The node's stable composite key, e.g. `"MEMORY:<uuid>"`. */
            readonly key?: string;
            kind?: components["schemas"]["GraphNodeKind"];
            /** @description The memory UUID or the entity name (lower-cased). */
            readonly id?: string;
            /** @description The display label: the memory summary or entity name. */
            readonly label?: string;
            /** @description The owning user's identifier, as a UUID. */
            readonly ownerId?: string;
            /**
             * Format: double
             * @description The node's importance (memory) or degree (entity); 0 if unknown.
             */
            readonly weight?: number;
        };
        /**
         * Format: enum
         * @description GraphNodeKind distinguishes the two node types in the memory graph.
         * @enum {string}
         */
        GraphNodeKind: GraphNodeKind;
        /** @description The gateway's health. */
        HealthCheckResponse: {
            /** @description The gateway\'s status: `ok` when healthy. */
            status?: string;
        };
        /**
         * Format: enum
         * @description IDClass represents the type of government ID
         * @enum {string}
         */
        IDClass: IDClass;
        /** @description One notification in a user's inbox history. */
        InboxItem: {
            /** @description The item's identifier, as a UUID. */
            readonly id?: string;
            /** @description The recipient's identifier, as a UUID. */
            readonly userId?: string;
            /** @description The notification type. */
            readonly type?: string;
            /** @description The rendered title. */
            readonly title?: string;
            /** @description The rendered body. */
            readonly body?: string;
            /** @description The template data the notification was rendered from. */
            data?: {
                [key: string]: string;
            };
            /** @description Whether the user has read the item. */
            readonly isRead?: boolean;
            /** @description The in-app path opened when the item is tapped. */
            readonly url?: string;
            /**
             * Format: date-time
             * @description When the record was created.
             */
            readonly createdAt?: string;
        };
        /**
         * Format: enum
         * @description InquiryState represents the status of a KYC inquiry
         * @enum {string}
         */
        InquiryState: InquiryState;
        /** @description Interest earned on an asset. */
        Interest: {
            /** @description Interest accrued on the current balance, as a decimal string. */
            readonly current?: string;
            /** @description Interest earned over the account's lifetime, as a decimal string. */
            readonly lifetime?: string;
        };
        /** @description Request message for EventsAdminService.IssueEventTickets. Handing a guest tickets is keyed on the event and the guest: a repeat records nothing and fails with EVENT_TICKETS_ALREADY_ISSUED. */
        IssueEventTicketsRequest: {
            /** @description The event's code, as lowercase letters, digits and hyphens. */
            eventCode: string;
            /**
             * Format: uuid
             * @description The guest's user id, as a UUID.
             */
            userId: string;
        };
        /**
         * Format: enum
         * @description The outcome of one fired payment job.
         * @enum {string}
         */
        JobState: JobState;
        /**
         * Format: enum
         * @description KYCState is the normalized unified status across Persona and Fern. Values match users.kyc.v1.KYCState for JSON backward compatibility.
         * @enum {string}
         */
        KYCState: KYCState;
        /** @description LedgerAccount is one side of the double-entry ledger: a user UUID, a counterparty UUID (recipient, linked account, joint account), or a named system account (for example "fees"). */
        LedgerAccount: {
            /** @description Account identifier - a user UUID or system account name. */
            readonly accountId?: string;
            /**
             * Format: date-time
             * @description When the account's first entry was recorded.
             */
            readonly firstEntryTime?: string;
            /**
             * Format: date-time
             * @description When the account's most recent entry was recorded.
             */
            readonly lastEntryTime?: string;
            /**
             * Format: int32
             * @description Number of transactions the account appears in, across all statuses.
             */
            readonly transactionCount?: number;
            /** @description Per-asset totals over the account's confirmed entries, ordered by asset symbol. Empty on ListLedgerAccounts responses; populated by GetLedgerAccount. */
            readonly assets?: components["schemas"]["LedgerAccountAssetSummary"][];
        };
        /** @description LedgerAccountAssetSummary is one asset's confirmed totals for an account. */
        LedgerAccountAssetSummary: {
            /** @description Asset/currency symbol (for example "USDC"). */
            readonly assetSymbol?: string;
            /** @description Confirmed credits minus confirmed debits, as a decimal string. */
            readonly balance?: string;
            /** @description Sum of confirmed credits, as a decimal string. */
            readonly totalCredits?: string;
            /** @description Sum of confirmed debits, as a decimal string. */
            readonly totalDebits?: string;
            /**
             * Format: int32
             * @description Number of confirmed transactions for this asset.
             */
            readonly transactionCount?: number;
        };
        /** @description LifecycleSend is one step the engine sent or skipped. */
        LifecycleSend: {
            /** @description The sequence. */
            sequence?: string;
            /**
             * Format: int32
             * @description The step, from zero.
             */
            step?: number;
            /** @description The message resent, for win-back. */
            messageSequence?: string;
            /**
             * Format: int32
             * @description The step of the message resent.
             */
            messageStep?: number;
            /** @description The goal version used. */
            variant?: string;
            /** @description "sent" or "skipped". */
            outcome?: string;
            /** @description "push" or "email" for a send. */
            channel?: string;
            /** @description Why a step was skipped ("no_channel", "opted_out"). */
            skipReason?: string;
            /** @description The outbox row of a send. */
            outboxId?: string;
            /** @description The outbox row's delivery status. */
            deliveryStatus?: string;
            /** @description The config version that produced it. */
            configVersion?: string;
            /**
             * Format: date-time
             * @description When it was recorded.
             */
            createTime?: string;
            /** @description The user it was for, as a UUID. */
            userId?: string;
            /** @description The user's email. Set on the cross-user summary only; empty when the user has no profile. */
            userEmail?: string;
        };
        /** @description The displayable essentials of a recipient who is another Liminal user. */
        LiminalUserSummary: {
            /** @description The recipient's Liminal user identifier, as a UUID. */
            readonly liminalUserId?: string;
            /** @description @username. */
            readonly displayTag?: string;
            /** @description "John Doe". */
            readonly fullName?: string;
        };
        /** @description LineChart is a multi-series time-series chart rendered as a component. Unlike a single-series Chart it carries one or more named series sharing one time axis, and labels the Y axis with a free-form unit (optional) rather than a currency code. */
        LineChart: {
            /** @description An optional heading. */
            readonly title?: string;
            /** @description An optional context line. */
            readonly subtitle?: string;
            /** @description An optional Y-axis label (e.g. "USD", "%", "ms"). */
            readonly unit?: string;
            /** @description The named series sharing one time axis. */
            readonly series?: components["schemas"]["ChartSeries"][];
        };
        /** @description An external bank account linked to a user. */
        LinkedAccount: {
            /** @description Ramps account ID. */
            readonly id?: string;
            /** @description The owning user's identifier, as a UUID. */
            readonly userId?: string;
            provider?: components["schemas"]["Provider"];
            /** @description Fern payment account ID. */
            readonly providerAccountId?: string;
            /** @description EXTERNAL_BANK_ACCOUNT, etc. */
            readonly type?: string;
            status?: components["schemas"]["LinkedAccount_State"];
            /** @description The name shown for the account in the app. */
            readonly displayName?: string;
            /** @description Last 4 digits. */
            readonly mask?: string;
            /** @description The account's currency, as an ISO 4217 or stablecoin code. */
            readonly currency?: string;
            /** @description The account's country, as an ISO 3166-1 alpha-2 code. */
            readonly country?: string;
            /** @description The payment rail used to reach the account, such as `US_ACH` or `EU_SEPA_CT`. */
            readonly paymentMethod?: string;
            /** @description The bank's name. */
            readonly bankName?: string;
            /**
             * Format: date-time
             * @description When the account was linked.
             */
            readonly createdAt?: string;
            /** @description Bank logo URL. */
            readonly logoUrl?: string;
            bankDetails?: components["schemas"]["BankAccountDetails"];
        };
        /**
         * Format: enum
         * @description LinkedAccount.State represents the status of a linked bank account.
         * @enum {string}
         */
        LinkedAccount_State: LinkedAccount_State;
        /** @description A user's linked external accounts. */
        ListAccountsResponse: {
            /** @description The linked accounts, unordered. */
            readonly accounts?: components["schemas"]["LinkedAccount"][];
        };
        /** @description Response message for EventsAdminService.ListEventTicketIssuances. */
        ListEventTicketIssuancesResponse: {
            /** @description The issuances on this page, most recent first. */
            eventTicketIssuances?: components["schemas"]["EventTicketIssuance"][];
            /** @description The token for the next page. Empty when this is the last page. */
            nextPageToken?: string;
            /**
             * Format: int32
             * @description How many guests of the event have been handed tickets, across every page.
             */
            totalSize?: number;
            /**
             * Format: int32
             * @description How many tickets the event's guests have been handed, across every page: the tally the venue's bill is settled from.
             */
            totalTicketCount?: number;
        };
        /** @description Response message for NotificationsService.ListInbox. */
        ListInboxResponse: {
            /** @description The inbox items, newest first. */
            readonly items?: components["schemas"]["InboxItem"][];
            /**
             * Format: int32
             * @description The total number of items across all pages.
             */
            readonly total?: number;
            /**
             * Format: int32
             * @description The number of unread items.
             */
            readonly unreadCount?: number;
        };
        /** @description ListLedgerAccountsResponse returns a page of accounts. */
        ListLedgerAccountsResponse: {
            /** @description Accounts ordered by most recent entry first, without per-asset totals. */
            readonly accounts?: components["schemas"]["LedgerAccount"][];
            /** @description Token to retrieve the next page of results. Empty when there are no more pages. */
            readonly nextPageToken?: string;
        };
        /** @description One page of calls. */
        ListNimCallsResponse: {
            /** @description The calls on this page, newest first. */
            calls?: components["schemas"]["NimCall"][];
            /** @description The token for the next page. Empty when this is the last page. */
            nextPageToken?: string;
        };
        /** @description One page of fired jobs. */
        ListPaymentScheduleJobsResponse: {
            /** @description The jobs on this page, newest first. */
            readonly jobs?: components["schemas"]["PaymentScheduleJob"][];
            /** @description The token for the next page. Empty when this is the last page. */
            readonly nextPageToken?: string;
        };
        /** @description One page of schedules. */
        ListPaymentSchedulesResponse: {
            /** @description The schedules on this page. */
            readonly schedules?: components["schemas"]["PaymentSchedule"][];
            /** @description The token for the next page. Empty when this is the last page. */
            readonly nextPageToken?: string;
        };
        /** @description A page of the user's saved recipients. */
        ListRecipientsResponse: {
            /** @description The recipients on this page. */
            readonly recipients?: components["schemas"]["Recipient"][];
            /**
             * Format: int32
             * @description The total number of recipients the user has saved.
             */
            readonly total?: number;
        };
        /** @description Response message for RewardsAdminService.ListRewardBudgets. */
        ListRewardBudgetsResponse: {
            /** @description The budgets on this page. */
            rewardBudgets?: components["schemas"]["RewardBudget"][];
            /** @description A token for the next page, empty on the last. */
            nextPageToken?: string;
        };
        /** @description Response message for RewardsAdminService.ListRewardMerchantRevisions. */
        ListRewardMerchantRevisionsResponse: {
            /** @description The merchant at each revision, newest first. */
            rewardMerchants?: components["schemas"]["RewardMerchant"][];
            /** @description A token for the next page, empty on the last. */
            nextPageToken?: string;
        };
        /** @description Response message for RewardsAdminService.ListRewardMerchants. */
        ListRewardMerchantsResponse: {
            /** @description The merchants on this page. */
            rewardMerchants?: components["schemas"]["RewardMerchant"][];
            /** @description A token for the next page, empty on the last. */
            nextPageToken?: string;
        };
        /** @description Response message for RewardsAdminService.ListRewardPayments. */
        ListRewardPaymentsResponse: {
            /** @description The payments on this page. */
            rewardPayments?: components["schemas"]["RewardPayment"][];
            /** @description A token for the next page, empty on the last. */
            nextPageToken?: string;
        };
        /** @description ListTransactionsResponse returns a list of transactions */
        ListTransactionsResponse: {
            /** @description List of transactions matching the filter criteria Ordered by create_time in descending order (newest first) */
            readonly transactions?: components["schemas"]["Transaction"][];
            /** @description Token to retrieve the next page of results Empty string if there are no more pages */
            readonly nextPageToken?: string;
        };
        /** @description One page of a user's on-chain transactions, as the admin dashboard renders them. Like ListUserWalletsResponse, the admin surface carries its own shape rather than the wallets service's resource. */
        ListUserWalletTransactionsResponse: {
            /** @description The matching transactions. A page shorter than the requested limit is the last one — the wallets service reports no count (AIP-158). */
            transactions?: components["schemas"]["AdminWalletTransaction"][];
        };
        /** @description One user's Safe wallets, as the admin dashboard renders them. The admin surface carries its own shape rather than the wallets service's resource, so a change to that resource is a deliberate edit here and not a silent change to the dashboard's contract. */
        ListUserWalletsResponse: {
            /** @description The user's wallets. */
            wallets?: components["schemas"]["AdminWallet"][];
        };
        /** @description MemoryEntry is one stored memory as shown in the admin view. */
        MemoryEntry: {
            /** @description The memory's identifier, as a UUID. */
            readonly id?: string;
            /** @description The owning user's identifier, as a UUID. */
            readonly ownerId?: string;
            /** @description The memory's human-readable summary. */
            readonly contentSummary?: string;
            /** @description The operation that produced the entry: "ADD", "UPDATE", "DELETE". */
            readonly operation?: string;
            /** @description The conversation the memory came from, as a UUID. */
            readonly conversationId?: string;
            /** @description When the memory was created, as an RFC3339 timestamp. */
            readonly createdAt?: string;
            /** @description When the memory last changed, as an RFC3339 timestamp. */
            readonly updatedAt?: string;
            /** @description When the memory was deleted, as an RFC3339 timestamp. Empty when not deleted. */
            readonly deletedAt?: string;
        };
        /** @description One way a Pix payee is recognised as a merchant. */
        MerchantIdentity: {
            type: components["schemas"]["MerchantIdentity_Type"];
            /** @description The identity, as typed by the operator; the service stores it canonically. */
            value: string;
        };
        /**
         * Format: enum
         * @description The kinds of identity a merchant is matched on.
         * @enum {string}
         */
        MerchantIdentity_Type: MerchantIdentity_Type;
        /** @description A labelled link a partner merchant's page shows as a button. */
        MerchantLink: {
            /** @description What the button says, for example "Instagram" or "Menu". */
            label: string;
            /**
             * Format: uri
             * @description Where the link goes, as an https URI.
             */
            uri: string;
        };
        /** @description A place customers can visit a partner merchant, pinned on the map. A location at exactly 0, 0 is refused as one sent without its coordinates. */
        MerchantLocation: {
            /** @description What customers call the place, for example "Pinheiros". */
            label: string;
            /**
             * Format: double
             * @description The place's latitude, in decimal degrees from -90 to 90.
             */
            latitude?: number;
            /**
             * Format: double
             * @description The place's longitude, in decimal degrees from -180 to 180.
             */
            longitude?: number;
            /** @description The place's address as one line for display. Empty when none is given. */
            address?: string;
        };
        /** @description Message represents a single message in a conversation */
        Message: {
            /** @description The message's identifier, as a UUID. */
            readonly id?: string;
            /** @description The author role: "user", "assistant" or "system". */
            readonly role?: string;
            /** @description The message text. */
            readonly content?: string;
            /**
             * Format: date-time
             * @description When the message was created.
             */
            readonly createdAt?: string;
            /** @description The tools used while producing the message. */
            readonly toolsUsed?: components["schemas"]["ToolUse"][];
            pendingAction?: components["schemas"]["PendingAction"];
            actionResult?: components["schemas"]["ActionResult"];
            /** @description Structured display blocks the client renders inline (e.g. a transaction list), in original order. Rehydrated from storage on history fetch so a resumed conversation re-renders the components instead of bare text. */
            readonly blocks?: components["schemas"]["DisplayBlock"][];
        };
        /**
         * Format: enum
         * @description NextAction is the single step a user can take next toward being able to transact. Exactly one applies at a time.
         * @enum {string}
         */
        NextAction: NextAction;
        /** @description NimAnnouncement is an admin-composed message that opens each user's next new Nim conversation, once per user. */
        NimAnnouncement: {
            /** @description The announcement's identifier, as a UUID. */
            readonly id?: string;
            /** @description The announcement's message text. */
            readonly content?: string;
            /** @description The admin who created the announcement, as an email address. */
            readonly createdBy?: string;
            /** @description A human-readable description of the audience, when one was recorded. */
            readonly audienceDescription?: string;
            /**
             * Format: int32
             * @description Snapshot size for a targeted announcement; unset for an all-users one (membership is resolved lazily at delivery, so there is no snapshot).
             */
            readonly recipientCount?: number;
            /**
             * Format: int32
             * @description Users who have received the message in a conversation so far.
             */
            readonly deliveredCount?: number;
            /**
             * Format: date-time
             * @description When the announcement was cancelled. Unset while live.
             */
            readonly cancelledAt?: string;
            /**
             * Format: date-time
             * @description When the announcement was created.
             */
            readonly createdAt?: string;
            /** @description True for an all-users announcement: delivered to every user — including ones who sign up after the send — until cancelled. */
            readonly allUsers?: boolean;
            /** @description The text of the button under the message. Empty when the message has no button. */
            readonly buttonLabel?: string;
            /** @description The page the button opens, as an HTTPS URL. Empty when the message has no button. */
            readonly buttonUri?: string;
        };
        /** @description NimAudience is the write-path targeting for an announcement. Criteria filters are resolved to a concrete user-id snapshot by admin_api at create time, so downstream services only ever see ALL or USER_IDS. Read paths expose only audience_kind + audience_description + audience_size — never the id array. */
        NimAudience: {
            kind?: components["schemas"]["NimAudienceKind"];
            /** @description Concrete user-id snapshot; required (non-empty) iff kind = USER_IDS. */
            userIds?: string[];
            /** @description Human-readable audit description, e.g. "filters: kyc=approved (123 users)". */
            description?: string;
            filters?: components["schemas"]["NimAudienceFilters"];
        };
        /** @description ===== ADMIN ANNOUNCEMENT TYPES ===== NimAudienceFilters mirrors the admin user-search filters (AdminSearchUsers). */
        NimAudienceFilters: {
            /** @description A free-text user search query. */
            query?: string;
            /** @description A KYC status to filter users by. */
            kycStatusFilter?: string;
            /** @description A device platform to filter users by. */
            platformFilter?: string;
        };
        /**
         * Format: enum
         * @description NimAudienceKind is how an announcement's recipients are chosen.
         * @enum {string}
         */
        NimAudienceKind: NimAudienceKind;
        /** @description A call between a user and Nim, from the moment it was started or placed: who started or placed it, what it was placed to say and about, and how it went. A call's record is kept after it ends. */
        NimCall: {
            /** @description The call's unique identifier, as a UUID. */
            readonly callId?: string;
            /** @description The user on the call, as a UUID. */
            readonly userId?: string;
            state?: components["schemas"]["NimCall_State"];
            initiator?: components["schemas"]["NimCallInitiator"];
            /** @description The identifier of whoever started or placed the call, in the initiator's own terms: for NIM_CALL_INITIATOR_ADMIN the email of the operator who placed it, for a call the user started the user's identifier, and otherwise the agent turn's or the scheduled task's. */
            readonly initiatorId?: string;
            /** @description What Nim was placed to call about, as the instruction Nim was given. The user never sees it. Empty for a call the user started. */
            readonly brief?: string;
            /** @description What Nim was placed to call about, as the short phrase the user reads after "about" should they miss or decline the call. Empty for a call the user started. */
            readonly reason?: string;
            /** @description The Nim conversation the call continues, as a UUID: where its transcript is. Empty while it is not known: a call placed to open a new conversation, as every operator's call is, opens it when it is answered. */
            readonly conversationId?: string;
            /** @description Whether Liminal pays for the call instead of the user, as the operator who placed it chose. */
            readonly waiveUserCredits?: boolean;
            /** @description Whether Nim could only talk and look things up on the call, as the operator who placed it chose. */
            readonly readOnlyTools?: boolean;
            /**
             * Format: date-time
             * @description When the call was started or placed, in UTC.
             */
            readonly createTime?: string;
            /**
             * Format: date-time
             * @description When the call was answered, in UTC. Unset for a call that has not been answered.
             */
            readonly answerTime?: string;
            /**
             * Format: date-time
             * @description When the call ended or stopped ringing, in UTC. Unset while it rings or is live.
             */
            readonly endTime?: string;
            endReason?: components["schemas"]["NimCallEndReason"];
            /** @description How long the call was live, from when it was answered to when it ended. Unset for a call that was never answered, or is live. */
            readonly liveDuration?: string;
        };
        /**
         * Format: enum
         * @description Why a call with Nim ended, or why it stopped ringing.
         * @enum {string}
         */
        NimCallEndReason: NimCallEndReason;
        /**
         * Format: enum
         * @description Who started or placed a call with Nim.
         * @enum {string}
         */
        NimCallInitiator: NimCallInitiator;
        /**
         * Format: enum
         * @description Where a call is in its life.
         * @enum {string}
         */
        NimCall_State: NimCall_State;
        /** @description NimTransaction is a single row in a TransactionList. */
        NimTransaction: {
            /** @description The transaction's identifier. */
            readonly id?: string;
            /** @description When the transaction happened, as an ISO 8601 / RFC 3339 timestamp. */
            readonly date?: string;
            /** @description The merchant or counterparty name. */
            readonly merchant?: string;
            /** @description The amount, as a decimal string — money must never deserialize as a number. */
            readonly amount?: string;
            /** @description The amount's currency code. */
            readonly currency?: string;
            /** @description "credit". */
            readonly direction?: string;
        };
        /** @description A user's notification delivery choices. */
        NotificationPreferences: {
            /** @description Unique identifier for the user (UUID format, e.g., "550e8400-e29b-41d4-a716-446655440000") */
            readonly userId?: string;
            /** @description Whether email notifications are enabled for this user */
            readonly emailEnabled?: boolean;
            /** @description Whether web push notifications are enabled (desktop/web browser) */
            readonly webPushEnabled?: boolean;
            /** @description Whether mobile push notifications are enabled (iOS/Android) */
            readonly mobilePushEnabled?: boolean;
            /** @description Whether SMS text message notifications are enabled */
            readonly smsEnabled?: boolean;
            /** @description Whether WhatsApp message notifications are enabled */
            readonly whatsappEnabled?: boolean;
            /** @description Type-specific notification preferences for granular control Keys are notification types (e.g., "payment.incoming_settled", "payment.request_received") Values are boolean indicating if that notification type is enabled Example: {"payment.incoming_settled": true, "payment.request_received": false} */
            typePreferences?: {
                [key: string]: boolean;
            };
            /**
             * Format: date-time
             * @description Timestamp when the preferences were created (RFC 3339 format)
             */
            readonly createdAt?: string;
            /**
             * Format: date-time
             * @description Timestamp when the preferences were last updated (RFC 3339 format)
             */
            readonly updatedAt?: string;
        };
        /**
         * Format: enum
         * @description What a user came to Liminal for, picked in the Nim onboarding chat.
         * @enum {string}
         */
        OnboardingGoal: OnboardingGoal;
        /**
         * Format: enum
         * @description OwnerType identifies the account holder type for bank accounts.
         * @enum {string}
         */
        OwnerType: OwnerType;
        /** @description Request message for RewardsAdminService.PauseRewardBudget. */
        PauseRewardBudgetRequest: {
            /** @description The budget to pause, as `rewardBudgets/{reward_budget}`. */
            name: string;
            /** @description The etag the budget was read with. */
            etag: string;
            /**
             * Format: uuid
             * @description The idempotency key, as a UUID: minted once by the client when the form opens and sent again on a retry, so a retried change is made once.
             */
            requestId: string;
        };
        /** @description Request message for RewardsAdminService.PauseRewardMerchant. */
        PauseRewardMerchantRequest: {
            /** @description The merchant to pause, as `rewardMerchants/{reward_merchant}`. */
            name: string;
            /** @description The etag the merchant was read with. */
            etag: string;
            /** @description Why the merchant is paused. */
            reason: string;
            /**
             * Format: uuid
             * @description The idempotency key, as a UUID: minted once by the client when the form opens and sent again on a retry, so a retried change is made once.
             */
            requestId: string;
        };
        /** @description One Pay with LIL level on a merchant's rates: the most USD a Pay with LIL choice at that level returns, and the LIL it costs. */
        PayLevel: {
            /** @description The level's USD, as a decimal string (for example "10"). Must be greater than zero and greater than the level before it. */
            usd: string;
            /** @description The LIL the level costs, as a decimal string: its USD at the redeem rate, rounded up to a whole LIL. Set by the rewards service from the rates, and never read from a request. */
            readonly lil?: string;
        };
        /** @description A recurring payment: who to pay, how much, and when. */
        PaymentSchedule: {
            /** @description The schedule's unique identifier, as a UUID. */
            readonly id?: string;
            /** @description The schedule's owner, as a UUID. */
            readonly userId?: string;
            /** @description The recipient the schedule pays, as a UUID. */
            readonly recipientId?: string;
            recipientType?: components["schemas"]["RecipientType"];
            /** @description The amount paid each occurrence, as a decimal string. */
            readonly amount?: string;
            /** @description The currency the amount is denominated in, as an ISO-4217 code (for example "USD"). */
            readonly currency?: string;
            /** @description The five-field cron expression naming the occurrences, interpreted in `timezone`. */
            readonly cron?: string;
            /**
             * Format: int32
             * @description The chain payments are made on.
             */
            readonly chainId?: number;
            /** @description The schedule's display name. */
            readonly name?: string;
            /** @description The schedule's free-form description. */
            readonly description?: string;
            status?: components["schemas"]["ScheduleState"];
            /**
             * Format: date-time
             * @description When the next payment fires, in UTC. Absent when the schedule is not active.
             */
            readonly nextPayment?: string;
            /**
             * Format: date-time
             * @description When the schedule was created.
             */
            readonly createdAt?: string;
            /**
             * Format: date-time
             * @description When the schedule was last updated.
             */
            readonly updatedAt?: string;
            /** @description IANA timezone name (e.g. "America/Los_Angeles") in which the cron expression is evaluated. Always populated; legacy rows return "UTC". */
            readonly timezone?: string;
            /**
             * Format: int32
             * @description Fires only every Nth matching week: 1 = every week, 2 = every other week. Always populated; rows predating the column return 1.
             */
            readonly weekInterval?: number;
        };
        /** @description One payment fired by a schedule. */
        PaymentScheduleJob: {
            /** @description The job's unique identifier, as a UUID. */
            readonly id?: string;
            /** @description The schedule that fired the job, as a UUID. */
            readonly scheduleId?: string;
            status?: components["schemas"]["JobState"];
            /** @description The ledger transaction recording the payment, as a UUID. Set once the payment is recorded. */
            readonly ledgerTransactionId?: string;
            /** @description The on-chain transaction hash. Set once submitted. */
            readonly transactionHash?: string;
            /** @description Why the job failed. Set only when `status` is `JOB_STATUS_FAILED`. */
            readonly error?: string;
            /**
             * Format: int32
             * @description How many times the job has been retried.
             */
            readonly retryCount?: number;
            /**
             * Format: date-time
             * @description The occurrence the job pays, in UTC.
             */
            readonly effectiveAt?: string;
            /**
             * Format: date-time
             * @description When the job actually executed. Unset while pending.
             */
            readonly executedAt?: string;
            /**
             * Format: date-time
             * @description When the job was created.
             */
            readonly createdAt?: string;
        };
        /** @description PendingAction represents an action awaiting confirmation */
        PendingAction: {
            /** @description The pending action's identifier, as a UUID. */
            readonly id?: string;
            /** @description The tool the action would run. */
            readonly tool?: string;
            /** @description A human-readable summary of what the action would do. */
            readonly summary?: string;
            /** @description The tool's input, as a JSON string. */
            readonly input?: string;
        };
        /** @description PersonaDecisionDetail is a single auto-decisioner output for a Persona inquiry. */
        PersonaDecisionDetail: {
            /** @description The Persona inquiry identifier. */
            readonly inquiryId?: string;
            /** @description The decision: "approve", "decline", or "review". */
            readonly decision?: string;
            /** @description The human-readable reason for the decision. */
            readonly decisionReason?: string;
            /** @description The inquiry's Persona status at decision time. */
            readonly personaStatus?: string;
            /** @description The assessed threat level. */
            readonly threatLevel?: string;
            /**
             * Format: date-time
             * @description When the record was created.
             */
            readonly createdAt?: string;
        };
        /** @description PersonaInquiryDetail is a single Persona inquiry with timestamps and identity fields. */
        PersonaInquiryDetail: {
            /** @description The Persona inquiry identifier. */
            readonly inquiryId?: string;
            status?: components["schemas"]["InquiryState"];
            /** @description When Persona created the inquiry, as RFC 3339. */
            readonly createdAt?: string;
            /** @description When the user completed the inquiry, as RFC 3339. */
            readonly completedAt?: string;
            /** @description When the inquiry was decisioned, as RFC 3339. */
            readonly decisionedAt?: string;
            /** @description The inquiry's identity fields, flattened to string values. */
            fields?: {
                [key: string]: string;
            };
        };
        /**
         * Format: enum
         * @description InquiryState represents the status of a KYC inquiry
         * @enum {string}
         */
        PersonaInquiryState: PersonaInquiryState;
        /** @description PersonaProviderDetails contains Persona-specific KYC decision information. */
        PersonaProviderDetails: {
            /** @description Persona inquiry ID (inq_xxx) */
            readonly inquiryId?: string;
            /** @description Automated decision result: "approve", "decline", "review" */
            readonly decision?: string;
            /** @description Human-readable reason for the decision */
            readonly decisionReason?: string;
        };
        /** @description Request for NimAdminService.PlaceNimCall. */
        PlaceNimCallRequest: {
            /**
             * Format: uuid
             * @description The user to call, as a UUID.
             */
            userId: string;
            /** @description What Nim is calling about, as an instruction to Nim: what to tell the user or ask them, for example the questions of a research call. Nim opens the call with it, in its own words, as soon as the user answers, and holds to it. The user never sees it, and it is never written to the call's conversation. Up to 8000 characters. */
            brief: string;
            /** @description What Nim is calling about, as a short phrase the user reads after "about" (for example "how you are finding Liminal so far"). If the user misses or declines the call, they are told Nim tried to call them about it, in a push and in their chat with Nim. Unlike the brief, the user sees it, so it carries none of the brief's instructions. Up to 120 characters. */
            reason: string;
            /** @description Whether Liminal pays for the call instead of the user: the call is not held to the user's Nim credits, and none of its usage counts against them. Unset, the call is charged to the user as any call is. */
            waiveUserCredits?: boolean;
            /** @description Whether Nim may only talk and look things up on the call: it can make no change on the user's account, so no confirmation card is shown. Unset, Nim has its full toolset as on any call. */
            readOnlyTools?: boolean;
            /**
             * Format: uuid
             * @description The caller's idempotency key, as a UUID unique to this call: send the same one again to retry the request, and the call it placed is returned instead of another being placed. Omit it to have the gateway mint one.
             */
            requestId?: string;
        };
        /** @description The call PlaceNimCall placed. */
        PlaceNimCallResponse: {
            /** @description The call's unique identifier, as a UUID. The same request_id always yields the same call_id. */
            readonly callId?: string;
            state?: components["schemas"]["NimCall_State"];
        };
        /** @description PlannedNudge is one step still to come in the running sequence. */
        PlannedNudge: {
            /** @description The sequence. */
            sequence?: string;
            /**
             * Format: int32
             * @description The step, from zero.
             */
            step?: number;
            /**
             * Format: date-time
             * @description When it is expected to go out, after quiet hours and the gap.
             */
            sendTime?: string;
            /** @description How it reaches the user: "push_then_email" or "email_only". */
            channelPolicy?: string;
            /** @description The push title, or the email subject for email-only sequences. */
            title?: string;
            /** @description The user it goes to, as a UUID. Set on the cross-user summary only. */
            userId?: string;
            /** @description The user's email. Set on the cross-user summary only; empty when the user has no profile. */
            userEmail?: string;
        };
        /**
         * Format: enum
         * @description A device platform.
         * @enum {string}
         */
        Platform: Platform;
        /**
         * Format: enum
         * @description PortfolioPeriod selects the time window for period-scoped profit-and-loss figures. UNSPECIFIED is treated as ALL, so callers that send no period receive lifetime figures.
         * @enum {string}
         */
        PortfolioPeriod: PortfolioPeriod;
        /** @description One position's contribution to an asset balance. */
        PositionBalance: {
            /** @description The chain the position lives on. */
            readonly chain?: string;
            /** @description The protocol whose vault holds the position. */
            readonly protocol?: string;
            /** @description The vault's display name. */
            readonly vaultName?: string;
            /** @description The vault's contract address. */
            readonly vaultAddress?: string;
            /** @description The position's current asset value, as a decimal string. */
            readonly balance?: string;
            /** @description The vault shares the position owns, as a decimal string. */
            readonly shareBalance?: string;
            /** @description The sustainable, compounding yield as a percentage string (for example "8.50"). */
            readonly baseApy?: string;
            /** @description The non-compounding token-reward rate as a percentage string (for example "2.30"). */
            readonly rewardsApr?: string;
        };
        /** @description A user's profile: identity, display details, and verification state. */
        Profile: {
            /** @description Unique identifier for the user (UUID format, e.g., "550e8400-e29b-41d4-a716-446655440000") */
            readonly userId?: string;
            /** @description User's email address (e.g., "john.doe@example.com") */
            readonly email?: string;
            /** @description User's first/given name (e.g., "John") */
            readonly firstName?: string;
            /** @description User's last/family name (e.g., "Doe") */
            readonly lastName?: string;
            /** @description Unique username for display and mentions, formatted as @username (e.g., "@john_doe") Must be 3-15 characters of letters, digits, hyphens and underscores, starting and ending alphanumeric, and must contain at least one letter */
            readonly displayTag?: string;
            /** @description User's phone number in E.164 format (e.g., "+1234567890") */
            readonly phoneNumber?: string;
            /** @description Hex color code for user's avatar background (e.g., "#FF5733") */
            readonly avatarColor?: string;
            /**
             * Format: date-time
             * @description Timestamp when the profile was created (RFC 3339 format)
             */
            readonly createdAt?: string;
            /**
             * Format: date-time
             * @description Timestamp when the profile was last updated (RFC 3339 format)
             */
            readonly updatedAt?: string;
            /** @description Whether the user has completed the onboarding flow */
            readonly isOnboardingCompleted?: boolean;
            /** @description The billing tier the user is on. */
            readonly tier?: string;
            /** @description Date of birth in YYYY-MM-DD format (e.g., "1990-01-15") */
            dateOfBirth?: string;
            /** @description Nationality as ISO 3166-1 alpha-2 code (e.g., "GB", "US") */
            readonly nationality?: string;
            /** @description Legal first name (may differ from display given_name) */
            readonly legalFirstName?: string;
            /** @description Legal middle name */
            readonly legalMiddleName?: string;
            /** @description Legal last name (may differ from display family_name) */
            readonly legalLastName?: string;
            /** @description Whether the user's phone number has been verified via SMS */
            readonly phoneNumberVerified?: boolean;
            /** @description Whether the user has completed the mandatory onboarding chat with Nim. Set by the nim onboarding service on completion; cleared by the admin reset action to send the user back through the chat. */
            readonly isOnboardingChatCompleted?: boolean;
            /** @description The handle this user previously went by, empty if they have never changed it. It stays reserved to them and still resolves to them, and its presence means their one handle change has been used. */
            readonly previousDisplayTag?: string;
            /** @description The user's IANA time zone as their phone last reported it (e.g., "Europe/London"); empty until the app has sent one. */
            readonly timeZone?: string;
            onboardingGoal?: components["schemas"]["OnboardingGoal"];
            acquisitionSource?: components["schemas"]["AcquisitionSource"];
            /** @description The user's own words when `acquisition_source` is OTHER; empty otherwise. */
            readonly acquisitionSourceDetail?: string;
        };
        /**
         * Format: enum
         * @description Provider identifies a ramp provider for routing operations.
         * @enum {string}
         */
        Provider: Provider;
        /** @description ProviderStatus contains the verification status and details for a single ramp provider. */
        ProviderStatus: {
            provider?: components["schemas"]["RampProvider"];
            status?: components["schemas"]["KYCState"];
            /** @description The provider-assigned customer identifier. */
            readonly providerCustomerId?: string;
            /** @description The provider's raw status string. */
            readonly rawStatus?: string;
            /** @description The URL where the user completes the provider's verification. */
            readonly verificationLink?: string;
            /** @description Issues preventing verification. */
            readonly verificationIssues?: components["schemas"]["VerificationIssue"][];
            /** @description The payment methods the provider currently offers the user. */
            readonly availablePaymentMethods?: string[];
            /** @description Per-rail availability forwarded from the ramps service: each entry is tagged with this provider plus its currency, payment method, direction, and availability. */
            readonly rails?: components["schemas"]["RampRailAvailability"][];
        };
        /** @description ===== ADMIN PUSH ANNOUNCEMENT TYPES ===== A push notification sent to an audience, immediately or at a scheduled time. */
        PushAnnouncement: {
            /** @description The push announcement's identifier, as a UUID. */
            readonly id?: string;
            /** @description The push title. */
            readonly title?: string;
            /** @description The push body. */
            readonly message?: string;
            status?: components["schemas"]["PushAnnouncement_State"];
            /**
             * Format: date-time
             * @description When the fan-out runs.
             */
            readonly sendAt?: string;
            /** @description The email of the admin who created it. */
            readonly createdBy?: string;
            /**
             * Format: int32
             * @description Users targeted by the fan-out; set once sending completes.
             */
            readonly recipientCount?: number;
            /**
             * Format: date-time
             * @description When the fan-out completed.
             */
            readonly sentAt?: string;
            /**
             * Format: date-time
             * @description When it was cancelled.
             */
            readonly cancelledAt?: string;
            /**
             * Format: date-time
             * @description When the record was created.
             */
            readonly createdAt?: string;
            /**
             * Format: date-time
             * @description When the record was last updated.
             */
            readonly updatedAt?: string;
            /** @description Internal app path opened when the user taps the push (e.g. /savings). */
            readonly url?: string;
            audienceKind?: components["schemas"]["AudienceKind"];
            /** @description The human-readable audience description. */
            readonly audienceDescription?: string;
            /**
             * Format: int32
             * @description Number of users in the snapshot; unset when audience_kind = ALL.
             */
            readonly audienceSize?: number;
            /** @description The in-app announcement this push was sent alongside, as a UUID; unset for a push created on its own. */
            readonly announcementId?: string;
        };
        /**
         * Format: enum
         * @description PushAnnouncement.State is a push announcement's delivery lifecycle state.
         * @enum {string}
         */
        PushAnnouncement_State: PushAnnouncement_State;
        /** @description Response message for RewardsAdminService.QueryRewardProgramme. Balances come from wallets and carry the time they were read; the budget counters are Rewards' own. Neither is netted against the other. */
        QueryRewardProgrammeResponse: {
            /** @description Every budget's counters, newest first. */
            budgets?: components["schemas"]["RewardBudgetFigures"][];
            /** @description USD every live redemption may still draw from the treasury, as a decimal string. */
            owedUsd?: string;
            /**
             * Format: int32
             * @description Redemptions whose LIL was collected and whose USD has not reached the customer within the owed alert window.
             */
            owedTooLongCount?: number;
            /** @description The treasury Safe's on-chain address. */
            treasurySafeAddress?: string;
            /** @description USDC the treasury Safe holds, as a decimal string. */
            treasuryUsdc?: string;
            /** @description LIL the treasury Safe holds, as a decimal string. */
            treasuryLil?: string;
            /**
             * Format: date-time
             * @description When the treasury balances were read from wallets.
             */
            balanceReadTime?: string;
            /** @description The treasury's USDC less what live redemptions may still draw, as a decimal string. */
            headroomUsd?: string;
            /** @description The headroom below which the treasury is low on funds, as a decimal string. */
            lowFundsThresholdUsd?: string;
            /** @description Whether the headroom is below the low-funds threshold. */
            lowFunds?: boolean;
            /** @description How long a redemption may stay owed, untouched, before it counts in owed_too_long_count and alerts. */
            owedAlertDuration?: string;
        };
        /** @description A postal address. */
        RampAddress: {
            /** @description The street address, including the number. */
            street?: string;
            /** @description The city. */
            city?: string;
            /** @description The state, province, or region. */
            state?: string;
            /** @description The postal or ZIP code. */
            postalCode?: string;
            /** @description The country, as an ISO 3166-1 alpha-2 code. */
            country?: string;
            /** @description The second street line, when present. */
            streetLine2?: string;
        };
        /**
         * Format: enum
         * @description Availability narrates the four outcomes for a rail: approved, still under provider review, unavailable in the customer's region, or revoked. Decoded downstream into UI copy.
         * @enum {string}
         */
        RampAvailability: RampAvailability;
        /**
         * Format: enum
         * @description Currency identifies a fiat or blockchain currency by ISO 4217 code. Numbering: 0 = unspecified, 1000+ = fiat (alphabetical), 2000+ = blockchain.
         * @enum {string}
         */
        RampCurrency: RampCurrency;
        /**
         * Format: enum
         * @description Direction is which way money moves on a rail from the customer's perspective. Onramp = fiat lands in the customer's Liminal balance (vIBAN / deposit account). Offramp = fiat leaves the Liminal balance to an external bank account.
         * @enum {string}
         */
        RampDirection: RampDirection;
        /**
         * Format: enum
         * @description PaymentMethod identifies an individual payment rail using canonical CC_SCHEME naming. Each adapter maps these to provider-specific identifiers. Numbering:   0         = UNSPECIFIED   1-9999    = Blockchain networks   10000-12499 = Americas domestic (10 slots per country, alphabetical)   12500-14999 = Europe domestic   15000-17499 = Middle East & Africa domestic   17500-19999 = Asia Pacific domestic   30000-39999 = Cross-border / global schemes   40000-49999 = Card networks Reference: core/rails/adapters/proto/PAYMENT_SCHEMES.md
         * @enum {string}
         */
        RampPaymentMethod: RampPaymentMethod;
        /**
         * Format: enum
         * @description Provider identifies a ramp provider for routing operations.
         * @enum {string}
         */
        RampProvider: RampProvider;
        /** @description RailAvailability is the orchestrator-level view of a single payment rail's availability: the adapter.v1.RailAvailability payload plus an explicit Provider tag so rails stay self-describing when consumers flat-map across ProviderCustomerStatus entries (e.g. a future unified "which offramps can this user use" view). Reuses the adapter.v1 enums for currency, payment_method, direction, availability — single source of truth lives in adapter.v1. */
        RampRailAvailability: {
            provider?: components["schemas"]["RampProvider"];
            currency?: components["schemas"]["RampCurrency"];
            paymentMethod?: components["schemas"]["RampPaymentMethod"];
            direction?: components["schemas"]["RampDirection"];
            status?: components["schemas"]["RampAvailability"];
            /** @description A human-readable note on the availability, when there is one. */
            readonly detail?: string;
        };
        /**
         * Format: enum
         * @description RampRecipientType identifies what kind of recipient account is stored. This affects how we look up accounts and create provider mappings.
         * @enum {string}
         */
        RampRecipientType: RampRecipientType;
        /** @description One problem a provider raised with a customer's verification. */
        RampVerificationIssue: {
            /** @description The provider's machine-readable issue code. */
            readonly code?: string;
            /** @description The provider's human-readable description of the issue. */
            readonly message?: string;
            /** @description When the provider raised the issue, as an RFC 3339 string. */
            readonly timestamp?: string;
        };
        /** @description A saved destination the user can withdraw to: a bank account, a crypto wallet, or another Liminal user. */
        Recipient: {
            /** @description The recipient's identifier, as a UUID. */
            readonly id?: string;
            /** @description Owner of this recipient. */
            readonly userId?: string;
            /** @description The recipient's email address. */
            readonly email?: string;
            /** @description The recipient's first name, for individual recipients. */
            readonly firstName?: string;
            /** @description The recipient's last name, for individual recipients. */
            readonly lastName?: string;
            /** @description A display name the user chose for the recipient. */
            readonly nickname?: string;
            recipientType?: components["schemas"]["RampRecipientType"];
            bankSummary?: components["schemas"]["BankAccountSummary"];
            walletSummary?: components["schemas"]["WalletSummary"];
            liminalUserSummary?: components["schemas"]["LiminalUserSummary"];
            /**
             * Format: date-time
             * @description When the recipient was created.
             */
            readonly createdAt?: string;
            /**
             * Format: date-time
             * @description When the recipient was last modified.
             */
            readonly updatedAt?: string;
            /** @description Deprecated: pass `id` (the Liminal recipient UUID) to `CreateWithdrawQuote.destination_account_id` instead; the adapter resolves it to the chosen provider's external account id. A recipient held at more than one provider reports its newest account here. */
            readonly providerAccountId?: string;
            /** @description Avatar color for display (hex color code, e.g., "#5aa193") For LIMINAL_USER: fetched from user's profile For BANK_ACCOUNT: generated from recipient ID */
            readonly avatarColor?: string;
            ownerType?: components["schemas"]["OwnerType"];
            /** @description Company name for business recipients */
            readonly businessName?: string;
            bankDetails?: components["schemas"]["BankAccountDetails"];
        };
        /**
         * Format: enum
         * @description What kind of recipient a schedule pays.
         * @enum {string}
         */
        RecipientType: RecipientType;
        /** @description One referral: who invited whom, when, and how it was attributed. */
        Referral: {
            /** @description The referral's identifier, as a UUID. */
            readonly referralId?: string;
            /** @description The inviter, as a user id (UUID). */
            readonly referrerUserId?: string;
            /** @description The inviter's email. Empty when their profile is not found. */
            readonly referrerEmail?: string;
            /** @description The invitee, as a user id (UUID). */
            readonly refereeUserId?: string;
            /** @description The invitee's email. Empty when their profile is not found. */
            readonly refereeEmail?: string;
            /**
             * Format: date-time
             * @description When the referral was attributed.
             */
            readonly createTime?: string;
            /** @description Whether the referral meets the quality criteria for its rewards: false until the invitee's deposits qualify it, or when it is flagged as abuse. */
            readonly qualified?: boolean;
            source?: components["schemas"]["AttributionSource"];
        };
        /** @description Request message for RewardsAdminService.ResolveRewardMerchantLocationLink. */
        ResolveRewardMerchantLocationLinkRequest: {
            /** @description The Google Maps link, short or full, as the operator pasted it. */
            uri: string;
        };
        /** @description Response message for RewardsAdminService.ResolveRewardMerchantLocationLink: the place a Google Maps link points at. */
        ResolveRewardMerchantLocationLinkResponse: {
            /**
             * Format: double
             * @description The place's latitude, in decimal degrees.
             */
            latitude?: number;
            /**
             * Format: double
             * @description The place's longitude, in decimal degrees.
             */
            longitude?: number;
            /** @description The place's name as the link gives it. Empty when the link names no place. */
            displayName?: string;
            /** @description The link with any short link followed to the full one it stands for. */
            expandedUri?: string;
        };
        /** @description Request message for NotificationsAdminService.RestartUserLifecycle. */
        RestartUserLifecycleRequest: {
            /**
             * Format: uuid
             * @description The staff test account to restart, as a UUID.
             */
            userId: string;
        };
        /** @description Request message for RewardsAdminService.ResumeRewardBudget. */
        ResumeRewardBudgetRequest: {
            /** @description The budget to resume, as `rewardBudgets/{reward_budget}`. */
            name: string;
            /** @description The etag the budget was read with. */
            etag: string;
            /**
             * Format: uuid
             * @description The idempotency key, as a UUID: minted once by the client when the form opens and sent again on a retry, so a retried change is made once.
             */
            requestId: string;
        };
        /** @description Request message for RewardsAdminService.ResumeRewardMerchant. */
        ResumeRewardMerchantRequest: {
            /** @description The merchant to resume, as `rewardMerchants/{reward_merchant}`. */
            name: string;
            /** @description The etag the merchant was read with. */
            etag: string;
            /** @description Why the merchant is resumed. */
            reason: string;
            /**
             * Format: uuid
             * @description The idempotency key, as a UUID: minted once by the client when the form opens and sent again on a retry, so a retried change is made once.
             */
            requestId: string;
        };
        /** @description Request message for RewardsAdminService.RetireRewardMerchant. */
        RetireRewardMerchantRequest: {
            /** @description The merchant to retire, as `rewardMerchants/{reward_merchant}`. */
            name: string;
            /** @description The etag the merchant was read with. */
            etag: string;
            /** @description Why the merchant is retired. */
            reason: string;
            /**
             * Format: uuid
             * @description The idempotency key, as a UUID: minted once by the client when the form opens and sent again on a retry, so a retried change is made once.
             */
            requestId: string;
        };
        /** @description A reward budget, as the rewards service holds it. */
        RewardBudget: {
            /** @description The budget's resource name, `rewardBudgets/{reward_budget}`. */
            name?: string;
            /** @description The budget's identifier, as a UUID. */
            readonly uid?: string;
            /** @description The name operators see. */
            displayName?: string;
            state?: components["schemas"]["RewardBudget_State"];
            /** @description The most USD the budget may cover in all, as a decimal string. */
            limitUsd?: string;
            /** @description The most USD one payment may have covered, as a decimal string. */
            maxPaymentUsd?: string;
            /** @description USD held for choices still settling, as a decimal string. */
            readonly reservedUsd?: string;
            /** @description USD covered by settled choices, as a decimal string. */
            readonly spentUsd?: string;
            /**
             * Format: date-time
             * @description When the budget starts admitting choices. Absent means now.
             */
            startTime?: string;
            /**
             * Format: date-time
             * @description When the budget stops admitting choices. Absent means never.
             */
            endTime?: string;
            /** @description The budget's etag; an update sends back the one it read. */
            etag?: string;
            /**
             * Format: date-time
             * @description When the budget was created.
             */
            readonly createTime?: string;
            /**
             * Format: date-time
             * @description When the budget last changed.
             */
            readonly updateTime?: string;
        };
        /** @description One budget's counters, in USD as decimal strings. */
        RewardBudgetFigures: {
            /** @description The budget, as `rewardBudgets/{reward_budget}`. */
            budget?: string;
            /** @description The name operators see. */
            displayName?: string;
            state?: components["schemas"]["RewardBudget_State"];
            /** @description The most the budget may spend. */
            limitUsd?: string;
            /** @description What open Pay with LIL choices hold. */
            reservedUsd?: string;
            /** @description What completed redemptions spent. */
            spentUsd?: string;
            /** @description The limit less what is spent and held. */
            remainingUsd?: string;
        };
        /**
         * Format: enum
         * @description Whether the budget admits choices.
         * @enum {string}
         */
        RewardBudget_State: RewardBudget_State;
        /** @description The payout of an Earn LIL choice: the grant's LIL on its way from the customer's pot to their wallet, by a rewards claim. */
        RewardEarnPayout: {
            state?: components["schemas"]["RewardEarnPayout_State"];
            /** @description The rewards claim that sends the LIL, as a UUID. Empty while the payout is pending. */
            readonly claimId?: string;
            /**
             * Format: date-time
             * @description When the LIL reached the customer's wallet. Unset until it has.
             */
            readonly paidTime?: string;
        };
        /**
         * Format: enum
         * @description Where the payout is.
         * @enum {string}
         */
        RewardEarnPayout_State: RewardEarnPayout_State;
        /** @description A partner merchant, as the rewards service holds it. */
        RewardMerchant: {
            /** @description The merchant's resource name, `rewardMerchants/{reward_merchant}`. */
            name?: string;
            /** @description The merchant's identifier, as a UUID. */
            readonly uid?: string;
            /** @description The name customers see. */
            displayName?: string;
            /** @description A short description shown on the merchant's card. */
            description?: string;
            /** @description Where the merchant's logo is served from, as an https URI: the served URI of the image `logo` names. Empty when it has no logo. Set the logo with `logo`. */
            readonly logoUri?: string;
            state?: components["schemas"]["RewardMerchant_State"];
            /** @description The identities a payee is recognised by. */
            identities?: components["schemas"]["MerchantIdentity"][];
            rates?: components["schemas"]["RewardRates"];
            /** @description The budget the merchant's Pay with LIL choices reserve from, as `rewardBudgets/{reward_budget}`. */
            budget?: string;
            /** @description The revision in force. */
            readonly revisionId?: string;
            /**
             * Format: date-time
             * @description When the revision in force was made.
             */
            readonly revisionCreateTime?: string;
            /** @description Why the revision in force was made. Required on a change that makes a revision. */
            revisionReason?: string;
            /** @description The operator who made the revision in force, set from their IAP identity. */
            readonly revisionActor?: string;
            /** @description The merchant's etag; an update sends back the one it read. */
            etag?: string;
            /**
             * Format: date-time
             * @description When the merchant was created.
             */
            readonly createTime?: string;
            /**
             * Format: date-time
             * @description When the merchant last changed.
             */
            readonly updateTime?: string;
            category?: components["schemas"]["RewardMerchant_Category"];
            /** @description The merchant's photos in display order; the first is the main photo. An update sends the order wanted, naming each image by its `name`. */
            images?: components["schemas"]["RewardMerchantImage"][];
            /** @description The merchant's logo, as the resource name of one of its images (`rewardMerchants/{reward_merchant}/images/{image}`). Empty when it has none. */
            logo?: string;
            /** @description The places customers can visit the merchant, each pinned on the map. */
            locations?: components["schemas"]["MerchantLocation"][];
            /** @description Labelled links the merchant's page shows as buttons, in display order. */
            links?: components["schemas"]["MerchantLink"][];
            /** @description The spans of time the merchant is live in. Empty means whenever it is active. */
            activeWindows?: components["schemas"]["ActiveWindow"][];
            /** @description Whether customers see the merchant and may choose on its payments now: it is active, and it has no active windows or the current time falls inside one of them. */
            readonly live?: boolean;
        };
        /** @description An image of a partner merchant: one of its photos, or its logo. */
        RewardMerchantImage: {
            /** @description The image's resource name, `rewardMerchants/{reward_merchant}/images/{image}`. Assigned when the image is created. */
            name?: string;
            /** @description Where the image is served from, as an https URI. */
            readonly uri?: string;
            /** @description The image's media type: "image/jpeg", "image/png" or "image/webp". */
            readonly mimeType?: string;
            /**
             * Format: int32
             * @description The image's width, in pixels.
             */
            readonly width?: number;
            /**
             * Format: int32
             * @description The image's height, in pixels.
             */
            readonly height?: number;
            /**
             * Format: uuid
             * @description The upload holding the image's bytes, as the `upload_id` CreateRewardMerchantImageUpload returned. Read when the image is created, and never returned.
             */
            uploadId?: string;
        };
        /** @description Where to upload one image of a partner merchant: a signed https URL the browser PUTs the bytes to, with upload_headers, before expire_time. */
        RewardMerchantImageUpload: {
            /** @description The upload's identifier, which CreateRewardMerchantImage takes once the bytes are in place. */
            readonly uploadId?: string;
            /** @description The image's media type: "image/jpeg", "image/png" or "image/webp". */
            mimeType: string;
            /**
             * Format: int32
             * @description The image's size, in bytes. At most 5 MiB (5242880 bytes).
             */
            sizeBytes: number;
            /** @description Where to PUT the bytes, as a signed https URL. */
            readonly uploadUri?: string;
            /** @description The headers the PUT must carry, exactly as given: the signature covers them. */
            readonly uploadHeaders?: {
                [key: string]: string;
            };
            /**
             * Format: date-time
             * @description When upload_uri stops admitting the upload.
             */
            readonly expireTime?: string;
        };
        /**
         * Format: enum
         * @description What kind of place the merchant is.
         * @enum {string}
         */
        RewardMerchant_Category: RewardMerchant_Category;
        /**
         * Format: enum
         * @description Whether the merchant takes part.
         * @enum {string}
         */
        RewardMerchant_State: RewardMerchant_State;
        /** @description One way to pay with LIL on a reward payment at a merchant revision whose rates carry Pay with LIL levels: a level, priced against what the payment covers. A payment offers every level whose USD is below its `covered_usd`, and the first level whose USD reaches it; it offers no level above that one. An option returns `usd_back`, the smaller of the level's USD and the payment's `covered_usd`, and costs `lil`, the level's LIL in full, however little of the level the payment uses. */
        RewardPayOption: {
            /**
             * Format: int32
             * @description The level's position among the merchant revision's levels, from 1 for the smallest.
             */
            readonly position?: number;
            /** @description The level's USD, as a decimal string. */
            readonly levelUsd?: string;
            /** @description The LIL the option costs, as a decimal string: the level's LIL. */
            readonly lil?: string;
            /** @description The USD the option returns to the customer, as a decimal string: the smaller of the level's USD and the payment's `covered_usd`. */
            readonly usdBack?: string;
            /** @description Whether the option returns all of the payment's `covered_usd`: true when the level's USD reaches it, which only the last option offered can. */
            readonly coversPayment?: boolean;
        };
        /** @description A customer's Pix payment to a partner merchant and what became of it. */
        RewardPayment: {
            /** @description The payment's resource name, as `users/{user}/rewardPayments/{reward_payment}`. */
            name?: string;
            /** @description The payment's identifier: the ledger transaction that recorded the Pix payment, as a UUID. */
            readonly uid?: string;
            /** @description The customer who paid, as a UUID. */
            readonly userId?: string;
            /** @description The merchant the payment was matched to, as `rewardMerchants/{reward_merchant}`. */
            readonly merchant?: string;
            /** @description The merchant revision whose rates priced the payment. */
            readonly merchantRevisionId?: string;
            /** @description The merchant's name as customers see it. */
            readonly merchantDisplayName?: string;
            state?: components["schemas"]["RewardPayment_State"];
            /** @description What the customer was debited, fees included, as a decimal USD string. */
            readonly paidUsd?: string;
            /** @description What has since been refunded, as a decimal USD string. */
            readonly refundedUsd?: string;
            /** @description What the payment covers, as a decimal USD string: the debit less any refund, never below zero. It is what a Pay with LIL choice on the whole payment returns, which is the Pay with LIL choice at a merchant revision with no levels; each of `pay_options` returns up to it. */
            readonly coveredUsd?: string;
            rates?: components["schemas"]["RewardRates"];
            /** @description The LIL a Pay with LIL choice on the whole payment costs, as a decimal string: `covered_usd` at the redeem rate, rounded up to a whole LIL. A Pay with LIL choice takes the whole payment only at a merchant revision with no levels; each of `pay_options` carries its own LIL. */
            readonly redeemLil?: string;
            /** @description The ways a Pay with LIL choice may pay, one per level offered, in increasing USD. They follow from the merchant revision's levels and `covered_usd`. Empty when the merchant revision has no levels: a Pay with LIL choice then takes the whole payment, for `redeem_lil`, returning `covered_usd`. */
            readonly payOptions?: components["schemas"]["RewardPayOption"][];
            /** @description The LIL an Earn LIL choice grants, as a decimal string. */
            readonly earnLil?: string;
            /** @description Whether Earn LIL may be chosen. */
            readonly earnAvailable?: boolean;
            /** @description The grant an Earn LIL choice created, as a UUID. Empty otherwise. */
            readonly grantId?: string;
            redemption?: components["schemas"]["RewardRedemption"];
            /**
             * Format: date-time
             * @description When the Pix payment settled.
             */
            readonly settleTime?: string;
            /**
             * Format: int64
             * @description The revision of the payment's amounts and state.
             */
            readonly revision?: number;
            /**
             * Format: date-time
             * @description When the reward payment was opened.
             */
            readonly createTime?: string;
            /**
             * Format: date-time
             * @description When the reward payment last changed.
             */
            readonly updateTime?: string;
            earnPayout?: components["schemas"]["RewardEarnPayout"];
        };
        /**
         * Format: enum
         * @description Where the payment is in its life.
         * @enum {string}
         */
        RewardPayment_State: RewardPayment_State;
        /** @description A merchant's two rates, both in LIL per one USD of the customer's debit, and the Pay with LIL levels priced at its redeem rate. */
        RewardRates: {
            /** @description LIL a customer pays to have one USD covered, as a decimal string. */
            redeemLilPerUsd: string;
            /** @description LIL a customer earns per USD instead, as a decimal string; lower than the redeem rate. */
            earnLilPerUsd: string;
            /** @description The Pay with LIL levels, in increasing USD, at most three. A customer paying with LIL takes one of them, for its LIL. A merchant with none offers Pay with LIL on the whole payment instead. Written with the rates, so a change to them makes a revision. */
            payLevels?: components["schemas"]["PayLevel"][];
        };
        /** @description The two legs of a Pay with LIL choice, and the amounts the choice moves. */
        RewardRedemption: {
            /** @description The redemption's identifier. */
            readonly uid?: string;
            state?: components["schemas"]["RewardRedemption_State"];
            /** @description The ledger transaction recording the LIL leaving the customer, as a UUID. Empty until that leg is recorded. */
            readonly collectTransactionId?: string;
            /** @description The ledger transaction recording the USD reaching the customer, as a UUID. Empty until that leg is recorded. */
            readonly reimburseTransactionId?: string;
            /** @description The chain transaction that moved the LIL, as a 0x-prefixed hash. */
            readonly collectTransactionHash?: string;
            /** @description The chain transaction that moved the USD, as a 0x-prefixed hash. */
            readonly reimburseTransactionHash?: string;
            /**
             * Format: date-time
             * @description When the redemption last changed state or recorded a leg. A redemption still owed past the owed alert duration after this is overdue.
             */
            readonly updateTime?: string;
            /** @description The LIL the choice collects from the customer, as a decimal string. */
            readonly lil?: string;
            /** @description The USD the choice returns to the customer, as a decimal string. */
            readonly usdBack?: string;
            /**
             * Format: int32
             * @description The Pay with LIL level the choice took, as its position among the merchant revision's levels, from 1 for the smallest. Zero when the choice took the whole payment, at a merchant revision with no levels.
             */
            readonly payLevel?: number;
        };
        /**
         * Format: enum
         * @description Where the redemption is in its two legs.
         * @enum {string}
         */
        RewardRedemption_State: RewardRedemption_State;
        /**
         * Format: enum
         * @description A schedule's lifecycle state.
         * @enum {string}
         */
        ScheduleState: ScheduleState;
        /** @description Request message for NotificationsAdminService.SendNudgePreview. */
        SendNudgePreviewRequest: {
            /** @description The sequence the message belongs to (for example "verify"). */
            sequence: string;
            /**
             * Format: int32
             * @description The step within the sequence, from zero.
             */
            step?: number;
            /** @description The goal version: "investing", "saving", "transfers" or "generic". */
            goal: string;
            /** @description The channel: "push" or "email". */
            channel: string;
        };
        /** @description Response message for NotificationsAdminService.SendNudgePreview. */
        SendNudgePreviewResponse: {
            /** @description The outbox row the preview was queued as. */
            outboxId?: string;
            /** @description The account it goes to, as a UUID. */
            userId?: string;
        };
        /** @description SplitBalanceLine is one outstanding balance row within a SplitTab. */
        SplitBalanceLine: {
            /** @description The outstanding amount, as a decimal string — money must never deserialize as a number. */
            readonly amount?: string;
            /** @description "owed" | "settled". */
            readonly direction?: string;
        };
        /** @description SplitTab is one split group ("tab") within a SplitsBalances block. */
        SplitTab: {
            /** @description The tab's name. */
            readonly name?: string;
            /**
             * Format: int32
             * @description The number of members in the tab.
             */
            readonly memberCount?: number;
            /**
             * Format: int32
             * @description The number of split items in the tab.
             */
            readonly itemCount?: number;
            /** @description The outstanding balance rows. */
            readonly lines?: components["schemas"]["SplitBalanceLine"][];
        };
        /** @description SplitsBalances is a set of bill-splitting tabs rendered as a component. */
        SplitsBalances: {
            /** @description An optional heading. */
            readonly title?: string;
            /** @description The split tabs, in display order. */
            readonly tabs?: components["schemas"]["SplitTab"][];
        };
        /** @description The `Status` type defines a logical error model that is suitable for different programming environments, including REST APIs and RPC APIs. It is used by [gRPC](https://github.com/grpc). Each `Status` message contains three pieces of data: error code, error message, and error details. You can find out more about this error model and how to work with it in the [API Design Guide](https://cloud.google.com/apis/design/errors). */
        Status: {
            /**
             * Format: int32
             * @description The status code, which should be an enum value of [google.rpc.Code][google.rpc.Code].
             */
            code?: number;
            /** @description A developer-facing error message, which should be in English. Any user-facing error message should be localized and sent in the [google.rpc.Status.details][google.rpc.Status.details] field, or localized by the client. */
            message?: string;
            /** @description A list of messages that carry the error details.  There is a common set of message types for APIs to use. */
            details?: components["schemas"]["GoogleProtobufAny"][];
        };
        /** @description Stock is a single row in a StocksList. */
        Stock: {
            /** @description The stock's ticker symbol. */
            readonly symbol?: string;
            /** @description The stock's name. */
            readonly name?: string;
            /** @description The current price, as a decimal string — money must never deserialize as a number. */
            readonly price?: string;
            /** @description The signed percent change over the period, as a decimal string — it must never deserialize as a number. */
            readonly changePct?: string;
        };
        /** @description StocksList is a list of stocks/equities rendered as a component, each with a current price and a change over the period as a percentage. */
        StocksList: {
            /** @description An optional heading. */
            readonly title?: string;
            /** @description The stocks, in display order. */
            readonly stocks?: components["schemas"]["Stock"][];
        };
        /** @description SuggestedReplies is a set of tappable reply suggestions. */
        SuggestedReplies: {
            /** @description The suggested reply texts, in display order. */
            readonly replies?: string[];
        };
        /** @description Response message for NotificationsAdminService.SummarizeNudgeActivity. */
        SummarizeNudgeActivityResponse: {
            /** @description Every nudge planned to go out in the next 24 hours, soonest first. */
            planned?: components["schemas"]["PlannedNudge"][];
            /** @description What was sent or skipped in the last 24 hours, newest first, capped at the most recent 1000. */
            sends?: components["schemas"]["LifecycleSend"][];
            /** @description True when the last 24 hours held more sends than were returned. */
            sendsTruncated?: boolean;
        };
        /** @description How referrals were attributed across every inviter in the last 30 days. */
        SummarizeReferralAttributionResponse: {
            /** @description How many referrals each attribution source produced in the last 30 days: one entry for every source, in the enum's order, including those that produced none. */
            readonly sourceCounts?: components["schemas"]["AttributionSourceCount"][];
            /** @description The referrals created in the last 30 days, newest first, capped at the most recent 500. */
            readonly referrals?: components["schemas"]["Referral"][];
            /** @description True when the last 30 days held more referrals than were returned. The source counts always cover every referral. */
            readonly referralsTruncated?: boolean;
        };
        /** @description Suspension is a user's current suspension state. `suspended` is resolved server-side against now() so no caller repeats the expiry/permanence logic. */
        Suspension: {
            /** @description The suspended user's identifier, as a UUID. */
            readonly userId?: string;
            /** @description Whether the user is currently suspended, resolved server-side against the current time. */
            readonly suspended?: boolean;
            /**
             * Format: date-time
             * @description Absent when the user is not suspended, or when the suspension is permanent (google.protobuf.Timestamp cannot represent infinity).
             */
            readonly suspendedUntil?: string;
            /** @description Whether the suspension is permanent. */
            readonly permanent?: boolean;
            /** @description Why the user was suspended. Empty when none was recorded. */
            readonly reason?: string;
            /** @description The admin who last changed the suspension. Empty when none was recorded. */
            readonly actorEmail?: string;
        };
        /** @description Table is generic tabular data rendered as a component. It is the last structured block before plain-text fallback. Every cell is a string — the sub-agent pre-formats numbers, so money never crosses the boundary as a float. */
        Table: {
            /** @description An optional heading. */
            readonly title?: string;
            /** @description The column headers, in display order. */
            readonly columns?: components["schemas"]["TableColumn"][];
            /** @description The rows, in display order. */
            readonly rows?: components["schemas"]["TableRow"][];
        };
        /** @description TableColumn is one column header plus the alignment of its cells. */
        TableColumn: {
            /** @description The column's header text. */
            readonly header?: string;
            /** @description "right" | "center". */
            readonly align?: string;
        };
        /** @description TableRow is one row of string cells, aligned positionally with the columns. */
        TableRow: {
            /** @description The row's cells, aligned positionally with the columns. */
            readonly cells?: string[];
        };
        /** @description Thinking is a collapsed extended-reasoning block. */
        Thinking: {
            /** @description The one-line summary shown while collapsed. */
            readonly summary?: string;
            /** @description The full reasoning text shown when expanded. */
            readonly content?: string;
        };
        /** @description The balance of one token in one wallet. */
        TokenBalance: {
            /** @description The token's symbol. */
            readonly symbol?: string;
            /** @description The token's contract address. */
            readonly address?: string;
            /** @description The balance, as a human-readable decimal string. */
            readonly balance?: string;
            /** @description The balance in the token's smallest unit. */
            readonly balanceWei?: string;
            /**
             * Format: int32
             * @description The token's decimal places.
             */
            readonly decimals?: number;
            /** @description The balance's value, in USD as a decimal string. Empty when the token is not priced, which is always the case today. */
            readonly usdValue?: string;
            /** @description The token's unit price, in USD as a decimal string. Empty when the token is not priced, which is always the case today. */
            readonly usdPrice?: string;
            /** @description The code the balance is shown under: the token's underlying symbol when it has one (USD for USDC), its own symbol otherwise. */
            readonly displayCurrencyCode?: string;
        };
        /** @description ToolUse records a tool that was used */
        ToolUse: {
            /** @description The tool's name. */
            readonly tool?: string;
            /** @description The tool's input, as a JSON string. */
            readonly input?: string;
            /** @description The tool's result, as a JSON string. */
            readonly result?: string;
            /** @description The tool's error message, when it failed. */
            readonly error?: string;
        };
        /** @description TopEntity is one of the most-connected entities. */
        TopEntity: {
            /** @description The entity's name. */
            readonly name?: string;
            /**
             * Format: int32
             * @description The entity's edge count.
             */
            readonly degree?: number;
        };
        /** @description A user's savings summed in USD terms. */
        TotalBalance: {
            /** @description The value of all positions in USD, as a decimal string. */
            readonly totalValueUsd?: string;
            /** @description The interest earned in USD, as a decimal string. */
            readonly totalInterestUsd?: string;
            /** @description The balance-weighted average APY across positions, as a percentage string. */
            readonly averageApy?: string;
        };
        /** @description Transaction represents a complete double-entry transaction */
        Transaction: {
            /** @description Unique identifier for the transaction (UUID format, e.g., "550e8400-e29b-41d4-a716-446655440000") */
            readonly id?: string;
            context?: components["schemas"]["TransactionContext"];
            status?: components["schemas"]["Transaction_State"];
            /** @description Optional human-readable note describing the transaction (e.g., "Payment for dinner") */
            readonly note?: string;
            /** @description Additional metadata as key-value pairs Common keys: correlation_id, vendor, blockchain_hash, transaction_type Example: {"correlation_id": "abc123", "blockchain_hash": "0x..."} */
            metadata?: {
                [key: string]: string;
            };
            /**
             * Format: date-time
             * @description Timestamp when the transaction was created (RFC 3339 format)
             */
            readonly createdAt?: string;
            /**
             * Format: date-time
             * @description Timestamp when the transaction was last updated (RFC 3339 format)
             */
            readonly updatedAt?: string;
            /**
             * Format: date-time
             * @description Timestamp when the transaction was confirmed (RFC 3339 format) Only set when status changes to CONFIRMED
             */
            readonly confirmedAt?: string;
            /** @description List of debit and credit entries that make up this transaction Must contain at least 2 entries, and total debits must equal total credits */
            readonly entries?: components["schemas"]["Entry"][];
            /** @description Idempotency key that was used to create this transaction (UUID format) */
            readonly requestId?: string;
        };
        /**
         * Format: enum
         * @description What kind of movement a transaction records.
         * @enum {string}
         */
        TransactionContext: TransactionContext;
        /** @description TransactionList is a list of transactions rendered as a component. */
        TransactionList: {
            /** @description An optional heading. */
            readonly title?: string;
            /** @description The transactions, in display order. */
            readonly transactions?: components["schemas"]["NimTransaction"][];
        };
        /**
         * Format: enum
         * @description The lifecycle of a transaction.
         * @enum {string}
         */
        Transaction_State: Transaction_State;
        /** @description UpdateSuspensionRequest sets a user's suspension. Exactly one of suspension_end_time (must be in the future) or permanent must be set. reason and actor_email are stored on the suspension and read back by GetSuspension, as well as going to the audit log. */
        UpdateSuspensionRequest: {
            /**
             * Format: uuid
             * @description The user to suspend, as a UUID.
             */
            userId: string;
            /**
             * Format: date-time
             * @description When the suspension lifts; must be in the future. Exactly one of this and permanent is set.
             */
            suspendedUntil?: string;
            /** @description Whether to ban permanently. Exactly one of this and suspension_end_time is set. */
            permanent?: boolean;
            /** @description The operator's reason, stored on the suspension and audit-logged. */
            reason?: string;
            /** @description The operator's email. The server sets this from the caller's verified admin identity; a value sent by a client is overwritten. */
            actorEmail?: string;
        };
        /** @description UserLifecycle is one user's onboarding nudge state. */
        UserLifecycle: {
            /** @description The user, as a UUID. */
            userId?: string;
            /** @description The stage: verify, fund, first_action, adopt, out_of_loop or excluded. Empty when the nudge engine has not seen the user yet. */
            stage?: string;
            /**
             * Format: date-time
             * @description When the user verified.
             */
            verifyTime?: string;
            /**
             * Format: date-time
             * @description When money first arrived.
             */
            fundTime?: string;
            /** @description The first product family used (send, savings or investing). */
            firstFamily?: string;
            /**
             * Format: date-time
             * @description When the first product family was first used.
             */
            firstFamilyTime?: string;
            /** @description The second product family used. */
            secondFamily?: string;
            /**
             * Format: date-time
             * @description When the second product family was first used.
             */
            secondFamilyTime?: string;
            /**
             * Format: date-time
             * @description When the user was excluded from nudges for good.
             */
            excludeTime?: string;
            /** @description The running journey or win-back series; empty when none runs. */
            sequence?: string;
            /**
             * Format: date-time
             * @description When the running sequence started.
             */
            runStartTime?: string;
            /**
             * Format: date-time
             * @description When the running journey was paused by a hold.
             */
            holdTime?: string;
            /** @description The stage whose journey is done (or was skipped at launch). */
            journeyDoneFor?: string;
            /**
             * Format: date-time
             * @description When the last nudge went out.
             */
            lastNudgeTime?: string;
            /** @description The nudges still planned in the running sequence, soonest first. */
            planned?: components["schemas"]["PlannedNudge"][];
            /** @description What was sent or skipped, newest first. */
            sends?: components["schemas"]["LifecycleSend"][];
        };
        /** @description One position in the user's portfolio. Money and quantity values are decimal strings; money is in USD. */
        UserPosition: {
            /** @description The held asset, as a UUID. */
            readonly assetId?: string;
            /** @description The venue ticker symbol. */
            readonly symbol?: string;
            /** @description The issuer's full name. */
            readonly name?: string;
            /** @description The held quantity of shares. */
            readonly quantity?: string;
            /** @description The asset's current mark price. */
            readonly markPrice?: string;
            /** @description The position's current market value. */
            readonly marketValue?: string;
            /** @description The average cost per share across the position's buys. */
            readonly avgCostPerShare?: string;
            /** @description The total amount paid for the held shares. */
            readonly costBasis?: string;
            /** @description The unrealised profit-and-loss on the held shares. */
            readonly unrealizedPnl?: string;
            /** @description The realised profit-and-loss from completed sells. */
            readonly realizedPnl?: string;
            /** @description The realised and unrealised profit-and-loss combined. */
            readonly totalPnl?: string;
            /** @description `total_pnl` as a percentage decimal string of cost basis. */
            readonly pnlPercent?: string;
            /** @description The profit-and-loss over the requested period. For ALL this mirrors the lifetime figures; for sub-periods it is computed against the position's reconstructed state at the period start. When no historical price exists for the asset at the period start, the value falls back to since-inception semantics rather than zero. */
            readonly periodPnl?: string;
            /** @description `period_pnl` as a percentage decimal string. */
            readonly periodPnlPct?: string;
            /** @description The position's value at the period start. */
            readonly periodStartValue?: string;
            /** @description Shares not reserved by an open SELL order: `quantity` minus the unfilled remainder of the user's non-terminal SELL orders for this asset. Clients gate further sells on this so the same shares cannot be sold twice by concurrent orders. */
            readonly availableQuantity?: string;
            /** @description The consumer-facing ticker when it differs from `symbol` (for example "BTC" while the underlying symbol is "cbBTC"). Empty means clients fall back to `symbol`. */
            readonly displaySymbol?: string;
            /** @description The asset's logo URL, from the same catalog snapshot as `mark_price`. Empty when the catalog has no logo; clients then fall back to an initials avatar. Present so a portfolio row renders from this message alone. */
            readonly logoUrl?: string;
        };
        /** @description VerificationIssue represents a specific problem with KYC verification. */
        VerificationIssue: {
            /** @description The machine-readable issue code. */
            readonly code?: string;
            /** @description The human-readable description. */
            readonly message?: string;
            /** @description When the issue was raised, as RFC 3339. */
            readonly timestamp?: string;
        };
        /** @description The token balances of one wallet. */
        WalletBalance: {
            /** @description The wallet's on-chain address. */
            readonly walletAddress?: string;
            /** @description The wallet kind: "eoa" or "aa". */
            readonly walletType?: string;
            /**
             * Format: int32
             * @description The EVM chain identifier.
             */
            readonly chainId?: number;
            /** @description The per-token balances. */
            readonly tokens?: components["schemas"]["TokenBalance"][];
            /** @description The wallet's total value, in USD as a decimal string. Empty when the tokens are not priced, which is always the case today. */
            readonly totalUsdValue?: string;
        };
        /** @description The displayable essentials of a recipient's crypto wallet. */
        WalletSummary: {
            /** @description Full address or masked version. */
            readonly walletAddress?: string;
            /**
             * Format: int32
             * @description The EVM chain the wallet lives on, such as `42161` for Arbitrum.
             */
            readonly chainId?: number;
            /** @description "Arbitrum", "Ethereum", "Polygon". */
            readonly chainName?: string;
            /** @description USDC, EURC, ETH. */
            readonly currency?: string;
        };
        /** @description WebhookEventDetail is a single Persona webhook event from the processing timeline. */
        WebhookEventDetail: {
            /** @description The event record's identifier, as a UUID. */
            readonly id?: string;
            /** @description The Persona event identifier; the idempotency key. */
            readonly personaEventId?: string;
            /** @description The Persona event type. */
            readonly eventType?: string;
            /** @description The Persona inquiry identifier. */
            readonly inquiryId?: string;
            /** @description The processing status: "pending", "completed", or "failed". */
            readonly status?: string;
            /**
             * Format: date-time
             * @description When the record was created.
             */
            readonly createdAt?: string;
            /**
             * Format: date-time
             * @description When processing finished.
             */
            readonly processedAt?: string;
            /** @description The failure description, on failed events. */
            readonly error?: string;
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    LedgerAdminService_ListLedgerAccounts: {
        parameters: {
            query?: {
                /** @description Number of accounts to return per page (default 50, max 200). */
                pageSize?: number;
                /** @description Pagination token from a previous response (empty for the first page). */
                pageToken?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListLedgerAccountsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    LedgerAdminService_GetLedgerAccount: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The account to fetch - a user UUID or system account name. */
                accountId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LedgerAccount"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    NotificationsAdminService_AdminListAnnouncements: {
        parameters: {
            query?: {
                /** @description The lifecycle filter. */
                status?: components["schemas"]["AnnouncementStatusFilter"];
                /** @description The maximum number of items to return. */
                limit?: number;
                /** @description The number of items to skip before the first result. */
                offset?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminListAnnouncementsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    NotificationsAdminService_AdminCreateAnnouncement: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminCreateAnnouncementRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Announcement"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    NotificationsAdminService_AdminGetAnnouncementDismissals: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The announcement to list dismissals for, as a UUID. */
                announcementId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminGetAnnouncementDismissalsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    NotificationsAdminService_AdminUpdateAnnouncement: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The announcement to update, as a UUID. */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminUpdateAnnouncementRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Announcement"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    NotificationsAdminService_AdminDeleteAnnouncement: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The announcement to delete, as a UUID. */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminDeleteAnnouncementResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    ConversationsAdminService_AdminListConversationFlags: {
        parameters: {
            query?: {
                /** @description The review state to list. Unspecified lists every state. */
                state?: components["schemas"]["ConversationFlag_State"];
                /** @description The conversation whose flags to list, as a UUID. Empty lists every conversation's flags. */
                conversationId?: string;
                /** @description The maximum number of flags to return: default 50, at most 100. Zero selects the default; the server may return fewer than requested. */
                pageSize?: number;
                /** @description A page token from a previous AdminListConversationFlags response. Omit to fetch the first page. Tokens are opaque and expire with the request shape. */
                pageToken?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminListConversationFlagsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    ConversationsAdminService_AdminUpdateConversationFlag: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The flag to update, as a UUID. */
                flagId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminUpdateConversationFlagRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ConversationFlag"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    ConversationsAdminService_AdminListConversations: {
        parameters: {
            query?: {
                /** @description A filter: a UUID matches as a user id; any other value is resolved to user ids by email or name. */
                query?: string;
                /** @description The maximum number of conversations to return: default 50, at most 100. */
                pageSize?: number;
                /** @description An opaque cursor from a previous response. Omit for the first page. */
                pageToken?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminListConversationsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    ConversationsAdminService_AdminGetConversation: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The conversation to fetch, as a UUID. */
                conversationId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminGetConversationResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    ConversationsAdminService_AdminCreateConversationFlag: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The conversation to flag, as a UUID. */
                conversationId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminCreateConversationFlagRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ConversationFlag"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    EventsAdminService_IssueEventTickets: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The event's code, as lowercase letters, digits and hyphens. */
                eventCode: string;
                /** @description The guest's user id, as a UUID. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["IssueEventTicketsRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EventGuest"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    EventsAdminService_ResolveEventGuest: {
        parameters: {
            query?: {
                /** @description The guest's profile tag, current or previous, with or without a leading "@", in any case (for example "faiz" or "@Faiz"). */
                tag?: string;
                /** @description The guest's email address, in any case. */
                email?: string;
                /** @description The guest's user id, as a UUID. */
                userId?: string;
            };
            header?: never;
            path: {
                /** @description The event's code, as lowercase letters, digits and hyphens. */
                eventCode: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EventGuest"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    EventsAdminService_ListEventTicketIssuances: {
        parameters: {
            query?: {
                /** @description The maximum number of issuances to return. Zero selects the default page size; the server may return fewer than requested. */
                pageSize?: number;
                /** @description A page token from a previous ListEventTicketIssuances response. Omit to fetch the first page. */
                pageToken?: string;
            };
            header?: never;
            path: {
                /** @description The event's code, as lowercase letters, digits and hyphens. */
                eventCode: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListEventTicketIssuancesResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    ConversationsAdminService_AdminListFeedback: {
        parameters: {
            query?: {
                /** @description A filter: a UUID matches as a user id; any other value is resolved to user ids by email or name. */
                query?: string;
                /** @description The categories to return. Empty returns every category. */
                kinds?: components["schemas"]["FeedbackKind"][];
                /** @description The maximum number of submissions to return: default 50, at most 100. */
                pageSize?: number;
                /** @description An opaque cursor from a previous response. Omit for the first page. */
                pageToken?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminListFeedbackResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    FFlagsAdminService_AdminDisableFFlag: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminDisableFFlagRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminDisableFFlagResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    FFlagsAdminService_AdminEnableFFlag: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminEnableFFlagRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminEnableFFlagResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    FFlagsAdminService_AdminListFFlags: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminListFFlagsRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminListFFlagsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    FFlagsAdminService_AdminDeleteUserFFlagOverride: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminDeleteUserFFlagOverrideRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminDeleteUserFFlagOverrideResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    FFlagsAdminService_AdminListUserFFlagOverrides: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminListUserFFlagOverridesRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminListUserFFlagOverridesResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    FFlagsAdminService_AdminSetUserFFlagOverride: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminSetUserFFlagOverrideRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminSetUserFFlagOverrideResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    AdminService_HealthCheck: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HealthCheckResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    KYCAdminService_AdminReplayPersonaWebhook: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The webhook event to replay, as the UUID of kyc.webhook_events.id. */
                webhookEventId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminReplayPersonaWebhookRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminReplayWebhookResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    LedgerAdminService_ListLedgerEntries: {
        parameters: {
            query?: {
                /** @description An account to filter by: a user's UUID or a system account name. */
                accountId?: string;
                /** @description A transaction context to filter by. */
                context?: components["schemas"]["TransactionContext"];
                /** @description A transaction status to filter by. */
                status?: components["schemas"]["Transaction_State"];
                /** @description The maximum number of transactions to return. */
                pageSize?: number;
                /** @description An opaque cursor from a previous response. Omit for the first page. */
                pageToken?: string;
                /** @description An asset symbol to filter by (for example `USDC`). */
                assetSymbol?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListTransactionsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    NotificationsAdminService_SummarizeNudgeActivity: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SummarizeNudgeActivityResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    NotificationsAdminService_SendNudgePreview: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SendNudgePreviewRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SendNudgePreviewResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    AdminService_GetCurrentAdmin: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetCurrentAdminResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    ConversationsAdminService_AdminListNimAnnouncements: {
        parameters: {
            query?: {
                /** @description The maximum announcements to return. Zero selects the default of 50. */
                limit?: number;
                /** @description The number of announcements to skip before the first returned. */
                offset?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminListNimAnnouncementsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    ConversationsAdminService_AdminCreateNimAnnouncement: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminCreateNimAnnouncementRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NimAnnouncement"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    ConversationsAdminService_AdminCancelNimAnnouncement: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The announcement to cancel, as a UUID. */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminCancelNimAnnouncementRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NimAnnouncement"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    NimAdminService_ListNimCalls: {
        parameters: {
            query?: {
                /** @description A user whose calls to list, as a UUID. Omit it to list every user's calls. */
                userId?: string;
                /** @description Who started or placed the calls to list: the user, Nim's agent, a scheduled task or an operator. Omit it (NIM_CALL_INITIATOR_UNSPECIFIED) to list calls whoever started or placed them. */
                initiator?: components["schemas"]["NimCallInitiator"];
                /** @description The maximum number of calls to return, at most 200. Zero selects the default of 50; the server may return fewer than requested. */
                pageSize?: number;
                /** @description A page token from a previous ListNimCalls response. Omit it to fetch the first page. Tokens are opaque and expire with the request shape: a token is refused with another user_id or initiator than its own. */
                pageToken?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListNimCallsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    NimAdminService_PlaceNimCall: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PlaceNimCallRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PlaceNimCallResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    NimAdminService_BackfillNimGraph: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BackfillNimGraphRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BackfillNimGraphResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    NimAdminService_GetNimEntityGraph: {
        parameters: {
            query?: {
                /** @description An owner to filter by, as a UUID. Empty returns the whole network. */
                ownerIdFilter?: string;
                /** @description The maximum paths to traverse. Zero selects the default of 500. */
                pathLimit?: number;
                /** @description The minimum edge confidence to include. Zero includes everything. */
                minConfidence?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetEntityGraphResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    NimAdminService_ExpandNimNode: {
        parameters: {
            query?: {
                /** @description The owning user, as a UUID. Needed for entity expansion, since entities are owner-scoped. */
                ownerId?: string;
                /** @description The node's kind. */
                kind?: components["schemas"]["GraphNodeKind"];
                /** @description The node to expand: a memory UUID or an entity name. */
                nodeId?: string;
                /** @description The traversal depth, from 1 to 3. Zero selects the default of 1. */
                depth?: number;
                /** @description The maximum paths to traverse, capped at 1000. Zero selects the default of 100. */
                pathLimit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ExpandNodeResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    NimAdminService_GetNimFullGraph: {
        parameters: {
            query?: {
                /** @description The owner whose graph to return, as a UUID. The full graph is always scoped to one owner. */
                ownerId?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetFullGraphResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    NimAdminService_GetNimMemoryGraph: {
        parameters: {
            query?: {
                /** @description The owner whose graph to return, as a UUID. */
                ownerId?: string;
                /** @description The memory to seed the traversal from, as a UUID. Empty picks the highest-importance memory. */
                seedMemoryId?: string;
                /** @description The traversal depth, from 1 to 5. Zero selects the default of 2. */
                depth?: number;
                /** @description The maximum paths to traverse, capped at 5000. Zero selects the default of 500. */
                pathLimit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetMemoryGraphResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    NimAdminService_GetNimGraphStats: {
        parameters: {
            query?: {
                /** @description An owner to filter by, as a UUID. Empty summarises the whole network. */
                ownerIdFilter?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetGraphStatsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    ConversationsAdminService_AdminListNimMedia: {
        parameters: {
            query?: {
                /** @description A filter: a UUID matches as a user id; any other value is resolved to user ids by email or name. */
                query?: string;
                /** @description The maximum number of items to return: default 50, at most 100. */
                pageSize?: number;
                /** @description An opaque cursor from a previous response. Omit for the first page. */
                pageToken?: string;
                /** @description When true, oldest images first instead of the default newest first. */
                oldestFirst?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminListNimMediaResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    NimAdminService_ListNimMemories: {
        parameters: {
            query?: {
                /** @description The maximum memories to return. Zero selects the default of 50. */
                pageSize?: number;
                /** @description The opaque cursor for the next page. Empty fetches the first page. */
                pageToken?: string;
                /** @description An owner to filter by, as a UUID. Empty lists every owner. */
                ownerIdFilter?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminListMemoriesResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    NotificationsAdminService_AdminListPushAnnouncements: {
        parameters: {
            query?: {
                /** @description Default 50. */
                limit?: number;
                /** @description The number of items to skip before the first result. */
                offset?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminListPushAnnouncementsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    NotificationsAdminService_AdminCreatePushAnnouncement: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminCreatePushAnnouncementRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PushAnnouncement"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    NotificationsAdminService_AdminCancelPushAnnouncement: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The push announcement to cancel, as a UUID. */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminCancelPushAnnouncementRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PushAnnouncement"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RampsAdminService_ListRampBanks: {
        parameters: {
            query?: {
                /** @description The owning user's identifier, as a UUID. */
                userId?: string;
                /** @description A provider to filter by. Omit for every provider. */
                provider?: components["schemas"]["Provider"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListAccountsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RampsAdminService_GetRampLinkedAccount: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The linked account to fetch, as a UUID. */
                accountId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LinkedAccount"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RampsAdminService_GetRampRecipient: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The recipient to fetch, as a UUID. */
                recipientId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Recipient"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    LedgerAdminService_ListRampTransactions: {
        parameters: {
            query?: {
                /** @description An account to filter by: a user's UUID or a system account name. */
                accountId?: string;
                /** @description A transaction context to filter by. */
                context?: components["schemas"]["TransactionContext"];
                /** @description A transaction status to filter by. */
                status?: components["schemas"]["Transaction_State"];
                /** @description The maximum number of transactions to return. */
                pageSize?: number;
                /** @description An opaque cursor from a previous response. Omit for the first page. */
                pageToken?: string;
                /** @description An asset symbol to filter by (for example `USDC`). */
                assetSymbol?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListTransactionsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    ReferralsAdminService_SummarizeReferralAttribution: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SummarizeReferralAttributionResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RewardsAdminService_ListRewardBudgets: {
        parameters: {
            query?: {
                /** @description The most budgets to return. Zero selects the default. */
                pageSize?: number;
                /** @description A page token from a previous list. Omit for the first page. */
                pageToken?: string;
                /** @description An AIP-160 filter over `state`. */
                filter?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListRewardBudgetsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RewardsAdminService_CreateRewardBudget: {
        parameters: {
            query?: {
                /** @description The idempotency key, as a UUID: minted once by the client when the form opens and sent again on a retry, so a retried change is made once. */
                requestId?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RewardBudget"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RewardBudget"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RewardsAdminService_GetRewardBudget: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The rewardBudget id. */
                rewardBudget: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RewardBudget"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RewardsAdminService_UpdateRewardBudget: {
        parameters: {
            query?: {
                /** @description The fields to write. */
                updateMask?: string;
                /** @description The idempotency key, as a UUID: minted once by the client when the form opens and sent again on a retry, so a retried change is made once. */
                requestId?: string;
            };
            header?: never;
            path: {
                /** @description The rewardBudget id. */
                rewardBudget: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RewardBudget"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RewardBudget"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RewardsAdminService_CloseRewardBudget: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The rewardBudget id. */
                rewardBudget: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CloseRewardBudgetRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RewardBudget"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RewardsAdminService_PauseRewardBudget: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The rewardBudget id. */
                rewardBudget: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PauseRewardBudgetRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RewardBudget"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RewardsAdminService_ResumeRewardBudget: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The rewardBudget id. */
                rewardBudget: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ResumeRewardBudgetRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RewardBudget"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RewardsAdminService_ListRewardMerchants: {
        parameters: {
            query?: {
                /** @description The most merchants to return. Zero selects the default. */
                pageSize?: number;
                /** @description A page token from a previous list. Omit for the first page. */
                pageToken?: string;
                /** @description An AIP-160 filter over `state`, `category` and `live`, for example `live = true AND category = CATEGORY_TRAVEL`. */
                filter?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListRewardMerchantsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RewardsAdminService_CreateRewardMerchant: {
        parameters: {
            query?: {
                /** @description The idempotency key, as a UUID: minted once by the client when the form opens and sent again on a retry, so a retried change is made once. */
                requestId?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RewardMerchant"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RewardMerchant"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RewardsAdminService_GetRewardMerchant: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The rewardMerchant id. */
                rewardMerchant: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RewardMerchant"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RewardsAdminService_UpdateRewardMerchant: {
        parameters: {
            query?: {
                /** @description The fields to write. The catalogue paths, `display_name`, `description`, `category`, `images`, `logo`, `locations`, `links` and `active_windows`, change the merchant in place; `identities`, `rates` (the Pay with LIL levels with them) and `budget` make a revision, and are sent in a request of their own. */
                updateMask?: string;
                /** @description The idempotency key, as a UUID: minted once by the client when the form opens and sent again on a retry, so a retried change is made once. */
                requestId?: string;
            };
            header?: never;
            path: {
                /** @description The rewardMerchant id. */
                rewardMerchant: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RewardMerchant"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RewardMerchant"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RewardsAdminService_CreateRewardMerchantImage: {
        parameters: {
            query?: {
                /** @description The idempotency key, as a UUID: minted once by the client for the upload and sent again on a retry, so a retried registration makes one image. */
                requestId?: string;
            };
            header?: never;
            path: {
                /** @description The rewardMerchant id. */
                rewardMerchant: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RewardMerchantImage"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RewardMerchantImage"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RewardsAdminService_DeleteRewardMerchantImage: {
        parameters: {
            query?: {
                /** @description The idempotency key, as a UUID. Sent again on a retry, it succeeds once the image is gone instead of failing as not found. */
                requestId?: string;
            };
            header?: never;
            path: {
                /** @description The rewardMerchant id. */
                rewardMerchant: string;
                /** @description The image id. */
                image: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RewardsAdminService_CreateRewardMerchantImageUpload: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The rewardMerchant id. */
                rewardMerchant: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RewardMerchantImageUpload"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RewardMerchantImageUpload"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RewardsAdminService_ListRewardMerchantRevisions: {
        parameters: {
            query?: {
                /** @description The most revisions to return. Zero selects the default. */
                pageSize?: number;
                /** @description A page token from a previous list. Omit for the first page. */
                pageToken?: string;
            };
            header?: never;
            path: {
                /** @description The rewardMerchant id. */
                rewardMerchant: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListRewardMerchantRevisionsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RewardsAdminService_PauseRewardMerchant: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The rewardMerchant id. */
                rewardMerchant: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PauseRewardMerchantRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RewardMerchant"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RewardsAdminService_ResumeRewardMerchant: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The rewardMerchant id. */
                rewardMerchant: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ResumeRewardMerchantRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RewardMerchant"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RewardsAdminService_RetireRewardMerchant: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The rewardMerchant id. */
                rewardMerchant: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RetireRewardMerchantRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RewardMerchant"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RewardsAdminService_ResolveRewardMerchantLocationLink: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ResolveRewardMerchantLocationLinkRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ResolveRewardMerchantLocationLinkResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RewardsAdminService_ListRewardPayments: {
        parameters: {
            query?: {
                /** @description The most payments to return. Zero selects the default. */
                pageSize?: number;
                /** @description A page token from a previous list. Omit for the first page. */
                pageToken?: string;
                /** @description An AIP-160 filter over `merchant`, `state`, `settle_time` and `redemption.update_time`, for example `merchant = "rewardMerchants/…" AND settle_time >= "2026-10-01T00:00:00Z"`. A payment with no redemption never matches a `redemption.update_time` comparison. */
                filter?: string;
                /** @description An AIP-132 ordering over `settle_time`. Empty orders by `settle_time desc`. */
                orderBy?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListRewardPaymentsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RewardsAdminService_QueryRewardProgramme: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["QueryRewardProgrammeResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    LedgerAdminService_ListTransactions: {
        parameters: {
            query?: {
                /** @description Optional: Filter by account ID (user UUID or system account name) Returns all transactions where this account appears in any entry Example: "550e8400-e29b-41d4-a716-446655440000" or "fees" */
                accountId?: string;
                /** @description Optional: Filter by transaction context (P2P, ONRAMP, OFFRAMP, etc.) */
                context?: components["schemas"]["TransactionContext"];
                /** @description Optional: Filter by transaction status (PENDING, CONFIRMED, FAILED) */
                status?: components["schemas"]["Transaction_State"];
                /** @description Number of transactions to return per page (default 50, max 100) */
                pageSize?: number;
                /** @description Pagination token from previous response (empty for first page) */
                pageToken?: string;
                /** @description Optional: Filter by asset symbol (USDC, LIL, EUR, GBP, etc.) Returns only transactions where ALL entries have this asset_symbol */
                assetSymbol?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListTransactionsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    LedgerAdminService_GetTransaction: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The transaction to fetch, as a UUID. */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Transaction"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    UsersAdminService_AdminBatchGetUsers: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminBatchGetUsersRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminBatchGetUsersResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    UsersAdminService_AdminBatchResolveUsersByName: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminBatchResolveUsersByNameRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminBatchResolveUsersByNameResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    UsersAdminService_ExportFilteredEmails: {
        parameters: {
            query?: {
                /** @description Free text matched against email and name; a UUID matches as a user id. */
                query?: string;
                /** @description A KYC status to filter by (for example `approved`). */
                kycStatusFilter?: string;
                /** @description A device platform to filter by (for example `ios`). */
                platformFilter?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ExportFilteredEmailsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    UsersAdminService_AdminResolveUsers: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminResolveUsersRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminResolveUsersResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    UsersAdminService_SearchUsers: {
        parameters: {
            query?: {
                /** @description Free text matched against email and name; a UUID matches as a user id. */
                query?: string;
                /** @description The maximum number of profiles to return. */
                limit?: number;
                /** @description How many matching profiles to skip before the page starts. */
                offset?: number;
                /** @description A KYC status to filter by (for example `approved`). */
                kycStatusFilter?: string;
                /** @description A device platform to filter by (for example `ios`). */
                platformFilter?: string;
                /** @description Ordering is applied across the whole matching set, before the page is cut. The handler already holds every match in memory to count them, so this is what makes "oldest user" mean the oldest user rather than the oldest of the twenty-five that happened to land on this page. */
                sortField?: components["schemas"]["AdminUserSortField"];
                /** @description Which way the sorted column runs. */
                sortDirection?: components["schemas"]["AdminSortDirection"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminSearchUsersResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    UsersAdminService_UpdateProfile: {
        parameters: {
            query?: {
                /** @description The profile fields to update, as field paths (for example "onboarding_chat_completed"). Omit to update every populated field. */
                updateMask?: string;
            };
            header?: never;
            path: {
                "profile.user_id": string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["Profile"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Profile"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    UsersAdminService_GetUser: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user to fetch, as a UUID. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Profile"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    WalletsAdminService_GetUserBalances: {
        parameters: {
            query?: {
                /** @description The EVM chain identifier; zero infers the chain per token. */
                chainId?: number;
                /** @description The tokens to filter by. Empty returns every supported token. */
                tokenSymbols?: string[];
            };
            header?: never;
            path: {
                /** @description The user whose balances to return, as a UUID. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ComputeBalanceResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    NotificationsAdminService_GetUserDevices: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The acting user's identifier, as a UUID. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetUserDevicesResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    NotificationsAdminService_ListUserInbox: {
        parameters: {
            query?: {
                /** @description The maximum number of items to return. Default 50. */
                limit?: number;
                /** @description The number of items to skip before the first result. */
                offset?: number;
                /** @description When true, returns only unread items. */
                unreadOnly?: boolean;
            };
            header?: never;
            path: {
                /** @description The user whose inbox to list, as a UUID. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListInboxResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    KYCAdminService_GetUserKYCData: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user whose verified identity to return, as a UUID. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetVerifiedIdentityResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    KYCAdminService_AdminListPersonaDecisions: {
        parameters: {
            query?: {
                /** @description The maximum number of items to return. */
                limit?: number;
                /** @description The number of items to skip before the first result. */
                offset?: number;
            };
            header?: never;
            path: {
                /** @description The acting user's identifier, as a UUID. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminListPersonaDecisionsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    KYCAdminService_AdminListPersonaInquiries: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The acting user's identifier, as a UUID. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminListPersonaInquiriesResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    KYCAdminService_AdminListWebhookEvents: {
        parameters: {
            query?: {
                /** @description The maximum number of items to return. */
                limit?: number;
                /** @description The number of items to skip before the first result. */
                offset?: number;
            };
            header?: never;
            path: {
                /** @description The acting user's identifier, as a UUID. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminListWebhookEventsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RampsAdminService_AdminGetProviderCustomer: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user, as a UUID. */
                userId: string;
                /** @description The provider to fetch the record from. */
                provider: components["schemas"]["Provider"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminGetProviderCustomerResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    KYCAdminService_GetUserKYCStatus: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user whose status to return, as a UUID. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetStatusResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    NotificationsAdminService_GetUserLifecycle: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user, as a UUID. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserLifecycle"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    NotificationsAdminService_RestartUserLifecycle: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The staff test account to restart, as a UUID. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RestartUserLifecycleRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserLifecycle"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RampsAdminService_ListUserLinkedAccounts: {
        parameters: {
            query?: {
                /** @description A provider to filter by. Omit for every provider. */
                provider?: components["schemas"]["Provider"];
            };
            header?: never;
            path: {
                /** @description The owning user's identifier, as a UUID. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListAccountsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    InvestingAdminService_GetUserPortfolio: {
        parameters: {
            query?: {
                /** @description The window for period-scoped profit-and-loss figures. UNSPECIFIED is read as ALL and returns lifetime figures only. */
                period?: components["schemas"]["PortfolioPeriod"];
            };
            header?: never;
            path: {
                /** @description The user whose portfolio to return, as a UUID. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetPortfolioResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    UsersAdminService_GetUserPreferences: {
        parameters: {
            query?: {
                /** @description A notification type to limit the result to (e.g. `payment.incoming_settled`). Omit for all types. */
                notificationType?: string;
            };
            header?: never;
            path: {
                /** @description The user whose preferences to return, as a UUID. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NotificationPreferences"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RampsAdminService_ListUserRecipients: {
        parameters: {
            query?: {
                /** @description The maximum number of recipients to return. Zero selects the server default. */
                limit?: number;
                /** @description The number of recipients to skip before the first returned. */
                offset?: number;
            };
            header?: never;
            path: {
                /** @description The owning user's identifier, as a UUID. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListRecipientsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    SavingsAdminService_GetUserSavings: {
        parameters: {
            query?: {
                /** @description The asset to limit the result to, as a stablecoin code. Omit for all assets. */
                assetSymbol?: string;
                /** @description The chains to query. Empty queries every configured chain. */
                chains?: components["schemas"]["Chain"][];
            };
            header?: never;
            path: {
                /** @description The user whose balances to return, as a UUID. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetBalanceResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    ScheduledPaymentsAdminService_ListUserSchedules: {
        parameters: {
            query?: {
                /** @description The maximum number of schedules to return. Zero selects the default page size. */
                pageSize?: number;
                /** @description A page token from a previous response. Omit for the first page. */
                pageToken?: string;
            };
            header?: never;
            path: {
                /** @description The user whose schedules to list, as a UUID. Taken from the request path. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListPaymentSchedulesResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    ScheduledPaymentsAdminService_ListScheduleJobs: {
        parameters: {
            query?: {
                /** @description The maximum number of jobs to return. Zero selects the default page size. */
                pageSize?: number;
                /** @description A page token from a previous response. Omit for the first page. */
                pageToken?: string;
            };
            header?: never;
            path: {
                /** @description The schedule's owner, as a UUID. Taken from the request path; the jobs are returned only when the schedule belongs to this user. */
                userId: string;
                /** @description The schedule whose jobs to list, as a UUID. */
                scheduleId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListPaymentScheduleJobsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    AuthAdminService_GetSuspension: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user whose suspension to read, as a UUID. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Suspension"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    AuthAdminService_DeleteSuspension: {
        parameters: {
            query?: {
                /** @description The operator's reason, stored on the suspension and audit-logged. */
                reason?: string;
                /** @description The operator's email. The server sets this from the caller's verified admin identity; a value sent by a client is overwritten. */
                actorEmail?: string;
            };
            header?: never;
            path: {
                /** @description The user whose suspension to lift, as a UUID. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    AuthAdminService_UpdateSuspension: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user to suspend, as a UUID. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateSuspensionRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Suspension"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    LedgerAdminService_ListUserLedgerTransactions: {
        parameters: {
            query?: {
                /** @description A transaction context to filter by. */
                context?: components["schemas"]["TransactionContext"];
                /** @description A transaction status to filter by. */
                status?: components["schemas"]["Transaction_State"];
                /** @description The maximum number of transactions to return. */
                pageSize?: number;
                /** @description An opaque cursor from a previous response. Omit for the first page. */
                pageToken?: string;
                /** @description An asset symbol to filter by (for example `USDC`). */
                assetSymbol?: string;
            };
            header?: never;
            path: {
                /** @description The user whose transactions to list, as a UUID. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListTransactionsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    WalletsAdminService_ListUserWalletTransactions: {
        parameters: {
            query?: {
                /** @description The EVM chain identifier. */
                chainId?: number;
                /** @description The status to filter by: "pending", "success", or "failed"; empty returns all. */
                status?: string;
                /** @description The maximum number of items to return. */
                limit?: number;
                /** @description The number of items to skip before the first result. */
                offset?: number;
            };
            header?: never;
            path: {
                /** @description The user whose transactions to list, as a UUID. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListUserWalletTransactionsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    WalletsAdminService_GetUserWallets: {
        parameters: {
            query?: {
                /** @description The EVM chain identifier. */
                chainId?: number;
            };
            header?: never;
            path: {
                /** @description The user whose wallets to return, as a UUID. */
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListUserWalletsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    RewardsAdminService_GetRewardPayment: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user id. */
                user: string;
                /** @description The rewardPayment id. */
                rewardPayment: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RewardPayment"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    WalletsAdminService_ListWallets: {
        parameters: {
            query?: {
                /** @description The user whose wallets to list, as a UUID. */
                userId?: string;
                /** @description The EVM chain identifier. */
                chainId?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ListUserWalletsResponse"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
    WalletsAdminService_GetWallet: {
        parameters: {
            query?: {
                /** @description The EVM chain identifier. */
                chainId?: number;
                /** @description The token symbols to include; empty includes every supported token. */
                tokenSymbols?: string[];
            };
            header?: never;
            path: {
                /** @description The wallet address to read. */
                address: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["WalletBalance"];
                };
            };
            /** @description Default error response */
            default: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Status"];
                };
            };
        };
    };
}
export enum AcquisitionSource {
    ACQUISITION_SOURCE_FRIEND_OR_FAMILY = "ACQUISITION_SOURCE_FRIEND_OR_FAMILY",
    ACQUISITION_SOURCE_IN_PERSON = "ACQUISITION_SOURCE_IN_PERSON",
    ACQUISITION_SOURCE_APP_STORE = "ACQUISITION_SOURCE_APP_STORE",
    ACQUISITION_SOURCE_GOOGLE_SEARCH = "ACQUISITION_SOURCE_GOOGLE_SEARCH",
    ACQUISITION_SOURCE_AI_ASSISTANT = "ACQUISITION_SOURCE_AI_ASSISTANT",
    ACQUISITION_SOURCE_TIKTOK = "ACQUISITION_SOURCE_TIKTOK",
    ACQUISITION_SOURCE_INSTAGRAM = "ACQUISITION_SOURCE_INSTAGRAM",
    ACQUISITION_SOURCE_X = "ACQUISITION_SOURCE_X",
    ACQUISITION_SOURCE_YOUTUBE = "ACQUISITION_SOURCE_YOUTUBE",
    ACQUISITION_SOURCE_REDDIT = "ACQUISITION_SOURCE_REDDIT",
    ACQUISITION_SOURCE_PODCAST_OR_NEWS = "ACQUISITION_SOURCE_PODCAST_OR_NEWS",
    ACQUISITION_SOURCE_OTHER = "ACQUISITION_SOURCE_OTHER",
    ACQUISITION_SOURCE_SOCIAL_MEDIA = "ACQUISITION_SOURCE_SOCIAL_MEDIA"
}
export enum AdminSortDirection {
    ADMIN_SORT_DIRECTION_ASC = "ADMIN_SORT_DIRECTION_ASC",
    ADMIN_SORT_DIRECTION_DESC = "ADMIN_SORT_DIRECTION_DESC"
}
export enum AdminUserSortField {
    ADMIN_USER_SORT_FIELD_CREATED_AT = "ADMIN_USER_SORT_FIELD_CREATED_AT",
    ADMIN_USER_SORT_FIELD_EMAIL = "ADMIN_USER_SORT_FIELD_EMAIL",
    ADMIN_USER_SORT_FIELD_FIRST_NAME = "ADMIN_USER_SORT_FIELD_FIRST_NAME",
    ADMIN_USER_SORT_FIELD_LAST_NAME = "ADMIN_USER_SORT_FIELD_LAST_NAME",
    ADMIN_USER_SORT_FIELD_USER_ID = "ADMIN_USER_SORT_FIELD_USER_ID",
    ADMIN_USER_SORT_FIELD_PLATFORMS = "ADMIN_USER_SORT_FIELD_PLATFORMS",
    ADMIN_USER_SORT_FIELD_ONBOARDING = "ADMIN_USER_SORT_FIELD_ONBOARDING"
}
export enum AnnouncementStatusFilter {
    ANNOUNCEMENT_STATUS_FILTER_ALL = "ANNOUNCEMENT_STATUS_FILTER_ALL",
    ANNOUNCEMENT_STATUS_FILTER_ACTIVE = "ANNOUNCEMENT_STATUS_FILTER_ACTIVE",
    ANNOUNCEMENT_STATUS_FILTER_EXPIRED = "ANNOUNCEMENT_STATUS_FILTER_EXPIRED",
    ANNOUNCEMENT_STATUS_FILTER_SCHEDULED = "ANNOUNCEMENT_STATUS_FILTER_SCHEDULED"
}
export enum AnnouncementType {
    ANNOUNCEMENT_TYPE_MAINTENANCE = "ANNOUNCEMENT_TYPE_MAINTENANCE",
    ANNOUNCEMENT_TYPE_FEATURE = "ANNOUNCEMENT_TYPE_FEATURE",
    ANNOUNCEMENT_TYPE_URGENT = "ANNOUNCEMENT_TYPE_URGENT",
    ANNOUNCEMENT_TYPE_PROMO = "ANNOUNCEMENT_TYPE_PROMO"
}
export enum AttributionSource {
    ATTRIBUTION_SOURCE_EMAIL_BIND = "ATTRIBUTION_SOURCE_EMAIL_BIND",
    ATTRIBUTION_SOURCE_INSTALL_REFERRER = "ATTRIBUTION_SOURCE_INSTALL_REFERRER",
    ATTRIBUTION_SOURCE_INSTALL_CLICK = "ATTRIBUTION_SOURCE_INSTALL_CLICK",
    ATTRIBUTION_SOURCE_APP_CLIP = "ATTRIBUTION_SOURCE_APP_CLIP",
    ATTRIBUTION_SOURCE_MANUAL_ENTRY = "ATTRIBUTION_SOURCE_MANUAL_ENTRY"
}
export enum AudienceKind {
    AUDIENCE_KIND_ALL = "AUDIENCE_KIND_ALL",
    AUDIENCE_KIND_USER_IDS = "AUDIENCE_KIND_USER_IDS",
    AUDIENCE_KIND_FILTERS = "AUDIENCE_KIND_FILTERS"
}
export enum Chain {
    CHAIN_ARBITRUM = "CHAIN_ARBITRUM",
    CHAIN_BASE = "CHAIN_BASE",
    CHAIN_OPTIMISM = "CHAIN_OPTIMISM",
    CHAIN_BASE_SEPOLIA = "CHAIN_BASE_SEPOLIA"
}
export enum Channel {
    CHANNEL_EMAIL = "CHANNEL_EMAIL",
    CHANNEL_WEB_PUSH = "CHANNEL_WEB_PUSH",
    CHANNEL_MOBILE_PUSH = "CHANNEL_MOBILE_PUSH",
    CHANNEL_SMS = "CHANNEL_SMS",
    CHANNEL_WHATSAPP = "CHANNEL_WHATSAPP"
}
export enum ConversationFlag_Source {
    SOURCE_ADMIN = "SOURCE_ADMIN",
    SOURCE_SLACK = "SOURCE_SLACK"
}
export enum ConversationFlag_State {
    STATE_OPEN = "STATE_OPEN",
    STATE_REVIEWED = "STATE_REVIEWED",
    STATE_ACTIONED = "STATE_ACTIONED"
}
export enum Direction {
    DIRECTION_DEBIT = "DIRECTION_DEBIT",
    DIRECTION_CREDIT = "DIRECTION_CREDIT"
}
export enum EventGuest_Eligibility {
    ELIGIBILITY_SUBMITTED = "ELIGIBILITY_SUBMITTED",
    ELIGIBILITY_VERIFIED = "ELIGIBILITY_VERIFIED",
    ELIGIBILITY_NOT_SUBMITTED = "ELIGIBILITY_NOT_SUBMITTED",
    ELIGIBILITY_REJECTED = "ELIGIBILITY_REJECTED"
}
export enum FeedbackKind {
    FEEDBACK_KIND_BUG = "FEEDBACK_KIND_BUG",
    FEEDBACK_KIND_FEATURE_REQUEST = "FEEDBACK_KIND_FEATURE_REQUEST",
    FEEDBACK_KIND_FEEDBACK = "FEEDBACK_KIND_FEEDBACK"
}
export enum GraphNodeKind {
    GRAPH_NODE_KIND_MEMORY = "GRAPH_NODE_KIND_MEMORY",
    GRAPH_NODE_KIND_ENTITY = "GRAPH_NODE_KIND_ENTITY"
}
export enum IDClass {
    ID_CLASS_DRIVERS_LICENSE = "ID_CLASS_DRIVERS_LICENSE",
    ID_CLASS_PASSPORT = "ID_CLASS_PASSPORT",
    ID_CLASS_ID_CARD = "ID_CLASS_ID_CARD",
    ID_CLASS_RESIDENCE_PERMIT = "ID_CLASS_RESIDENCE_PERMIT",
    ID_CLASS_VISA = "ID_CLASS_VISA"
}
export enum InquiryState {
    INQUIRY_STATUS_CREATED = "INQUIRY_STATUS_CREATED",
    INQUIRY_STATUS_PENDING = "INQUIRY_STATUS_PENDING",
    INQUIRY_STATUS_COMPLETED = "INQUIRY_STATUS_COMPLETED",
    INQUIRY_STATUS_EXPIRED = "INQUIRY_STATUS_EXPIRED",
    INQUIRY_STATUS_FAILED = "INQUIRY_STATUS_FAILED",
    INQUIRY_STATUS_NEEDS_REVIEW = "INQUIRY_STATUS_NEEDS_REVIEW",
    INQUIRY_STATUS_APPROVED = "INQUIRY_STATUS_APPROVED",
    INQUIRY_STATUS_DECLINED = "INQUIRY_STATUS_DECLINED"
}
export enum JobState {
    JOB_STATUS_PENDING = "JOB_STATUS_PENDING",
    JOB_STATUS_SUCCESS = "JOB_STATUS_SUCCESS",
    JOB_STATUS_FAILED = "JOB_STATUS_FAILED"
}
export enum KYCState {
    KYC_STATUS_PENDING = "KYC_STATUS_PENDING",
    KYC_STATUS_UNDER_REVIEW = "KYC_STATUS_UNDER_REVIEW",
    KYC_STATUS_NEEDS_INFO = "KYC_STATUS_NEEDS_INFO",
    KYC_STATUS_VERIFIED = "KYC_STATUS_VERIFIED",
    KYC_STATUS_REJECTED = "KYC_STATUS_REJECTED",
    KYC_STATUS_SUSPENDED = "KYC_STATUS_SUSPENDED"
}
export enum LinkedAccount_State {
    LINKED_ACCOUNT_STATUS_ACTIVE = "LINKED_ACCOUNT_STATUS_ACTIVE",
    LINKED_ACCOUNT_STATUS_INACTIVE = "LINKED_ACCOUNT_STATUS_INACTIVE"
}
export enum MerchantIdentity_Type {
    TYPE_CNPJ = "TYPE_CNPJ",
    TYPE_PIX_KEY = "TYPE_PIX_KEY"
}
export enum NextAction {
    NEXT_ACTION_NONE = "NEXT_ACTION_NONE",
    NEXT_ACTION_START_VERIFICATION = "NEXT_ACTION_START_VERIFICATION",
    NEXT_ACTION_RESUME_VERIFICATION = "NEXT_ACTION_RESUME_VERIFICATION",
    NEXT_ACTION_PROVIDE_DETAILS = "NEXT_ACTION_PROVIDE_DETAILS",
    NEXT_ACTION_WAIT = "NEXT_ACTION_WAIT",
    NEXT_ACTION_CONTACT_SUPPORT = "NEXT_ACTION_CONTACT_SUPPORT"
}
export enum NimAudienceKind {
    AUDIENCE_KIND_ALL = "AUDIENCE_KIND_ALL",
    AUDIENCE_KIND_USER_IDS = "AUDIENCE_KIND_USER_IDS",
    AUDIENCE_KIND_FILTERS = "AUDIENCE_KIND_FILTERS"
}
export enum NimCallEndReason {
    NIM_CALL_END_REASON_END_CALL = "NIM_CALL_END_REASON_END_CALL",
    NIM_CALL_END_REASON_CALLER_NEVER_JOINED = "NIM_CALL_END_REASON_CALLER_NEVER_JOINED",
    NIM_CALL_END_REASON_CALLER_LEFT = "NIM_CALL_END_REASON_CALLER_LEFT",
    NIM_CALL_END_REASON_CALLER_ENDED = "NIM_CALL_END_REASON_CALLER_ENDED",
    NIM_CALL_END_REASON_NIM_DISCONNECTED = "NIM_CALL_END_REASON_NIM_DISCONNECTED",
    NIM_CALL_END_REASON_AUDIO_FAILED = "NIM_CALL_END_REASON_AUDIO_FAILED",
    NIM_CALL_END_REASON_ASSISTANT_ENDED = "NIM_CALL_END_REASON_ASSISTANT_ENDED",
    NIM_CALL_END_REASON_VOICE_FAILED = "NIM_CALL_END_REASON_VOICE_FAILED",
    NIM_CALL_END_REASON_MAX_LENGTH = "NIM_CALL_END_REASON_MAX_LENGTH",
    NIM_CALL_END_REASON_SHUTDOWN = "NIM_CALL_END_REASON_SHUTDOWN",
    NIM_CALL_END_REASON_DECLINED = "NIM_CALL_END_REASON_DECLINED",
    NIM_CALL_END_REASON_RING_TIMEOUT = "NIM_CALL_END_REASON_RING_TIMEOUT",
    NIM_CALL_END_REASON_NO_DEVICE_REACHED = "NIM_CALL_END_REASON_NO_DEVICE_REACHED",
    NIM_CALL_END_REASON_LOST = "NIM_CALL_END_REASON_LOST"
}
export enum NimCallInitiator {
    NIM_CALL_INITIATOR_USER = "NIM_CALL_INITIATOR_USER",
    NIM_CALL_INITIATOR_AGENT = "NIM_CALL_INITIATOR_AGENT",
    NIM_CALL_INITIATOR_SCHEDULED = "NIM_CALL_INITIATOR_SCHEDULED",
    NIM_CALL_INITIATOR_ADMIN = "NIM_CALL_INITIATOR_ADMIN"
}
export enum NimCall_State {
    STATE_RINGING = "STATE_RINGING",
    STATE_ANSWERED = "STATE_ANSWERED",
    STATE_DECLINED = "STATE_DECLINED",
    STATE_MISSED = "STATE_MISSED",
    STATE_ENDED = "STATE_ENDED"
}
export enum OnboardingGoal {
    ONBOARDING_GOAL_INVESTING = "ONBOARDING_GOAL_INVESTING",
    ONBOARDING_GOAL_SAVING = "ONBOARDING_GOAL_SAVING",
    ONBOARDING_GOAL_TRANSFERS = "ONBOARDING_GOAL_TRANSFERS",
    ONBOARDING_GOAL_NONE = "ONBOARDING_GOAL_NONE"
}
export enum OwnerType {
    OWNER_TYPE_INDIVIDUAL = "OWNER_TYPE_INDIVIDUAL",
    OWNER_TYPE_BUSINESS = "OWNER_TYPE_BUSINESS"
}
export enum PersonaInquiryState {
    INQUIRY_STATUS_CREATED = "INQUIRY_STATUS_CREATED",
    INQUIRY_STATUS_PENDING = "INQUIRY_STATUS_PENDING",
    INQUIRY_STATUS_COMPLETED = "INQUIRY_STATUS_COMPLETED",
    INQUIRY_STATUS_EXPIRED = "INQUIRY_STATUS_EXPIRED",
    INQUIRY_STATUS_FAILED = "INQUIRY_STATUS_FAILED",
    INQUIRY_STATUS_NEEDS_REVIEW = "INQUIRY_STATUS_NEEDS_REVIEW",
    INQUIRY_STATUS_APPROVED = "INQUIRY_STATUS_APPROVED",
    INQUIRY_STATUS_DECLINED = "INQUIRY_STATUS_DECLINED"
}
export enum Platform {
    PLATFORM_WEB = "PLATFORM_WEB",
    PLATFORM_IOS = "PLATFORM_IOS",
    PLATFORM_ANDROID = "PLATFORM_ANDROID"
}
export enum PortfolioPeriod {
    PORTFOLIO_PERIOD_1D = "PORTFOLIO_PERIOD_1D",
    PORTFOLIO_PERIOD_1W = "PORTFOLIO_PERIOD_1W",
    PORTFOLIO_PERIOD_1M = "PORTFOLIO_PERIOD_1M",
    PORTFOLIO_PERIOD_3M = "PORTFOLIO_PERIOD_3M",
    PORTFOLIO_PERIOD_1Y = "PORTFOLIO_PERIOD_1Y",
    PORTFOLIO_PERIOD_5Y = "PORTFOLIO_PERIOD_5Y",
    PORTFOLIO_PERIOD_ALL = "PORTFOLIO_PERIOD_ALL"
}
export enum Provider {
    PROVIDER_FERN = "PROVIDER_FERN",
    PROVIDER_AVENIA = "PROVIDER_AVENIA",
    PROVIDER_RAIN = "PROVIDER_RAIN",
    PROVIDER_BRIDGE = "PROVIDER_BRIDGE",
    PROVIDER_MANTECA = "PROVIDER_MANTECA",
    PROVIDER_BLINDPAY = "PROVIDER_BLINDPAY"
}
export enum PushAnnouncement_State {
    PUSH_ANNOUNCEMENT_STATUS_SCHEDULED = "PUSH_ANNOUNCEMENT_STATUS_SCHEDULED",
    PUSH_ANNOUNCEMENT_STATUS_SENDING = "PUSH_ANNOUNCEMENT_STATUS_SENDING",
    PUSH_ANNOUNCEMENT_STATUS_SENT = "PUSH_ANNOUNCEMENT_STATUS_SENT",
    PUSH_ANNOUNCEMENT_STATUS_CANCELLED = "PUSH_ANNOUNCEMENT_STATUS_CANCELLED"
}
export enum RampAvailability {
    AVAILABILITY_AVAILABLE = "AVAILABILITY_AVAILABLE",
    AVAILABILITY_PENDING_REVIEW = "AVAILABILITY_PENDING_REVIEW",
    AVAILABILITY_REGION_UNAVAILABLE = "AVAILABILITY_REGION_UNAVAILABLE",
    AVAILABILITY_REVOKED = "AVAILABILITY_REVOKED"
}
export enum RampCurrency {
    CURRENCY_AED = "CURRENCY_AED",
    CURRENCY_ARS = "CURRENCY_ARS",
    CURRENCY_AUD = "CURRENCY_AUD",
    CURRENCY_AZN = "CURRENCY_AZN",
    CURRENCY_BAM = "CURRENCY_BAM",
    CURRENCY_BDT = "CURRENCY_BDT",
    CURRENCY_BGN = "CURRENCY_BGN",
    CURRENCY_BHD = "CURRENCY_BHD",
    CURRENCY_BOB = "CURRENCY_BOB",
    CURRENCY_BRL = "CURRENCY_BRL",
    CURRENCY_BWP = "CURRENCY_BWP",
    CURRENCY_CAD = "CURRENCY_CAD",
    CURRENCY_CDF = "CURRENCY_CDF",
    CURRENCY_CHF = "CURRENCY_CHF",
    CURRENCY_CLP = "CURRENCY_CLP",
    CURRENCY_CNY = "CURRENCY_CNY",
    CURRENCY_COP = "CURRENCY_COP",
    CURRENCY_CRC = "CURRENCY_CRC",
    CURRENCY_CZK = "CURRENCY_CZK",
    CURRENCY_DKK = "CURRENCY_DKK",
    CURRENCY_DOP = "CURRENCY_DOP",
    CURRENCY_DZD = "CURRENCY_DZD",
    CURRENCY_EGP = "CURRENCY_EGP",
    CURRENCY_ETB = "CURRENCY_ETB",
    CURRENCY_EUR = "CURRENCY_EUR",
    CURRENCY_GBP = "CURRENCY_GBP",
    CURRENCY_GEL = "CURRENCY_GEL",
    CURRENCY_GHS = "CURRENCY_GHS",
    CURRENCY_GTQ = "CURRENCY_GTQ",
    CURRENCY_GYD = "CURRENCY_GYD",
    CURRENCY_HKD = "CURRENCY_HKD",
    CURRENCY_HNL = "CURRENCY_HNL",
    CURRENCY_HRK = "CURRENCY_HRK",
    CURRENCY_HTG = "CURRENCY_HTG",
    CURRENCY_HUF = "CURRENCY_HUF",
    CURRENCY_IDR = "CURRENCY_IDR",
    CURRENCY_ILS = "CURRENCY_ILS",
    CURRENCY_INR = "CURRENCY_INR",
    CURRENCY_ISK = "CURRENCY_ISK",
    CURRENCY_JMD = "CURRENCY_JMD",
    CURRENCY_JOD = "CURRENCY_JOD",
    CURRENCY_JPY = "CURRENCY_JPY",
    CURRENCY_KES = "CURRENCY_KES",
    CURRENCY_KHR = "CURRENCY_KHR",
    CURRENCY_KRW = "CURRENCY_KRW",
    CURRENCY_KWD = "CURRENCY_KWD",
    CURRENCY_KZT = "CURRENCY_KZT",
    CURRENCY_LKR = "CURRENCY_LKR",
    CURRENCY_MAD = "CURRENCY_MAD",
    CURRENCY_MGA = "CURRENCY_MGA",
    CURRENCY_MKD = "CURRENCY_MKD",
    CURRENCY_MMK = "CURRENCY_MMK",
    CURRENCY_MNT = "CURRENCY_MNT",
    CURRENCY_MWK = "CURRENCY_MWK",
    CURRENCY_MXN = "CURRENCY_MXN",
    CURRENCY_MYR = "CURRENCY_MYR",
    CURRENCY_MZN = "CURRENCY_MZN",
    CURRENCY_NAD = "CURRENCY_NAD",
    CURRENCY_NGN = "CURRENCY_NGN",
    CURRENCY_NIO = "CURRENCY_NIO",
    CURRENCY_NOK = "CURRENCY_NOK",
    CURRENCY_NPR = "CURRENCY_NPR",
    CURRENCY_NZD = "CURRENCY_NZD",
    CURRENCY_OMR = "CURRENCY_OMR",
    CURRENCY_PEN = "CURRENCY_PEN",
    CURRENCY_PGK = "CURRENCY_PGK",
    CURRENCY_PHP = "CURRENCY_PHP",
    CURRENCY_PKR = "CURRENCY_PKR",
    CURRENCY_PLN = "CURRENCY_PLN",
    CURRENCY_PYG = "CURRENCY_PYG",
    CURRENCY_QAR = "CURRENCY_QAR",
    CURRENCY_RON = "CURRENCY_RON",
    CURRENCY_RSD = "CURRENCY_RSD",
    CURRENCY_RWF = "CURRENCY_RWF",
    CURRENCY_SAR = "CURRENCY_SAR",
    CURRENCY_SDG = "CURRENCY_SDG",
    CURRENCY_SEK = "CURRENCY_SEK",
    CURRENCY_SGD = "CURRENCY_SGD",
    CURRENCY_SLE = "CURRENCY_SLE",
    CURRENCY_SRD = "CURRENCY_SRD",
    CURRENCY_THB = "CURRENCY_THB",
    CURRENCY_TND = "CURRENCY_TND",
    CURRENCY_TRY = "CURRENCY_TRY",
    CURRENCY_TTD = "CURRENCY_TTD",
    CURRENCY_TWD = "CURRENCY_TWD",
    CURRENCY_TZS = "CURRENCY_TZS",
    CURRENCY_UAH = "CURRENCY_UAH",
    CURRENCY_UGX = "CURRENCY_UGX",
    CURRENCY_USD = "CURRENCY_USD",
    CURRENCY_UYU = "CURRENCY_UYU",
    CURRENCY_UZS = "CURRENCY_UZS",
    CURRENCY_VES = "CURRENCY_VES",
    CURRENCY_VND = "CURRENCY_VND",
    CURRENCY_XAF = "CURRENCY_XAF",
    CURRENCY_XOF = "CURRENCY_XOF",
    CURRENCY_ZAR = "CURRENCY_ZAR",
    CURRENCY_ZMW = "CURRENCY_ZMW",
    CURRENCY_BRLA = "CURRENCY_BRLA",
    CURRENCY_EURC = "CURRENCY_EURC",
    CURRENCY_USDC = "CURRENCY_USDC",
    CURRENCY_USDT = "CURRENCY_USDT",
    CURRENCY_USDB = "CURRENCY_USDB"
}
export enum RampDirection {
    DIRECTION_ONRAMP = "DIRECTION_ONRAMP",
    DIRECTION_OFFRAMP = "DIRECTION_OFFRAMP"
}
export enum RampPaymentMethod {
    PAYMENT_METHOD_ARBITRUM = "PAYMENT_METHOD_ARBITRUM",
    PAYMENT_METHOD_AVALANCHE = "PAYMENT_METHOD_AVALANCHE",
    PAYMENT_METHOD_BASE = "PAYMENT_METHOD_BASE",
    PAYMENT_METHOD_ETHEREUM = "PAYMENT_METHOD_ETHEREUM",
    PAYMENT_METHOD_OPTIMISM = "PAYMENT_METHOD_OPTIMISM",
    PAYMENT_METHOD_POLYGON = "PAYMENT_METHOD_POLYGON",
    PAYMENT_METHOD_STARKNET = "PAYMENT_METHOD_STARKNET",
    PAYMENT_METHOD_TRON = "PAYMENT_METHOD_TRON",
    PAYMENT_METHOD_AR_TRANSFERENCIA_30 = "PAYMENT_METHOD_AR_TRANSFERENCIA_30",
    PAYMENT_METHOD_AR_CBU = "PAYMENT_METHOD_AR_CBU",
    PAYMENT_METHOD_AR_MEP = "PAYMENT_METHOD_AR_MEP",
    PAYMENT_METHOD_BO_QR_BCB = "PAYMENT_METHOD_BO_QR_BCB",
    PAYMENT_METHOD_BO_RTGS = "PAYMENT_METHOD_BO_RTGS",
    PAYMENT_METHOD_BR_PIX = "PAYMENT_METHOD_BR_PIX",
    PAYMENT_METHOD_BR_TED = "PAYMENT_METHOD_BR_TED",
    PAYMENT_METHOD_BR_DOC = "PAYMENT_METHOD_BR_DOC",
    PAYMENT_METHOD_BR_STR = "PAYMENT_METHOD_BR_STR",
    PAYMENT_METHOD_BR_BOLETO = "PAYMENT_METHOD_BR_BOLETO",
    PAYMENT_METHOD_CA_INTERAC = "PAYMENT_METHOD_CA_INTERAC",
    PAYMENT_METHOD_CA_EFT = "PAYMENT_METHOD_CA_EFT",
    PAYMENT_METHOD_CA_LYNX = "PAYMENT_METHOD_CA_LYNX",
    PAYMENT_METHOD_CA_RTR = "PAYMENT_METHOD_CA_RTR",
    PAYMENT_METHOD_CL_TEF = "PAYMENT_METHOD_CL_TEF",
    PAYMENT_METHOD_CL_ACH = "PAYMENT_METHOD_CL_ACH",
    PAYMENT_METHOD_CL_LBTR = "PAYMENT_METHOD_CL_LBTR",
    PAYMENT_METHOD_CO_ACH = "PAYMENT_METHOD_CO_ACH",
    PAYMENT_METHOD_CO_PSE = "PAYMENT_METHOD_CO_PSE",
    PAYMENT_METHOD_CO_TRANSFIYA = "PAYMENT_METHOD_CO_TRANSFIYA",
    PAYMENT_METHOD_CO_CUD = "PAYMENT_METHOD_CO_CUD",
    PAYMENT_METHOD_CO_BRE_B = "PAYMENT_METHOD_CO_BRE_B",
    PAYMENT_METHOD_CR_SINPE = "PAYMENT_METHOD_CR_SINPE",
    PAYMENT_METHOD_CR_SINPE_MOVIL = "PAYMENT_METHOD_CR_SINPE_MOVIL",
    PAYMENT_METHOD_CR_PAKO = "PAYMENT_METHOD_CR_PAKO",
    PAYMENT_METHOD_DO_ACH = "PAYMENT_METHOD_DO_ACH",
    PAYMENT_METHOD_DO_BILLET = "PAYMENT_METHOD_DO_BILLET",
    PAYMENT_METHOD_EC_BCE = "PAYMENT_METHOD_EC_BCE",
    PAYMENT_METHOD_EC_RTGS = "PAYMENT_METHOD_EC_RTGS",
    PAYMENT_METHOD_GT_ACH = "PAYMENT_METHOD_GT_ACH",
    PAYMENT_METHOD_GT_TIGO = "PAYMENT_METHOD_GT_TIGO",
    PAYMENT_METHOD_HN_ACH_PRONTO = "PAYMENT_METHOD_HN_ACH_PRONTO",
    PAYMENT_METHOD_HN_RTGS = "PAYMENT_METHOD_HN_RTGS",
    PAYMENT_METHOD_HT_MONCASH = "PAYMENT_METHOD_HT_MONCASH",
    PAYMENT_METHOD_JM_ACH = "PAYMENT_METHOD_JM_ACH",
    PAYMENT_METHOD_JM_DIGICEL = "PAYMENT_METHOD_JM_DIGICEL",
    PAYMENT_METHOD_MX_SPEI = "PAYMENT_METHOD_MX_SPEI",
    PAYMENT_METHOD_MX_CODI = "PAYMENT_METHOD_MX_CODI",
    PAYMENT_METHOD_MX_TEF = "PAYMENT_METHOD_MX_TEF",
    PAYMENT_METHOD_NI_ACH = "PAYMENT_METHOD_NI_ACH",
    PAYMENT_METHOD_PA_ACH = "PAYMENT_METHOD_PA_ACH",
    PAYMENT_METHOD_PE_CCE = "PAYMENT_METHOD_PE_CCE",
    PAYMENT_METHOD_PE_LBTR = "PAYMENT_METHOD_PE_LBTR",
    PAYMENT_METHOD_PE_PLIN = "PAYMENT_METHOD_PE_PLIN",
    PAYMENT_METHOD_PY_SIPAP = "PAYMENT_METHOD_PY_SIPAP",
    PAYMENT_METHOD_PY_LBTR = "PAYMENT_METHOD_PY_LBTR",
    PAYMENT_METHOD_SR_RTGS = "PAYMENT_METHOD_SR_RTGS",
    PAYMENT_METHOD_SV_TRANSFER365 = "PAYMENT_METHOD_SV_TRANSFER365",
    PAYMENT_METHOD_SV_TIGO = "PAYMENT_METHOD_SV_TIGO",
    PAYMENT_METHOD_TT_ACH = "PAYMENT_METHOD_TT_ACH",
    PAYMENT_METHOD_US_ACH = "PAYMENT_METHOD_US_ACH",
    PAYMENT_METHOD_US_FEDWIRE = "PAYMENT_METHOD_US_FEDWIRE",
    PAYMENT_METHOD_US_RTP = "PAYMENT_METHOD_US_RTP",
    PAYMENT_METHOD_US_FEDNOW = "PAYMENT_METHOD_US_FEDNOW",
    PAYMENT_METHOD_US_CHIPS = "PAYMENT_METHOD_US_CHIPS",
    PAYMENT_METHOD_UY_ACH = "PAYMENT_METHOD_UY_ACH",
    PAYMENT_METHOD_UY_RTGS = "PAYMENT_METHOD_UY_RTGS",
    PAYMENT_METHOD_VE_PAGO_MOVIL = "PAYMENT_METHOD_VE_PAGO_MOVIL",
    PAYMENT_METHOD_GY_ACH = "PAYMENT_METHOD_GY_ACH",
    PAYMENT_METHOD_EU_SEPA_CT = "PAYMENT_METHOD_EU_SEPA_CT",
    PAYMENT_METHOD_EU_SEPA_INST = "PAYMENT_METHOD_EU_SEPA_INST",
    PAYMENT_METHOD_EU_SEPA_DD = "PAYMENT_METHOD_EU_SEPA_DD",
    PAYMENT_METHOD_GB_FPS = "PAYMENT_METHOD_GB_FPS",
    PAYMENT_METHOD_GB_BACS = "PAYMENT_METHOD_GB_BACS",
    PAYMENT_METHOD_GB_CHAPS = "PAYMENT_METHOD_GB_CHAPS",
    PAYMENT_METHOD_BG_BORICA_INST = "PAYMENT_METHOD_BG_BORICA_INST",
    PAYMENT_METHOD_BG_BISERA = "PAYMENT_METHOD_BG_BISERA",
    PAYMENT_METHOD_CH_SIC = "PAYMENT_METHOD_CH_SIC",
    PAYMENT_METHOD_CH_TWINT = "PAYMENT_METHOD_CH_TWINT",
    PAYMENT_METHOD_CZ_CERTIS = "PAYMENT_METHOD_CZ_CERTIS",
    PAYMENT_METHOD_CZ_CERTIS_INST = "PAYMENT_METHOD_CZ_CERTIS_INST",
    PAYMENT_METHOD_DK_STRAKSCLEARING = "PAYMENT_METHOD_DK_STRAKSCLEARING",
    PAYMENT_METHOD_DK_NETS = "PAYMENT_METHOD_DK_NETS",
    PAYMENT_METHOD_DK_NEMKONTO = "PAYMENT_METHOD_DK_NEMKONTO",
    PAYMENT_METHOD_GE_RTGS = "PAYMENT_METHOD_GE_RTGS",
    PAYMENT_METHOD_HR_NKSINST = "PAYMENT_METHOD_HR_NKSINST",
    PAYMENT_METHOD_HU_AFR = "PAYMENT_METHOD_HU_AFR",
    PAYMENT_METHOD_HU_GIRO = "PAYMENT_METHOD_HU_GIRO",
    PAYMENT_METHOD_IS_CBI = "PAYMENT_METHOD_IS_CBI",
    PAYMENT_METHOD_NO_STRAKSBETALINGER = "PAYMENT_METHOD_NO_STRAKSBETALINGER",
    PAYMENT_METHOD_NO_NICS = "PAYMENT_METHOD_NO_NICS",
    PAYMENT_METHOD_PL_EXPRESS_ELIXIR = "PAYMENT_METHOD_PL_EXPRESS_ELIXIR",
    PAYMENT_METHOD_PL_ELIXIR = "PAYMENT_METHOD_PL_ELIXIR",
    PAYMENT_METHOD_PL_BLUE_CASH = "PAYMENT_METHOD_PL_BLUE_CASH",
    PAYMENT_METHOD_PL_BLIK = "PAYMENT_METHOD_PL_BLIK",
    PAYMENT_METHOD_RO_TRANSFOND_INST = "PAYMENT_METHOD_RO_TRANSFOND_INST",
    PAYMENT_METHOD_RO_REGIS = "PAYMENT_METHOD_RO_REGIS",
    PAYMENT_METHOD_RS_IPS = "PAYMENT_METHOD_RS_IPS",
    PAYMENT_METHOD_RU_SBP = "PAYMENT_METHOD_RU_SBP",
    PAYMENT_METHOD_RU_BESP = "PAYMENT_METHOD_RU_BESP",
    PAYMENT_METHOD_SE_SWISH = "PAYMENT_METHOD_SE_SWISH",
    PAYMENT_METHOD_SE_BIR = "PAYMENT_METHOD_SE_BIR",
    PAYMENT_METHOD_TR_FAST = "PAYMENT_METHOD_TR_FAST",
    PAYMENT_METHOD_TR_EFT = "PAYMENT_METHOD_TR_EFT",
    PAYMENT_METHOD_UA_SEP = "PAYMENT_METHOD_UA_SEP",
    PAYMENT_METHOD_AZ_IPS = "PAYMENT_METHOD_AZ_IPS",
    PAYMENT_METHOD_AE_AANI = "PAYMENT_METHOD_AE_AANI",
    PAYMENT_METHOD_AE_UAEFTS = "PAYMENT_METHOD_AE_UAEFTS",
    PAYMENT_METHOD_AE_FTS = "PAYMENT_METHOD_AE_FTS",
    PAYMENT_METHOD_BH_FAWRI_PLUS = "PAYMENT_METHOD_BH_FAWRI_PLUS",
    PAYMENT_METHOD_BH_FAWRI = "PAYMENT_METHOD_BH_FAWRI",
    PAYMENT_METHOD_EG_IPN = "PAYMENT_METHOD_EG_IPN",
    PAYMENT_METHOD_EG_RTGS = "PAYMENT_METHOD_EG_RTGS",
    PAYMENT_METHOD_EG_MEEZA = "PAYMENT_METHOD_EG_MEEZA",
    PAYMENT_METHOD_ET_ETHSWITCH = "PAYMENT_METHOD_ET_ETHSWITCH",
    PAYMENT_METHOD_ET_TELEBIRR = "PAYMENT_METHOD_ET_TELEBIRR",
    PAYMENT_METHOD_GH_GIP = "PAYMENT_METHOD_GH_GIP",
    PAYMENT_METHOD_GH_GHIPSS_ACH = "PAYMENT_METHOD_GH_GHIPSS_ACH",
    PAYMENT_METHOD_GH_MMI = "PAYMENT_METHOD_GH_MMI",
    PAYMENT_METHOD_IL_ZAHAV = "PAYMENT_METHOD_IL_ZAHAV",
    PAYMENT_METHOD_IL_MASAV = "PAYMENT_METHOD_IL_MASAV",
    PAYMENT_METHOD_JO_CLIQ = "PAYMENT_METHOD_JO_CLIQ",
    PAYMENT_METHOD_JO_ACH = "PAYMENT_METHOD_JO_ACH",
    PAYMENT_METHOD_KE_PESALINK = "PAYMENT_METHOD_KE_PESALINK",
    PAYMENT_METHOD_KE_MPESA = "PAYMENT_METHOD_KE_MPESA",
    PAYMENT_METHOD_KE_RTGS = "PAYMENT_METHOD_KE_RTGS",
    PAYMENT_METHOD_KE_KEPSS = "PAYMENT_METHOD_KE_KEPSS",
    PAYMENT_METHOD_KW_KNET = "PAYMENT_METHOD_KW_KNET",
    PAYMENT_METHOD_MA_SIMT = "PAYMENT_METHOD_MA_SIMT",
    PAYMENT_METHOD_MA_SRBM = "PAYMENT_METHOD_MA_SRBM",
    PAYMENT_METHOD_MW_RTGS = "PAYMENT_METHOD_MW_RTGS",
    PAYMENT_METHOD_MW_MOBILE_MONEY = "PAYMENT_METHOD_MW_MOBILE_MONEY",
    PAYMENT_METHOD_NG_NIP = "PAYMENT_METHOD_NG_NIP",
    PAYMENT_METHOD_NG_NACS = "PAYMENT_METHOD_NG_NACS",
    PAYMENT_METHOD_NG_RTGS = "PAYMENT_METHOD_NG_RTGS",
    PAYMENT_METHOD_OM_OMANNET = "PAYMENT_METHOD_OM_OMANNET",
    PAYMENT_METHOD_QA_QPS = "PAYMENT_METHOD_QA_QPS",
    PAYMENT_METHOD_QA_FAWRAN = "PAYMENT_METHOD_QA_FAWRAN",
    PAYMENT_METHOD_RW_RSWITCH = "PAYMENT_METHOD_RW_RSWITCH",
    PAYMENT_METHOD_RW_MOBILE_MONEY = "PAYMENT_METHOD_RW_MOBILE_MONEY",
    PAYMENT_METHOD_SA_SARIE = "PAYMENT_METHOD_SA_SARIE",
    PAYMENT_METHOD_SA_MADA = "PAYMENT_METHOD_SA_MADA",
    PAYMENT_METHOD_SL_MOBILE_MONEY = "PAYMENT_METHOD_SL_MOBILE_MONEY",
    PAYMENT_METHOD_TZ_TIPS = "PAYMENT_METHOD_TZ_TIPS",
    PAYMENT_METHOD_TZ_MOBILE_MONEY = "PAYMENT_METHOD_TZ_MOBILE_MONEY",
    PAYMENT_METHOD_TZ_RTGS = "PAYMENT_METHOD_TZ_RTGS",
    PAYMENT_METHOD_UG_MOBILE_MONEY = "PAYMENT_METHOD_UG_MOBILE_MONEY",
    PAYMENT_METHOD_UG_RTGS = "PAYMENT_METHOD_UG_RTGS",
    PAYMENT_METHOD_XAF_BEAC_RTGS = "PAYMENT_METHOD_XAF_BEAC_RTGS",
    PAYMENT_METHOD_XAF_MOBILE_MONEY = "PAYMENT_METHOD_XAF_MOBILE_MONEY",
    PAYMENT_METHOD_XOF_BCEAO_RTGS = "PAYMENT_METHOD_XOF_BCEAO_RTGS",
    PAYMENT_METHOD_XOF_MOBILE_MONEY = "PAYMENT_METHOD_XOF_MOBILE_MONEY",
    PAYMENT_METHOD_ZA_RTC = "PAYMENT_METHOD_ZA_RTC",
    PAYMENT_METHOD_ZA_EFT = "PAYMENT_METHOD_ZA_EFT",
    PAYMENT_METHOD_ZA_SAMOS = "PAYMENT_METHOD_ZA_SAMOS",
    PAYMENT_METHOD_ZA_PAYSHAP = "PAYMENT_METHOD_ZA_PAYSHAP",
    PAYMENT_METHOD_ZM_ZAMSWITCH = "PAYMENT_METHOD_ZM_ZAMSWITCH",
    PAYMENT_METHOD_ZM_MOBILE_MONEY = "PAYMENT_METHOD_ZM_MOBILE_MONEY",
    PAYMENT_METHOD_AU_NPP = "PAYMENT_METHOD_AU_NPP",
    PAYMENT_METHOD_AU_BECS = "PAYMENT_METHOD_AU_BECS",
    PAYMENT_METHOD_AU_RITS = "PAYMENT_METHOD_AU_RITS",
    PAYMENT_METHOD_BD_BEFTN = "PAYMENT_METHOD_BD_BEFTN",
    PAYMENT_METHOD_BD_RTGS = "PAYMENT_METHOD_BD_RTGS",
    PAYMENT_METHOD_BD_BKASH = "PAYMENT_METHOD_BD_BKASH",
    PAYMENT_METHOD_BD_NAGAD = "PAYMENT_METHOD_BD_NAGAD",
    PAYMENT_METHOD_CN_IBPS = "PAYMENT_METHOD_CN_IBPS",
    PAYMENT_METHOD_CN_CNAPS = "PAYMENT_METHOD_CN_CNAPS",
    PAYMENT_METHOD_CN_WECHAT_PAY = "PAYMENT_METHOD_CN_WECHAT_PAY",
    PAYMENT_METHOD_CN_ALIPAY = "PAYMENT_METHOD_CN_ALIPAY",
    PAYMENT_METHOD_HK_FPS = "PAYMENT_METHOD_HK_FPS",
    PAYMENT_METHOD_HK_CHATS = "PAYMENT_METHOD_HK_CHATS",
    PAYMENT_METHOD_ID_BI_FAST = "PAYMENT_METHOD_ID_BI_FAST",
    PAYMENT_METHOD_ID_BI_RTGS = "PAYMENT_METHOD_ID_BI_RTGS",
    PAYMENT_METHOD_ID_SKN = "PAYMENT_METHOD_ID_SKN",
    PAYMENT_METHOD_IN_UPI = "PAYMENT_METHOD_IN_UPI",
    PAYMENT_METHOD_IN_IMPS = "PAYMENT_METHOD_IN_IMPS",
    PAYMENT_METHOD_IN_NEFT = "PAYMENT_METHOD_IN_NEFT",
    PAYMENT_METHOD_IN_RTGS = "PAYMENT_METHOD_IN_RTGS",
    PAYMENT_METHOD_JP_ZENGIN = "PAYMENT_METHOD_JP_ZENGIN",
    PAYMENT_METHOD_JP_BOJ_NET = "PAYMENT_METHOD_JP_BOJ_NET",
    PAYMENT_METHOD_KH_BAKONG = "PAYMENT_METHOD_KH_BAKONG",
    PAYMENT_METHOD_KR_EBS = "PAYMENT_METHOD_KR_EBS",
    PAYMENT_METHOD_KR_BOK_WIRE = "PAYMENT_METHOD_KR_BOK_WIRE",
    PAYMENT_METHOD_KZ_ISMT = "PAYMENT_METHOD_KZ_ISMT",
    PAYMENT_METHOD_KZ_KISC = "PAYMENT_METHOD_KZ_KISC",
    PAYMENT_METHOD_LK_CEFTS = "PAYMENT_METHOD_LK_CEFTS",
    PAYMENT_METHOD_LK_SLIPS = "PAYMENT_METHOD_LK_SLIPS",
    PAYMENT_METHOD_MN_QR_PAY = "PAYMENT_METHOD_MN_QR_PAY",
    PAYMENT_METHOD_MY_DUITNOW = "PAYMENT_METHOD_MY_DUITNOW",
    PAYMENT_METHOD_MY_IBG = "PAYMENT_METHOD_MY_IBG",
    PAYMENT_METHOD_MY_FPX = "PAYMENT_METHOD_MY_FPX",
    PAYMENT_METHOD_MY_RENTAS = "PAYMENT_METHOD_MY_RENTAS",
    PAYMENT_METHOD_NP_CONNECTIPS = "PAYMENT_METHOD_NP_CONNECTIPS",
    PAYMENT_METHOD_NP_NCHL = "PAYMENT_METHOD_NP_NCHL",
    PAYMENT_METHOD_NZ_BULK = "PAYMENT_METHOD_NZ_BULK",
    PAYMENT_METHOD_NZ_ESAS = "PAYMENT_METHOD_NZ_ESAS",
    PAYMENT_METHOD_PH_INSTAPAY = "PAYMENT_METHOD_PH_INSTAPAY",
    PAYMENT_METHOD_PH_PESONET = "PAYMENT_METHOD_PH_PESONET",
    PAYMENT_METHOD_PK_RAAST = "PAYMENT_METHOD_PK_RAAST",
    PAYMENT_METHOD_PK_IBFT = "PAYMENT_METHOD_PK_IBFT",
    PAYMENT_METHOD_PK_RTGS = "PAYMENT_METHOD_PK_RTGS",
    PAYMENT_METHOD_SG_PAYNOW = "PAYMENT_METHOD_SG_PAYNOW",
    PAYMENT_METHOD_SG_FAST = "PAYMENT_METHOD_SG_FAST",
    PAYMENT_METHOD_SG_MEPS = "PAYMENT_METHOD_SG_MEPS",
    PAYMENT_METHOD_TH_PROMPTPAY = "PAYMENT_METHOD_TH_PROMPTPAY",
    PAYMENT_METHOD_TH_BAHTNET = "PAYMENT_METHOD_TH_BAHTNET",
    PAYMENT_METHOD_TW_FINANCIAL_XML = "PAYMENT_METHOD_TW_FINANCIAL_XML",
    PAYMENT_METHOD_TW_CBC_RTGS = "PAYMENT_METHOD_TW_CBC_RTGS",
    PAYMENT_METHOD_VN_NAPAS = "PAYMENT_METHOD_VN_NAPAS",
    PAYMENT_METHOD_VN_IBPS = "PAYMENT_METHOD_VN_IBPS",
    PAYMENT_METHOD_SWIFT_MT = "PAYMENT_METHOD_SWIFT_MT",
    PAYMENT_METHOD_SWIFT_MX = "PAYMENT_METHOD_SWIFT_MX",
    PAYMENT_METHOD_PAPSS = "PAYMENT_METHOD_PAPSS",
    PAYMENT_METHOD_BUNA = "PAYMENT_METHOD_BUNA",
    PAYMENT_METHOD_CIPS = "PAYMENT_METHOD_CIPS",
    PAYMENT_METHOD_SIRESS = "PAYMENT_METHOD_SIRESS",
    PAYMENT_METHOD_VISA = "PAYMENT_METHOD_VISA",
    PAYMENT_METHOD_MASTERCARD = "PAYMENT_METHOD_MASTERCARD",
    PAYMENT_METHOD_AMEX = "PAYMENT_METHOD_AMEX",
    PAYMENT_METHOD_UNIONPAY = "PAYMENT_METHOD_UNIONPAY",
    PAYMENT_METHOD_JCB = "PAYMENT_METHOD_JCB",
    PAYMENT_METHOD_DISCOVER = "PAYMENT_METHOD_DISCOVER",
    PAYMENT_METHOD_RUPAY = "PAYMENT_METHOD_RUPAY",
    PAYMENT_METHOD_MADA_CARD = "PAYMENT_METHOD_MADA_CARD",
    PAYMENT_METHOD_MEEZA_CARD = "PAYMENT_METHOD_MEEZA_CARD",
    PAYMENT_METHOD_TROY = "PAYMENT_METHOD_TROY",
    PAYMENT_METHOD_MIR = "PAYMENT_METHOD_MIR",
    PAYMENT_METHOD_EFTPOS_NZ = "PAYMENT_METHOD_EFTPOS_NZ",
    PAYMENT_METHOD_BANCONTACT = "PAYMENT_METHOD_BANCONTACT",
    PAYMENT_METHOD_CARTES_BANCAIRES = "PAYMENT_METHOD_CARTES_BANCAIRES"
}
export enum RampProvider {
    PROVIDER_FERN = "PROVIDER_FERN",
    PROVIDER_AVENIA = "PROVIDER_AVENIA",
    PROVIDER_RAIN = "PROVIDER_RAIN",
    PROVIDER_BRIDGE = "PROVIDER_BRIDGE",
    PROVIDER_MANTECA = "PROVIDER_MANTECA",
    PROVIDER_BLINDPAY = "PROVIDER_BLINDPAY"
}
export enum RampRecipientType {
    RECIPIENT_TYPE_BANK_ACCOUNT = "RECIPIENT_TYPE_BANK_ACCOUNT",
    RECIPIENT_TYPE_CRYPTO_WALLET = "RECIPIENT_TYPE_CRYPTO_WALLET",
    RECIPIENT_TYPE_LIMINAL_USER = "RECIPIENT_TYPE_LIMINAL_USER"
}
export enum RecipientType {
    RECIPIENT_TYPE_BANK_ACCOUNT = "RECIPIENT_TYPE_BANK_ACCOUNT",
    RECIPIENT_TYPE_LIMINAL_USER = "RECIPIENT_TYPE_LIMINAL_USER"
}
export enum RewardBudget_State {
    STATE_OPEN = "STATE_OPEN",
    STATE_PAUSED = "STATE_PAUSED",
    STATE_CLOSED = "STATE_CLOSED"
}
export enum RewardEarnPayout_State {
    STATE_PENDING = "STATE_PENDING",
    STATE_SENDING = "STATE_SENDING",
    STATE_FAILED = "STATE_FAILED",
    STATE_PAID = "STATE_PAID"
}
export enum RewardMerchant_Category {
    CATEGORY_DINING_DRINKS = "CATEGORY_DINING_DRINKS",
    CATEGORY_ENTERTAINMENT = "CATEGORY_ENTERTAINMENT",
    CATEGORY_FIT_WELL = "CATEGORY_FIT_WELL",
    CATEGORY_SHOPPING = "CATEGORY_SHOPPING",
    CATEGORY_TRAVEL = "CATEGORY_TRAVEL"
}
export enum RewardMerchant_State {
    STATE_ACTIVE = "STATE_ACTIVE",
    STATE_PAUSED = "STATE_PAUSED",
    STATE_RETIRED = "STATE_RETIRED"
}
export enum RewardPayment_State {
    STATE_OPEN = "STATE_OPEN",
    STATE_EARNED = "STATE_EARNED",
    STATE_PAYING = "STATE_PAYING",
    STATE_REDEEMED = "STATE_REDEEMED",
    STATE_REFUNDED = "STATE_REFUNDED",
    STATE_REVIEW = "STATE_REVIEW"
}
export enum RewardRedemption_State {
    STATE_ACCEPTED = "STATE_ACCEPTED",
    STATE_COLLECTING = "STATE_COLLECTING",
    STATE_COLLECTED = "STATE_COLLECTED",
    STATE_COLLECT_FAILED = "STATE_COLLECT_FAILED",
    STATE_REIMBURSING = "STATE_REIMBURSING",
    STATE_REDEEMED = "STATE_REDEEMED"
}
export enum ScheduleState {
    SCHEDULE_STATUS_ACTIVE = "SCHEDULE_STATUS_ACTIVE",
    SCHEDULE_STATUS_PAUSED = "SCHEDULE_STATUS_PAUSED",
    SCHEDULE_STATUS_DELETED = "SCHEDULE_STATUS_DELETED"
}
export enum TransactionContext {
    TRANSACTION_CONTEXT_P2P = "TRANSACTION_CONTEXT_P2P",
    TRANSACTION_CONTEXT_ONRAMP = "TRANSACTION_CONTEXT_ONRAMP",
    TRANSACTION_CONTEXT_OFFRAMP = "TRANSACTION_CONTEXT_OFFRAMP",
    TRANSACTION_CONTEXT_FIAT_TO_FIAT = "TRANSACTION_CONTEXT_FIAT_TO_FIAT",
    TRANSACTION_CONTEXT_TELEPORT = "TRANSACTION_CONTEXT_TELEPORT",
    TRANSACTION_CONTEXT_SAVINGS_DEPOSIT = "TRANSACTION_CONTEXT_SAVINGS_DEPOSIT",
    TRANSACTION_CONTEXT_SAVINGS_WITHDRAW = "TRANSACTION_CONTEXT_SAVINGS_WITHDRAW",
    TRANSACTION_CONTEXT_STOCK_BUY = "TRANSACTION_CONTEXT_STOCK_BUY",
    TRANSACTION_CONTEXT_STOCK_SELL = "TRANSACTION_CONTEXT_STOCK_SELL",
    TRANSACTION_CONTEXT_JOINT_ACCOUNT_DEPOSIT = "TRANSACTION_CONTEXT_JOINT_ACCOUNT_DEPOSIT",
    TRANSACTION_CONTEXT_JOINT_ACCOUNT_WITHDRAW = "TRANSACTION_CONTEXT_JOINT_ACCOUNT_WITHDRAW",
    TRANSACTION_CONTEXT_REFUND = "TRANSACTION_CONTEXT_REFUND",
    TRANSACTION_CONTEXT_PIX_PAYMENT = "TRANSACTION_CONTEXT_PIX_PAYMENT",
    TRANSACTION_CONTEXT_PIX_RECEIVE = "TRANSACTION_CONTEXT_PIX_RECEIVE",
    TRANSACTION_CONTEXT_PIX_BOLETO = "TRANSACTION_CONTEXT_PIX_BOLETO",
    TRANSACTION_CONTEXT_REWARD_REDEMPTION = "TRANSACTION_CONTEXT_REWARD_REDEMPTION",
    TRANSACTION_CONTEXT_CHAIN_TRANSFER = "TRANSACTION_CONTEXT_CHAIN_TRANSFER"
}
export enum Transaction_State {
    TRANSACTION_STATUS_PENDING = "TRANSACTION_STATUS_PENDING",
    TRANSACTION_STATUS_CONFIRMED = "TRANSACTION_STATUS_CONFIRMED",
    TRANSACTION_STATUS_FAILED = "TRANSACTION_STATUS_FAILED"
}
